'use strict';

var React = require('react');
var classNames = require('classnames');
var reactResponsive = require('react-responsive');
var react = require('@storyblok/react');
var htmlparser2 = require('htmlparser2');
var cssSelect = require('css-select');
var domutils = require('domutils');
var domhandler = require('domhandler');
var domSerializer = require('dom-serializer');
var reactUse = require('react-use');
var button = require('@react-aria/button');
var cloneDeep = require('clone-deep');
var ReactDOMServer = require('react-dom/server');
var makeSlug = require('slugify');
var interactions = require('@react-aria/interactions');
var Modal = require('react-modal');
var rxjs = require('rxjs');
var ajax = require('rxjs/ajax');
var operators = require('rxjs/operators');
var isEqual = require('lodash.isequal');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

function _interopNamespaceCompat(e) {
    if (e && typeof e === 'object' && 'default' in e) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceCompat(React);
var classNames__default = /*#__PURE__*/_interopDefaultCompat(classNames);
var cloneDeep__default = /*#__PURE__*/_interopDefaultCompat(cloneDeep);
var ReactDOMServer__default = /*#__PURE__*/_interopDefaultCompat(ReactDOMServer);
var makeSlug__default = /*#__PURE__*/_interopDefaultCompat(makeSlug);
var Modal__default = /*#__PURE__*/_interopDefaultCompat(Modal);
var isEqual__default = /*#__PURE__*/_interopDefaultCompat(isEqual);

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */


var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var initialValue = {
    provider: 'default',
    components: {},
    hooks: {
        useRouter: function () { return ''; }
    },
    internalLinks: {},
    lang: 'gb',
    localeCode: '',
    storyUuid: '',
    pricing: {
        getPrice: function () { return ''; }
    }
};
var SiteComponentContext = React.createContext(initialValue);
var Provider = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var value = __assign(__assign({}, initialValue), props);
    return (React__namespace.default.createElement(SiteComponentContext.Provider, { value: value }, children));
};

var BasicImage = function (_a) {
    _a.maxWidth; // eslint-disable-line @typescript-eslint/no-unused-vars
    _a.fillColor; // eslint-disable-line @typescript-eslint/no-unused-vars
    _a.resizeProps; // eslint-disable-line @typescript-eslint/no-unused-vars
    var props = __rest(_a, ["maxWidth", "fillColor", "resizeProps"]);
    return React__namespace.default.createElement("img", __assign({ alt: "" }, props));
};

var ioOptions = {
    threshold: 0.01,
    rootMargin: '50%'
};
var useIntersectionObserver = function (ref, isDisabled) {
    if (isDisabled === void 0) { isDisabled = false; }
    var _a = React.useState(isDisabled), isVisible = _a[0], setIsVisible = _a[1];
    var _b = React.useState(isDisabled), shouldReveal = _b[0], setShouldReveal = _b[1];
    React.useEffect(function () {
        var observer;
        var node = ref.current;
        if (node) {
            if ('IntersectionObserver' in window) {
                observer = new IntersectionObserver(function (entries) {
                    entries.forEach(function (entry) {
                        if (entry.intersectionRatio > 0 || entry.isIntersecting) {
                            setIsVisible(true);
                        }
                    });
                }, ioOptions);
                observer.observe(node);
            }
            else {
                setIsVisible(true);
            }
        }
        return function () {
            if (observer && observer.unobserve) {
                observer.unobserve(node);
            }
        };
    }, [ref, setIsVisible]);
    return {
        isVisible: isVisible,
        shouldReveal: shouldReveal,
        setIsVisible: setIsVisible,
        setShouldReveal: setShouldReveal
    };
};

var checkImage = function (asset) {
    return asset &&
        typeof asset.image === 'string' &&
        asset.image.length > 0;
};
var generateSrcSetString = function (imageSet) {
    return imageSet
        .map(function (item) {
        var _a = item.split(','), src = _a[0], width = _a[1];
        return "".concat(src, " ").concat(width, "w");
    })
        .join(', \n');
};
var getLargestTransformedImage = function (imageSet) {
    var lastImage = imageSet[imageSet.length - 1];
    return lastImage.split(',')[0];
};
var getImageFormat = function (imgPath) {
    var imgFormat = imgPath.match(/\.(\w+)$/);
    return imgFormat ? imgFormat[1].toLowerCase() : '';
};
var createReferenceImage = function (onLoad, imageSet) {
    var img = new Image();
    img.onload = function () { return onLoad(); };
    img.src = getLargestTransformedImage(imageSet);
    img.srcset = generateSrcSetString(imageSet);
};
var getPossibleMaxWidth = function (isFluidImage, maxWidth) {
    if (maxWidth) {
        return maxWidth;
    }
    if (isFluidImage) {
        return 3840;
    }
    else {
        return 1440;
    }
};
var generateBgClassName = function (imgPath) {
    var part = imgPath.split('.')[0].split('/').join('-');
    return "img-background-".concat(part);
};
var getInitialBackgroundStyles = function (className, base64, fillColor) {
    return "\n    .".concat(className, " .before,\n    .").concat(className, " .after {\n      display: block;\n      position: absolute;\n      width: 100%;\n      height: 100%;\n      top: 0;\n      left: 0;\n      transition: opacity 500ms ease-in-out;\n      background-position: center;\n      background-repeat: no-repeat;\n      background-size: cover;\n      z-index: -100;\n    }\n\n    .").concat(className, " {\n      position: relative;\n      overflow: hidden;\n    }\n\n    .").concat(className, " .before {\n      background-image: url(").concat(base64 ? base64 : '', ");\n      background-color: ").concat(fillColor ? fillColor : 'transparent', ";\n    }\n\n    .").concat(className, " .after {\n      opacity: 0;\n    }\n  ");
};
var getResponsiveBackgroundStyles = function (imageSet, className) {
    var mediaQueryStyles = imageSet.reverse().map(function (item) {
        var _a = item.split(','), src = _a[0], width = _a[1];
        return "\n    @media (max-width: ".concat(width, "px) {\n      .").concat(className, " .after {\n        background-image: url(\"").concat(src, "\");\n      }\n    }");
    });
    return "\n    .".concat(className, " .after {\n      background-image: url(\"").concat(imageSet[0].split(',')[0], "\");\n      transition: opacity 500ms ease-in-out;\n      opacity: 1;\n    }\n    ").concat(mediaQueryStyles, "\n  ");
};

var imageScales = [360, 440, 800, 1024, 1440, 1920, 2560, 3840];
var getScales = function (width, maxWidth) {
    var maxScaleWidth = getMaxScaleWidth(width, maxWidth);
    var allScales = imageScales.includes(maxWidth)
        ? imageScales
        : __spreadArray(__spreadArray([], imageScales, true), [maxWidth], false);
    var scales = allScales.filter(function (size) { return size <= maxScaleWidth; });
    scales.length === 0 && scales.push(maxScaleWidth);
    return scales;
};
var getMaxScaleWidth = function (originalWidth, maxWidth) {
    return maxWidth > originalWidth ? originalWidth : maxWidth;
};

var matchStoryblokAssetOrigin = function (url) {
    var origin = url.match(/(https?:|)\/\/a\.storyblok\.com\//g);
    return origin ? origin : '';
};
var matchStoryblokImageServiceOrigin = function (url) {
    var origin = url.match(/(https?:|)\/\/img2\.storyblok\.com\//g);
    return origin ? origin : '';
};
var getOriginalImageDimensions = function (imagePath) {
    var matcher = imagePath.match(/f\/\d+\/([0-9]+x[0-9]+)/i) || [];
    if (typeof matcher[1] === 'undefined') {
        return {
            width: 0,
            height: 0
        };
    }
    var imgDimensions = matcher[1];
    var dimensions = imgDimensions.split('x');
    var width = Number(dimensions[0]);
    var height = Number(dimensions[1]);
    return { width: width, height: height };
};
var getStoryblokImagePath = function (url) {
    return url.replace(matchStoryblokAssetOrigin(url)[0], '');
};
var getBasicImageProps = function (src) {
    var imgPath = getStoryblokImagePath(src);
    var imgFormat = getImageFormat(imgPath);
    var _a = getOriginalImageDimensions(imgPath), width = _a.width, height = _a.height;
    var aspectRatio = width / height;
    return {
        imgPath: imgPath,
        imgFormat: imgFormat,
        dimensions: {
            width: width,
            height: height,
            aspectRatio: aspectRatio
        }
    };
};
var generateUrl = function (imgPath, props) {
    var imageService = 'https://img2.storyblok.com';
    var quality = props.quality ? props.quality : 93;
    var focal = props.focal ? ":focal(".concat(props.focal, ")") : '';
    var resize = props.resize;
    var imageSize = resize ? resize : "".concat(props.width, "x").concat(props.height);
    var smart = resize ? '' : 'smart/';
    if (props.imgFormat === 'webp') {
        return "".concat(imageService, "/").concat(imageSize, "/").concat(smart, "filters:format(webp):quality(").concat(quality, ")").concat(focal, "/").concat(imgPath);
    }
    return "".concat(imageService, "/").concat(imageSize, "/").concat(smart, "filters:quality(").concat(quality, ")").concat(focal, "/").concat(imgPath);
};
var getFixedImageProps = function (src, maxWidth, quality, focal, resize) {
    var basicImgProps = getBasicImageProps(src);
    var imgPath = basicImgProps.imgPath, imgFormat = basicImgProps.imgFormat, dimensions = basicImgProps.dimensions;
    var aspectRatio = dimensions.aspectRatio, width = dimensions.width;
    var scales = getScales(width, maxWidth);
    var srcSet = { base: [], webp: [] };
    scales.forEach(function (currentWidth) {
        var props = {
            width: currentWidth,
            height: Math.round(currentWidth / aspectRatio),
            quality: quality,
            focal: focal,
            resize: resize,
            imgFormat: imgFormat
        };
        var baseUrl = "".concat(generateUrl(imgPath, __assign({}, props)), ",").concat(currentWidth);
        var webpUrl = "".concat(generateUrl(imgPath, __assign(__assign({}, props), { imgFormat: 'webp' })), ",").concat(currentWidth);
        srcSet.webp.push(webpUrl);
        srcSet.base.push(baseUrl);
    });
    return __assign(__assign({}, basicImgProps), { srcSet: srcSet });
};
var isStoryblokAssetImage = function (url) {
    return !!matchStoryblokAssetOrigin(url);
};
var isStoryblokImageServiceImage = function (url) {
    return !!matchStoryblokImageServiceOrigin(url);
};
var convertUrl = function (url, props) {
    var imagePath = getStoryblokImagePath(url);
    if (isStoryblokImageServiceImage(url)) {
        return url;
    }
    if (isStoryblokAssetImage(url) && getImageFormat(imagePath) !== 'svg') {
        return generateUrl(imagePath, props);
    }
    return url;
};

var generateImageSources = function (imageVariants, isWebp) {
    var imageSources = imageVariants.map(function (variant) {
        var _a = variant.split(','), srcSet = _a[0], width = _a[1];
        var media = "(max-width: ".concat(width, "px)");
        return (React__namespace.default.createElement("source", { type: isWebp ? 'image/webp' : '', key: variant, media: media, srcSet: srcSet }));
    });
    if (isWebp) {
        var lastVariant = imageVariants[imageVariants.length - 1];
        var srcSet = lastVariant.split(',')[0];
        imageSources.push(React__namespace.default.createElement("source", { type: "image/webp", key: srcSet, srcSet: srcSet }));
    }
    return imageSources;
};
var wrapperStyles = {
    position: 'relative',
    overflow: 'hidden'
};
var imageStyles = function (cropAlignment) { return ({
    position: 'absolute',
    objectFit: 'cover',
    objectPosition: cropAlignment || 'unset',
    width: '100%',
    height: '100%',
    left: '0',
    top: '0',
    transition: 'opacity 500ms'
}); };
var base64ImageStyles = __assign(__assign({}, imageStyles()), { transition: 'opacity 0s 500ms' });
var bgTagBaseStyles = {
    width: '100%',
    transitionDelay: '500ms'
};
var AdvanceImage = function (_a) {
    var src = _a.src, alt_tag = _a.alt_tag, className = _a.className, _b = _a.type, type = _b === void 0 ? 'fixed' : _b, maxWidth = _a.maxWidth, quality = _a.quality, base64 = _a.base64, fillColor = _a.fillColor, loading = _a.loading, resizeProps = _a.resizeProps, isStatic = _a.isStatic, rest = __rest(_a, ["src", "alt_tag", "className", "type", "maxWidth", "quality", "base64", "fillColor", "loading", "resizeProps", "isStatic"]);
    var isFluidImage = type === 'fluid';
    var isCritical = loading === 'eager';
    var bgFillColor = fillColor ? fillColor : 'rgba(0,0,0, 0.05)';
    var possibleMaxWidth = getPossibleMaxWidth(isFluidImage, Number(maxWidth));
    var _c = React.useState(''), base64Hydration = _c[0], setBase64Hydration = _c[1];
    var imageProps = getFixedImageProps(src, possibleMaxWidth, Number(quality), resizeProps === null || resizeProps === void 0 ? void 0 : resizeProps.focal, resizeProps === null || resizeProps === void 0 ? void 0 : resizeProps.resize);
    var _d = imageProps.srcSet, webp = _d.webp, base = _d.base;
    var imageRef = React.useRef(null);
    var _e = useIntersectionObserver(imageRef, isStatic), isVisible = _e.isVisible, setIsVisible = _e.setIsVisible, shouldReveal = _e.shouldReveal, setShouldReveal = _e.setShouldReveal;
    if (isCritical) {
        setIsVisible(true);
    }
    var handleImageLoad = function () {
        setShouldReveal(true);
    };
    React.useEffect(function () {
        setBase64Hydration(base64 || '');
    }, [base64, setBase64Hydration]);
    return (React__namespace.default.createElement("div", { className: className, key: src, style: wrapperStyles, ref: imageRef },
        React__namespace.default.createElement("div", { style: __assign(__assign({}, bgTagBaseStyles), { paddingBottom: "".concat(100 /
                    ((resizeProps === null || resizeProps === void 0 ? void 0 : resizeProps.cropAspectRatio) || imageProps.dimensions.aspectRatio), "%"), backgroundColor: fillColor ? bgFillColor : 'transparent', opacity: shouldReveal ? 0 : 1 }) }),
        base64Hydration && (React__namespace.default.createElement(BasicImage, __assign({}, rest, { src: base64Hydration, alt: alt_tag, className: className, style: __assign(__assign({}, base64ImageStyles), { opacity: !shouldReveal ? 1 : 0 }) }))),
        isVisible && (React__namespace.default.createElement("picture", null,
            webp && generateImageSources(webp, true),
            base && generateImageSources(base, false),
            React__namespace.default.createElement(BasicImage, __assign({ src: getLargestTransformedImage(base), alt: alt_tag, loading: loading ? loading : 'lazy', onLoad: handleImageLoad, style: __assign(__assign({}, imageStyles(resizeProps === null || resizeProps === void 0 ? void 0 : resizeProps.cropAlignment)), { opacity: shouldReveal ? 1 : 0 }) }, rest))))));
};

var ImgBackground = function (_a) {
    var children = _a.children, src = _a.src, _b = _a.tag, tag = _b === void 0 ? 'div' : _b, _c = _a.type, type = _c === void 0 ? 'fixed' : _c, style = _a.style, className = _a.className, maxWidth = _a.maxWidth, quality = _a.quality, base64 = _a.base64, fillColor = _a.fillColor, loading = _a.loading;
    var isFluidImage = type === 'fluid';
    var isCritical = loading === 'eager';
    var possibleMaxWidth = getPossibleMaxWidth(isFluidImage, Number(maxWidth));
    var imageProps = getFixedImageProps(src, possibleMaxWidth, Number(quality));
    var bgClassName = generateBgClassName(imageProps.imgPath);
    var wrapperRef = React.useRef(null);
    var _d = useIntersectionObserver(wrapperRef), isVisible = _d.isVisible, setIsVisible = _d.setIsVisible, shouldReveal = _d.shouldReveal, setShouldReveal = _d.setShouldReveal;
    if (isCritical) {
        setIsVisible(true);
    }
    var onImageLoad = function () {
        setShouldReveal(true);
    };
    React.useEffect(function () {
        if (isVisible) {
            createReferenceImage(onImageLoad, imageProps.srcSet.base);
        }
    }, [isVisible]);
    // skip JSX to avoid ts errors with ElementType with refs
    // To be able to have JSX again, there might be less conflicts in later
    // versions of react, typescript, ts-jest and their type definitions.
    return React__namespace.default.createElement(tag, {
        className: classNames__default.default(className, bgClassName),
        key: src,
        style: style,
        ref: wrapperRef
    }, React__namespace.default.createElement(React__namespace.default.Fragment, null,
        React__namespace.default.createElement("div", { className: "before" }),
        React__namespace.default.createElement("style", null,
            getInitialBackgroundStyles(bgClassName, base64, fillColor),
            shouldReveal &&
                getResponsiveBackgroundStyles(imageProps.srcSet.base, bgClassName)),
        children,
        React__namespace.default.createElement("div", { className: "after" })));
};

var Img = function (_a) {
    var src = _a.src; 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _a._uid; var rest = __rest(_a, ["src", "_uid"]);
    if (!src) {
        return null;
    }
    var isStoryblokImage = src.match(/(a|img2).storyblok.com/);
    var isSvgImage = getImageFormat(src) === 'svg';
    if (isStoryblokImage && !isSvgImage) {
        return React__namespace.default.createElement(AdvanceImage, __assign({ src: src }, rest));
    }
    return React__namespace.default.createElement(BasicImage, __assign({ src: src }, rest));
};

var Image$1 = function (_a) {
    var asset = _a.asset;
    var image = asset.image, rest = __rest(asset, ["image"]);
    return (React__namespace.default.createElement("section", { style: { width: '100%' } },
        React__namespace.default.createElement(Img, __assign({ src: image }, rest))));
};

// filters:focal(<left>x<top>:<right>x<bottom>)
var deriveFocal = function (_a) {
    var alignment = _a.alignment, imgPath = _a.imgPath, _b = _a.targetWidth, targetWidth = _b === void 0 ? 0 : _b, _c = _a.targetHeight, targetHeight = _c === void 0 ? 0 : _c;
    var left, top, right, bottom;
    var _d = getOriginalImageDimensions(imgPath), originalWidth = _d.width, originalHeight = _d.height;
    if (originalWidth < targetWidth ||
        originalHeight < targetHeight ||
        !alignment ||
        targetWidth <= 0 ||
        targetHeight <= 0) {
        return '';
    }
    switch (alignment) {
        case 'top':
        case 'bottom':
            left = originalWidth / 2 - targetWidth / 2;
            left = targetWidth === 0 ? originalWidth : left;
            right = left + targetWidth;
            top = alignment === 'top' ? 0 : originalHeight - targetHeight;
            bottom = alignment === 'bottom' ? originalHeight : top + targetHeight;
            break;
        case 'left':
        case 'right':
            top = originalHeight / 2 - targetHeight / 2;
            bottom = top + targetHeight;
            left = alignment === 'left' ? 0 : originalWidth - targetWidth;
            right = alignment === 'right' ? originalWidth : left + targetWidth;
            break;
        case 'center':
        default:
            left = originalWidth / 2 - targetWidth / 2;
            right = left + targetWidth;
            top = originalHeight / 2 - targetHeight / 2;
            bottom = top + targetHeight;
            break;
    }
    return (Math.floor(left) +
        'x' +
        Math.floor(top) +
        ':' +
        Math.floor(right) +
        'x' +
        Math.floor(bottom));
};

var getTargetRatio = function (targetAspectRatio) {
    var _a = targetAspectRatio.split(':'), numerator = _a[0], denominator = _a[1];
    return Number(numerator) / Number(denominator);
};
var getFormatFlags = function (originalDimensions, targetRatio) {
    var originalRatio = originalDimensions.width / originalDimensions.height;
    var originIsLandscape = originalRatio > 1;
    var originIsPortrait = originalRatio < 1;
    var targetIsLandscape = targetRatio > 1;
    var targetIsPortrait = targetRatio < 1;
    var targetIsSquare = targetRatio === 1;
    var targetIsSameOrientation = (targetIsLandscape && originIsLandscape) ||
        (targetIsPortrait && originIsPortrait);
    var targetIsThinner = (targetIsLandscape && targetRatio > originalRatio) ||
        (targetIsPortrait && targetRatio < originalRatio);
    return {
        originIsLandscape: originIsLandscape,
        originIsPortrait: originIsPortrait,
        targetIsLandscape: targetIsLandscape,
        targetIsPortrait: targetIsPortrait,
        targetIsSquare: targetIsSquare,
        targetIsSameOrientation: targetIsSameOrientation,
        targetIsThinner: targetIsThinner
    };
};
var getCropTargetDimensions = function (imgPath, targetAspectRatio) {
    var originalDimensions = getOriginalImageDimensions(imgPath);
    var originalWidth = originalDimensions.width, originalHeight = originalDimensions.height;
    var originalRatio = originalWidth / originalHeight;
    var targetRatio = targetAspectRatio
        ? getTargetRatio(targetAspectRatio)
        : originalRatio;
    var _a = getFormatFlags(originalDimensions, targetRatio), targetIsLandscape = _a.targetIsLandscape, targetIsPortrait = _a.targetIsPortrait, targetIsSquare = _a.targetIsSquare, targetIsThinner = _a.targetIsThinner;
    if ((targetIsLandscape && targetIsThinner) ||
        (targetIsPortrait && !targetIsThinner)) {
        return {
            targetWidth: originalWidth,
            targetHeight: originalWidth / targetRatio
        };
    }
    if ((targetIsLandscape && !targetIsThinner) ||
        (targetIsPortrait && targetIsThinner)) {
        return {
            targetWidth: originalHeight * targetRatio,
            targetHeight: originalHeight
        };
    }
    if (targetIsSquare) {
        return {
            targetWidth: originalRatio > 1 ? originalHeight : originalWidth,
            targetHeight: originalRatio > 1 ? originalHeight : originalWidth
        };
    }
    return { targetWidth: originalWidth, targetHeight: originalHeight };
};

var getOneDimensionResize = function (_a) {
    var targetDimensions = _a.targetDimensions, originalDimensions = _a.originalDimensions, _b = _a.targetScale, targetScale = _b === void 0 ? 100 : _b;
    var targetWidth = targetDimensions.targetWidth, targetHeight = targetDimensions.targetHeight;
    var originalWidth = originalDimensions.width, originalHeight = originalDimensions.height;
    var targetRatio = targetWidth / targetHeight;
    var _c = getFormatFlags(originalDimensions, targetRatio), originIsPortrait = _c.originIsPortrait, targetIsLandscape = _c.targetIsLandscape, targetIsSquare = _c.targetIsSquare, targetIsSameOrientation = _c.targetIsSameOrientation, targetIsThinner = _c.targetIsThinner;
    if (targetIsSameOrientation && !targetIsThinner) {
        return targetIsLandscape
            ? "".concat(Math.floor(targetWidth), "x").concat(Math.floor(originalHeight * targetScale))
            : "".concat(Math.floor(originalWidth * targetScale), "x").concat(Math.floor(targetHeight));
    }
    if (targetIsSquare && originIsPortrait) {
        return "".concat(Math.floor(originalWidth * targetScale), "x").concat(Math.floor(targetHeight));
    }
    return targetWidth > targetHeight
        ? "".concat(Math.floor(originalWidth * targetScale), "x").concat(Math.floor(targetHeight))
        : "".concat(Math.floor(targetWidth), "x").concat(Math.floor(originalHeight * targetScale));
};

var breakpoints = {
    xs: 0,
    sm: 400,
    m1: 600,
    m2: 1024,
    lg: 1440,
    xl: 1920
};
var constructQuery = function (_a) {
    var minBreakpoint = _a.minBreakpoint, maxBreakpoint = _a.maxBreakpoint;
    var query = [];
    var minPx = minBreakpoint && minBreakpoint in breakpoints
        ? breakpoints[minBreakpoint]
        : 0;
    var maxPx = maxBreakpoint && maxBreakpoint in breakpoints
        ? breakpoints[maxBreakpoint]
        : 0;
    if (minPx > 0) {
        query.push("(min-width: ".concat(minPx, "px)"));
    }
    if (maxPx > 0) {
        query.push("(max-width: ".concat(maxPx, "px)"));
    }
    if ((minPx > 0 && maxPx > 0 && minPx >= maxPx) || query.length === 0) {
        return 'all';
    }
    return query.join(' and ');
};
var validateBreakpointCollection = function (list) {
    if (list.find(function (_a, i) {
        var _b = _a.minBreakpoint, min = _b === void 0 ? 'xs' : _b, _c = _a.maxBreakpoint, max = _c === void 0 ? '' : _c;
        return __spreadArray(__spreadArray([], list.slice(i + 1), true), list.slice(0, i), true).find(function (_a) {
            var _b = _a.minBreakpoint, min2 = _b === void 0 ? 'xs' : _b;
            return ((breakpoints[min] || 0) <= (breakpoints[min2] || 0) &&
                (breakpoints[max] || Infinity) > (breakpoints[min2] || 0));
        });
    })) {
        return React__namespace.default.createElement("div", null, errorSvgs['overlap']);
    }
    var screenSizeCoverage = Array.from(list.reduce(function (acc, _a) {
        var _b = _a.minBreakpoint, minBreakpoint = _b === void 0 ? 'xs' : _b, _c = _a.maxBreakpoint, maxBreakpoint = _c === void 0 ? '' : _c;
        var nextMin = breakpoints[minBreakpoint] || 0, nextMax = breakpoints[maxBreakpoint] || Infinity;
        for (var _i = 0, _d = Object.entries(breakpoints); _i < _d.length; _i++) {
            var _e = _d[_i], label = _e[0], breakpoint = _e[1];
            if (breakpoint >= nextMin && breakpoint < nextMax)
                acc.add(label);
        }
        return acc;
    }, new Set()));
    if (screenSizeCoverage.length < 6) {
        return React__namespace.default.createElement("div", null, errorSvgs['disparate']);
    }
    return undefined;
};
var errorSvgs = {
    overlap: (React__namespace.default.createElement("svg", { key: "overlap", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16" },
        React__namespace.default.createElement("path", { fill: "gray", d: "M0 0h10v10H0z" }),
        React__namespace.default.createElement("path", { fill: "#bfbfbf", d: "M5 5h11v11H5z" }),
        React__namespace.default.createElement("path", { fill: "#e70000", d: "M5 5h5v5H5z" }),
        React__namespace.default.createElement("text", { transform: "translate(3, 0) rotate(15)", style: { font: 'italic 1px sans-serif' } },
            React__namespace.default.createElement("tspan", { x: "0", dy: "1px" }, "Responsive error:"),
            React__namespace.default.createElement("tspan", { x: "0", dy: "1px" }, "Can't have one min-max"),
            React__namespace.default.createElement("tspan", { x: "0", dy: "1px" }, "within another min-max."),
            React__namespace.default.createElement("tspan", { x: "0", dy: "1px" }, "Check you settings")))),
    disparate: (React__namespace.default.createElement("svg", { key: "disparate", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16" },
        React__namespace.default.createElement("path", { fill: "#e70000", d: "M0 0h16v16H0z" }),
        React__namespace.default.createElement("path", { fill: "gray", d: "M0 0h9v9H0z" }),
        React__namespace.default.createElement("path", { fill: "#bfbfbf", d: "M11 11h5v5h-5z" }),
        React__namespace.default.createElement("text", { transform: "translate(3, 0) rotate(40)", style: { font: 'italic 1px sans-serif' } },
            React__namespace.default.createElement("tspan", { x: "0", dy: "1px" }, "Responsive error:"),
            React__namespace.default.createElement("tspan", { x: "0", dy: "1px" }, "Not every screen size is covered for."),
            React__namespace.default.createElement("tspan", { x: "0", dy: "1px" }, "Check you settings"))))
};

var ImgResized = function (_a) {
    var _b = _a.cropAlignment, cropAlignment = _b === void 0 ? 'center' : _b, _c = _a.cropAspectRatio, cropAspectRatio = _c === void 0 ? '4:3' : _c, _d = _a.cropScaling, cropScaling = _d === void 0 ? '100' : _d, asset = _a.asset, minBreakpoint = _a.minBreakpoint, maxBreakpoint = _a.maxBreakpoint;
    var query = constructQuery({ minBreakpoint: minBreakpoint, maxBreakpoint: maxBreakpoint });
    var show = reactResponsive.useMediaQuery({ query: query });
    if (!checkImage(asset) || !show)
        return null;
    var _e = getBasicImageProps(asset.image), imgPath = _e.imgPath, originalDimensions = _e.dimensions;
    var targetDimensions = getCropTargetDimensions(imgPath, cropAspectRatio);
    var targetScale = Number(cropScaling) >= 100 ? Number(cropScaling) / 100 : 1;
    var resize = getOneDimensionResize({
        targetDimensions: targetDimensions,
        originalDimensions: originalDimensions,
        targetScale: targetScale
    });
    var focal = deriveFocal(__assign({ alignment: cropAlignment || 'center', imgPath: imgPath }, targetDimensions));
    var resizeProps = {
        resize: resize,
        focal: focal,
        cropAlignment: cropAlignment,
        cropScaling: targetScale,
        cropAspectRatio: getTargetRatio(cropAspectRatio)
    };
    // The src as it should be generated by AdvanceImage:
    // `${imageService}/${resize}/filters:focal(${focal}):quality(${quality})/${imgPath}`
    return React__namespace.default.createElement(Img, __assign({}, asset, { src: asset.image, resizeProps: resizeProps }));
};

var Row = function (_a) {
    var _b;
    var _c = _a.align, align = _c === void 0 ? 'top' : _c, _d = _a.justify, justify = _d === void 0 ? 'start' : _d, children = _a.children, className = _a.className;
    var classes = classNames__default.default('row', (_b = {},
        _b["row-".concat(justify)] = justify,
        _b["row-".concat(align)] = align,
        _b), className);
    return React__namespace.default.createElement("div", { className: classes }, children);
};

var createSizeClasses = function (size, columnConfig) {
    var _a;
    if (!columnConfig) {
        return {};
    }
    var sizeConfig = {};
    if (typeof columnConfig === 'number') {
        sizeConfig.span = columnConfig;
    }
    else if (typeof columnConfig === 'object') {
        sizeConfig = columnConfig || {};
    }
    return _a = {},
        _a["col-".concat(size, "-").concat(sizeConfig.span)] = typeof sizeConfig.span !== 'undefined',
        _a["col-".concat(size, "-offset-").concat(sizeConfig.offset)] = sizeConfig.offset || sizeConfig.offset === 0,
        _a["col-".concat(size, "-order-").concat(sizeConfig.order)] = sizeConfig.order || sizeConfig.order === 0,
        _a;
};
var Col = function (props) {
    var _a;
    var span = props.span, offset = props.offset, order = props.order, className = props.className, xs = props.xs, sm = props.sm, md = props.md, ml = props.ml, lg = props.lg, xl = props.xl, children = props.children;
    var sizeClasses = {};
    sizeClasses = __assign(__assign({}, sizeClasses), createSizeClasses('xs', xs));
    sizeClasses = __assign(__assign({}, sizeClasses), createSizeClasses('sm', sm));
    sizeClasses = __assign(__assign({}, sizeClasses), createSizeClasses('md', md));
    sizeClasses = __assign(__assign({}, sizeClasses), createSizeClasses('ml', ml));
    sizeClasses = __assign(__assign({}, sizeClasses), createSizeClasses('lg', lg));
    sizeClasses = __assign(__assign({}, sizeClasses), createSizeClasses('xl', xl));
    var classes = classNames__default.default('col', (_a = {},
        _a["col-".concat(span)] = span !== undefined,
        _a["col-offset-".concat(offset)] = offset,
        _a["col-order-".concat(order)] = order,
        _a), className, sizeClasses);
    return React__namespace.default.createElement("div", { className: classes }, children);
};

var css$13 = {"section-text-left":"styles_section-text-left__b96z7","section-text-center":"styles_section-text-center__tfSfa","section-text-right":"styles_section-text-right__dZYU9"};

var ConditionalWrapper = function (_a) {
    var condition = _a.condition, wrapper = _a.wrapper, children = _a.children;
    return React__namespace.default.createElement(React__namespace.default.Fragment, null, condition ? wrapper(children) : children);
};

var gridProfiles$1 = {
    'content-50': {
        ml: {
            span: 6,
            offset: 3
        }
    },
    'content-66': {
        ml: {
            span: 8,
            offset: 2
        }
    },
    'content-66-left-align': {
        ml: {
            span: 8,
            offset: 1
        }
    },
    'md-75-ml-66-lg-50': {
        md: {
            span: 6,
            offset: 1
        },
        ml: {
            span: 8,
            offset: 2
        },
        lg: {
            span: 6,
            offset: 3
        }
    },
    'md-75-ml-100': {
        md: {
            span: 6,
            offset: 1
        },
        ml: {
            span: 12,
            offset: 0
        }
    },
    'w-narrow': {
        ml: {
            span: 6,
            offset: 3
        },
        lg: {
            span: 8,
            offset: 2
        }
    }
};

/*
  Use the "span" property to set the width, specified in number of grid columns.
  The value will be set for the specified breakpoint and all above, if not specified.
  Content is centered by default, to offset it use the "fromLeft" property.
  Grid margin is not added by default, to add it set the "gridMargin" property to true.
*/
// double profiles for renaming purposes
var gridProfiles = {
    'full-width-no-margins': {},
    'full-width-with-margins': {
        xs: {
            gridMargin: true
        },
        sm: {
            gridMargin: true
        },
        m1: {
            gridMargin: true
        },
        m2: {
            gridMargin: true
        },
        lg: {
            gridMargin: true
        }
    },
    'm1-10-m2-8-lg-6': {
        m1: {
            span: 10
        },
        m2: {
            span: 8
        },
        lg: {
            span: 6
        }
    },
    'm2-10': {
        m2: {
            span: 10
        }
    },
    's-margin-m2-10': {
        xs: {
            gridMargin: true
        },
        sm: {
            gridMargin: true
        },
        m1: {
            gridMargin: true
        },
        m2: {
            span: 10
        }
    },
    'm1-10-m2-8': {
        m1: {
            span: 10
        },
        m2: {
            span: 8
        }
    },
    'm2-11-left-align': {
        m2: {
            span: 11,
            gridMargin: true,
            fromLeft: 0
        },
        lg: {
            gridMargin: true,
            fromLeft: 0
        }
    },
    's-margin-m1-8': {
        xs: {
            gridMargin: true
        },
        sm: {
            gridMargin: true
        },
        m1: {
            span: 8
        }
    },
    's-margin-m1-6': {
        xs: {
            gridMargin: true
        },
        sm: {
            gridMargin: true
        },
        m1: {
            span: 6
        }
    },
    'm1-margin-m2-12': {
        m1: {
            gridMargin: true
        },
        m2: {
            span: 12
        }
    }
};

var css$12 = {"innerContainer":"styles_innerContainer__5q3so","noMaxWidth":"styles_noMaxWidth__I2QH4","content":"styles_content__F54rZ","overrideSectionPadding":"styles_overrideSectionPadding__n0zb4","xs-width-0":"styles_xs-width-0__hOrLv","xs-width-1":"styles_xs-width-1__3994G","xs-width-2":"styles_xs-width-2__F7jl3","xs-width-3":"styles_xs-width-3__Iub0-","xs-width-4":"styles_xs-width-4__A303r","xs-from-left-0":"styles_xs-from-left-0__E-jMe","xs-from-left-1":"styles_xs-from-left-1__cycR4","xs-from-left-2":"styles_xs-from-left-2__djE8D","xs-grid-margin":"styles_xs-grid-margin__yoqHs","xs-no-grid-margin":"styles_xs-no-grid-margin__dUL0d","sm-width-0":"styles_sm-width-0__7th64","sm-width-1":"styles_sm-width-1__wUYw4","sm-width-2":"styles_sm-width-2__0ncw6","sm-width-3":"styles_sm-width-3__25eCr","sm-width-4":"styles_sm-width-4__gCYyg","sm-from-left-0":"styles_sm-from-left-0__fpTJD","sm-from-left-1":"styles_sm-from-left-1__6ZVHS","sm-from-left-2":"styles_sm-from-left-2__X6c9H","sm-grid-margin":"styles_sm-grid-margin__iZyes","sm-no-grid-margin":"styles_sm-no-grid-margin__Wmg6E","m1-width-0":"styles_m1-width-0__Q05EA","m1-width-1":"styles_m1-width-1__l4Z3k","m1-width-2":"styles_m1-width-2__DFC-9","m1-width-3":"styles_m1-width-3__TBwxA","m1-width-4":"styles_m1-width-4__FMNaM","m1-width-5":"styles_m1-width-5__GiCFx","m1-width-6":"styles_m1-width-6__MPr9O","m1-width-7":"styles_m1-width-7__S8gzo","m1-width-8":"styles_m1-width-8__vzGM5","m1-width-9":"styles_m1-width-9__BFhzf","m1-width-10":"styles_m1-width-10__h4mx7","m1-width-11":"styles_m1-width-11__Lr44M","m1-width-12":"styles_m1-width-12__iyjCU","m1-from-left-0":"styles_m1-from-left-0__C3K-D","m1-from-left-1":"styles_m1-from-left-1__MMjta","m1-from-left-2":"styles_m1-from-left-2__f7t-5","m1-from-left-3":"styles_m1-from-left-3__KWtUW","m1-from-left-4":"styles_m1-from-left-4__MnkUU","m1-from-left-5":"styles_m1-from-left-5__Ncgg8","m1-from-left-6":"styles_m1-from-left-6__W9K4g","m1-grid-margin":"styles_m1-grid-margin__Mkjn9","m1-no-grid-margin":"styles_m1-no-grid-margin__IICqk","m2-width-0":"styles_m2-width-0__ry6gZ","m2-width-1":"styles_m2-width-1__N58MI","m2-width-2":"styles_m2-width-2__lWo9P","m2-width-3":"styles_m2-width-3__izVBj","m2-width-4":"styles_m2-width-4__5GuLv","m2-width-5":"styles_m2-width-5__NEEGl","m2-width-6":"styles_m2-width-6__A1jAO","m2-width-7":"styles_m2-width-7__rxwqB","m2-width-8":"styles_m2-width-8__P3wPG","m2-width-9":"styles_m2-width-9__p7kNs","m2-width-10":"styles_m2-width-10__0LKy0","m2-width-11":"styles_m2-width-11__AEBsg","m2-width-12":"styles_m2-width-12__8k-HW","m2-from-left-0":"styles_m2-from-left-0__YQssV","m2-from-left-1":"styles_m2-from-left-1__ZYrJ9","m2-from-left-2":"styles_m2-from-left-2__pQds-","m2-from-left-3":"styles_m2-from-left-3__43nVu","m2-from-left-4":"styles_m2-from-left-4__oo0qD","m2-from-left-5":"styles_m2-from-left-5__s2LRD","m2-from-left-6":"styles_m2-from-left-6__ev8Zb","m2-grid-margin":"styles_m2-grid-margin__rtPfs","m2-no-grid-margin":"styles_m2-no-grid-margin__B4spr","lg-width-0":"styles_lg-width-0__9-NCM","lg-width-1":"styles_lg-width-1__tGK14","lg-width-2":"styles_lg-width-2__KUqh8","lg-width-3":"styles_lg-width-3__Yx6PY","lg-width-4":"styles_lg-width-4__H2pey","lg-width-5":"styles_lg-width-5__N1mV8","lg-width-6":"styles_lg-width-6__fZpoM","lg-width-7":"styles_lg-width-7__P9qUm","lg-width-8":"styles_lg-width-8__xZ10R","lg-width-9":"styles_lg-width-9__Pk4Q3","lg-width-10":"styles_lg-width-10__yEZz9","lg-width-11":"styles_lg-width-11__fDR8d","lg-width-12":"styles_lg-width-12__fo-nY","lg-from-left-0":"styles_lg-from-left-0__JzBLd","lg-from-left-1":"styles_lg-from-left-1__zqRpD","lg-from-left-2":"styles_lg-from-left-2__iNxoA","lg-from-left-3":"styles_lg-from-left-3__nVgIN","lg-from-left-4":"styles_lg-from-left-4__ZFN1L","lg-from-left-5":"styles_lg-from-left-5__5IfbF","lg-from-left-6":"styles_lg-from-left-6__nVa0v","lg-grid-margin":"styles_lg-grid-margin__CkMWj","lg-no-grid-margin":"styles_lg-no-grid-margin__w8gMR","paddingTop-only-desktop":"styles_paddingTop-only-desktop__G4dgw","paddingTop-extra-small":"styles_paddingTop-extra-small__TFfC2","paddingTop-small":"styles_paddingTop-small__-BE-E","paddingTop-default":"styles_paddingTop-default__xTARp","paddingTop-large":"styles_paddingTop-large__hvNXH","paddingBottom-only-desktop":"styles_paddingBottom-only-desktop__RJvFS","paddingBottom-extra-small":"styles_paddingBottom-extra-small__dxwb4","paddingBottom-small":"styles_paddingBottom-small__KB1fh","paddingBottom-default":"styles_paddingBottom-default__cQnKM","paddingBottom-large":"styles_paddingBottom-large__U09JH"};

/* THIS FILE IS AUTOMATICALLY GENERATED */
var colors = { "default": ["color-default", "#001435ff"], "secondary": ["color-secondary", "#545d68ff"], "highlight": ["color-highlight", "#0070e0ff"], "info": ["color-info", "#003087ff"], "success": ["color-success", "#0f7013ff"], "warning": ["color-warning", "#001435ff"], "error": ["color-error", "#c40b0bff"], "inverted": ["color-inverted", "#ffffffff"], "placeholder": ["color-placeholder", "#87888E"], "action-primary": ["color-action-primary", "#FFFFFF"], "action-secondary": ["color-action-secondary", "#003087"], "action-minor": ["color-action-minor", "#141416"], "action-destructive": ["color-action-destructive", "#C40B0B"], "action-destructive-solid": ["color-action-destructive-solid", "#FFFFFF"], "action-inline": ["color-action-inline", "#003087"], "action-inline-destructive": ["color-action-inline-destructive", "#C40B0B"] };
var backgroundColors = { "default": ["bg-default", "#FFFFFF"], "grouped-primary": ["bg-grouped-primary", "#faf8f5ff"], "grouped-secondary": ["bg-grouped-secondary", "#f1ede8ff"], "highlight": ["bg-highlight", "#ffffffff"], "info": ["bg-info", "#ffffffff"], "success": ["bg-success", "#ffffffff"], "warning": ["bg-warning", "#ffffffff"], "error": ["bg-error", "#ffffffff"], "inverted": ["bg-inverted", "#001C64ff"], "placeholder": ["bg-placeholder", "#B9BABE"], "action-primary": ["bg-action-primary", "#003087"], "action-secondary": ["bg-action-secondary", "transparent"], "action-minor": ["bg-action-minor", "transparent"], "action-destructive": ["bg-action-destructive", "transparent"], "action-destructive-solid": ["bg-action-destructive-solid", "#C40B0B"], "action-inline": ["bg-action-inline", "transparent"], "action-inline-destructive": ["bg-action-inline-destructive", "transparent"] };
var borderColors$1 = { "divider": ["border-divider", "#f1ede8ff"], "success": ["border-succes", "#0f7013ff"], "warning": ["border-warning", "#ffbe4aff"], "error": ["border-error", "#c40b0bff"], "focus-form": ["border-focus-form", "#141416"], "focus": ["border-focus", "#0070E0"], "action-primary": ["border-action-primary", "#003087"], "action-secondary": ["border-action-secondary", "#003087"], "action-minor": ["border-action-minor", "#D2D3D6"], "action-destructive": ["border-action-destructive", "#C40B0B"], "action-destructive-solid": ["border-action-destructive-solid", "#C40B0B"], "action-inline": ["border-action-inline", "transparent"], "action-inline-destructive": ["border-action-inline-destructive", "transparent"], "info": ["border-info", "#003087ff"], "form": ["border-form", "#929496ff"], "interactive": ["border-interactive", "#93959A"] };

var getClass = function (map) {
    return function (key) { var _a, _b; return (_b = (_a = map[key]) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : null; };
};
var getColorClass = getClass(colors);
var getHoverColorClass = function (key) { return "color-".concat(key, "--hover"); };
var getBackgroundColorClass = getClass(backgroundColors);
var getBorderColorClass = getClass(borderColors$1);
var getColorClasses = function (key) { return ({
    color: getColorClass(key),
    background: getBackgroundColorClass(key),
    border: getBorderColorClass(key)
}); };

var getStoryblokProps = function (input) {
    return input
        ? Object.fromEntries(Object.entries(input).filter(function (_a) {
            var k = _a[0];
            return k.indexOf('data-blok') === 0;
        }))
        : {};
};

var getClasses = function (profile) {
    if (profile in gridProfiles) {
        var _a = gridProfiles[profile], xs = _a.xs, sm = _a.sm, m1 = _a.m1, m2 = _a.m2, lg = _a.lg;
        var classes = {};
        classes = createClasses('xs', xs);
        classes = __assign(__assign({}, classes), createClasses('sm', sm));
        classes = __assign(__assign({}, classes), createClasses('m1', m1));
        classes = __assign(__assign({}, classes), createClasses('m2', m2));
        classes = __assign(__assign({}, classes), createClasses('lg', lg));
        return classes;
    }
    return {};
};
var createClasses = function (size, settings) {
    var _a;
    return _a = {},
        _a[css$12["".concat(size, "-width-").concat(settings === null || settings === void 0 ? void 0 : settings.span)]] = !!(settings === null || settings === void 0 ? void 0 : settings.span),
        _a[css$12["".concat(size, "-from-left-").concat(settings === null || settings === void 0 ? void 0 : settings.fromLeft)]] = (settings === null || settings === void 0 ? void 0 : settings.fromLeft) !== undefined,
        _a[css$12["".concat(size, "-grid-margin")]] = !!(settings === null || settings === void 0 ? void 0 : settings.gridMargin),
        _a[css$12["".concat(size, "-no-grid-margin")]] = (settings === null || settings === void 0 ? void 0 : settings.gridMargin) !== true,
        _a;
};
var ContainerLayout = function (_a) {
    var _b, _c;
    var _d;
    var id = _a.id, backgroundColor = _a.backgroundColor, backgroundImage = _a.backgroundImage, gridProfile = _a.gridProfile, paddingTop = _a.paddingTop, paddingBottom = _a.paddingBottom, children = _a.children, className = _a.className, overrideSectionPadding = _a.overrideSectionPadding, _e = _a.noMaxWidth, noMaxWidth = _e === void 0 ? false : _e, _f = _a.tagName, tagName = _f === void 0 ? 'section' : _f, rest = __rest(_a, ["id", "backgroundColor", "backgroundImage", "gridProfile", "paddingTop", "paddingBottom", "children", "className", "overrideSectionPadding", "noMaxWidth", "tagName"]);
    var backgroundColorClass = (_d = getBackgroundColorClass(backgroundColor)) !== null && _d !== void 0 ? _d : backgroundColor;
    var TagName = tagName || 'section'; // avoid empty strings
    return (React__namespace.default.createElement(ConditionalWrapper, { condition: checkImage(backgroundImage), wrapper: function (children) { return (React__namespace.default.createElement(ImgBackground, { src: backgroundImage.image, base64: backgroundImage.base64, quality: 90, loading: "lazy", tag: "section", className: className }, children)); } },
        React__namespace.default.createElement(TagName, __assign({ id: (id === null || id === void 0 ? void 0 : id.length) > 0 ? id : undefined, className: classNames__default.default([backgroundColorClass], (_b = {},
                _b[css$12["paddingTop-".concat(paddingTop)]] = paddingTop !== 'none',
                _b[css$12["paddingBottom-".concat(paddingBottom)]] = paddingBottom !== 'none',
                _b["".concat(className)] = !checkImage(backgroundImage),
                _b[css$12.overrideSectionPadding] = overrideSectionPadding,
                _b)), "data-testid": "container-layout" }, getStoryblokProps(rest)),
            React__namespace.default.createElement("div", { className: classNames__default.default(css$12.innerContainer, (_c = {},
                    _c[css$12.noMaxWidth] = noMaxWidth,
                    _c)) },
                React__namespace.default.createElement("div", { className: classNames__default.default(css$12.content, __assign({}, getClasses(gridProfile))) }, children)))));
};

var SectionLayout = function (_a) {
    var component = _a.component, props = __rest(_a, ["component"]);
    if (component === 'container-layout') {
        return React__namespace.default.createElement(ContainerLayout, __assign({}, props));
    }
    return React__namespace.default.createElement(SectionLayoutLegacy, __assign({}, props));
};
var SectionLayoutLegacy = function (_a) {
    var _b, _c;
    var disableWrapperClass = _a.disableWrapperClass, _d = _a.gridProfile, gridProfile = _d === void 0 ? '' : _d, disableMaximumWidth = _a.disableMaximumWidth, textAlign = _a.textAlign, paddingTop = _a.paddingTop, paddingBottom = _a.paddingBottom, backgroundColor = _a.backgroundColor, backgroundImage = _a.backgroundImage, highlightTextColor = _a.highlightTextColor, id = _a.id, children = _a.children, className = _a.className, rest = __rest(_a, ["disableWrapperClass", "gridProfile", "disableMaximumWidth", "textAlign", "paddingTop", "paddingBottom", "backgroundColor", "backgroundImage", "highlightTextColor", "id", "children", "className"]);
    var hasBackgroundImage = checkImage(backgroundImage);
    return (React__namespace.default.createElement(ConditionalWrapper, { condition: hasBackgroundImage, wrapper: function (children) { return (React__namespace.default.createElement(ImgBackground, { src: (backgroundImage && backgroundImage.image) || '', base64: backgroundImage && backgroundImage.base64, quality: 90, loading: "lazy", tag: "section", className: className }, children)); } },
        React__namespace.default.createElement("section", __assign({ className: classNames__default.default({ 'w-full': !disableWrapperClass }, (_b = getBackgroundColorClass(backgroundColor)) !== null && _b !== void 0 ? _b : backgroundColor, (_c = getColorClass(highlightTextColor)) !== null && _c !== void 0 ? _c : highlightTextColor, !hasBackgroundImage && className), id: id && (id === null || id === void 0 ? void 0 : id.length) > 0 ? id : undefined }, getStoryblokProps(rest)),
            React__namespace.default.createElement("div", { className: classNames__default.default({ 'w-normal': !disableMaximumWidth }, css$13["section-".concat(textAlign)], paddingTop, paddingBottom) },
                React__namespace.default.createElement(ConditionalWrapper, { condition: gridProfile in gridProfiles$1, wrapper: function (children) { return (React__namespace.default.createElement(Row, null,
                        React__namespace.default.createElement(Col, __assign({}, gridProfiles$1[gridProfile]), children))); } }, children)))));
};

var _path$C;
function _extends$P() { _extends$P = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$P.apply(this, arguments); }
var SvgAlertCircle = function SvgAlertCircle(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$P({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 880 880"
  }, props), _path$C || (_path$C = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M440 0c243 0 440 197 440 440S683 880 440 880 0 683 0 440 197 0 440 0zm0 60C231.5 60 60 231.5 60 440s171.5 380 380 380 380-171.5 380-380S648.5 60 440 60zm-27 424-14-264h82l-14 264h-54zm27 166c-27.4 0-50-22.6-50-50s22.6-50 50-50 50 22.6 50 50-22.6 50-50 50z"
  })));
};

var _path$B;
function _extends$O() { _extends$O = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$O.apply(this, arguments); }
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$O({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 880 720"
  }, props), _path$B || (_path$B = /*#__PURE__*/React__namespace.createElement("path", {
    d: "m520 0 360 360-360 360-56-56 262-264H0v-80h726L464 56l56-56z"
  })));
};

function _extends$N() { _extends$N = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$N.apply(this, arguments); }
var SvgArrowRightOtto = function SvgArrowRightOtto(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$N({
    viewBox: "0 0 16 16",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M1 8.63h12.93m-4.1-5.51 4.67 5.51-4.67 5.5",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.25px"
    }
  }));
};

var _path$A;
function _extends$M() { _extends$M = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$M.apply(this, arguments); }
var SvgBank = function SvgBank(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 845"
  }, props), _path$A || (_path$A = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M626.5 265 405 80.5 175 265H73.5L405 0l324 265H626.5zM40 305h720v40H40v-40zm90 360V385h60v280h-60zm240 0V385h60v280h-60zm300 0h-60V385h60v280zM40 705h720v40H40v-40zM0 785h800v60H0v-60z"
  })));
};

var _path$z;
function _extends$L() { _extends$L = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$L.apply(this, arguments); }
var SvgBarDiagram = function SvgBarDiagram(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$L({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 720 880"
  }, props), _path$z || (_path$z = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M720 0v880h-60V0h60zM280 40v840h-60V40h60zm221 160v680h-60V200h60zM60 280v600H0V280h60z"
  })));
};

var _path$y;
function _extends$K() { _extends$K = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$K.apply(this, arguments); }
var SvgBulb = function SvgBulb(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 601.5 881.2"
  }, props), _path$y || (_path$y = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M460.8 641.2h-60C401.2 472.8 542 444.9 542 295.8 542 161.1 438.3 60 300.8 60 163.2 60 59.5 161.1 59.5 295.8c0 149.2 140.8 177 141.2 345.5h-59C140.2 499.8 0 470.3 0 295.8 0 127.1 129.6 0 300.8 0s300.8 127.1 300.8 295.8c-.1 174.5-139.4 204-140.8 345.4zm0 60v60h-320v-60h320zm0 120v60h-320v-60h320z"
  })));
};

var _path$x;
function _extends$J() { _extends$J = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$J.apply(this, arguments); }
var SvgCardReader = function SvgCardReader(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$J({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 880"
  }, props), _path$x || (_path$x = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M97.5 880C42 880 0 839 0 782.5v-685C0 41 42 0 97.5 0h445C598 0 640 41 640 97.5v685c0 56.5-42 97.5-97.5 97.5h-445zm1.5-60h442c22 0 39-17.5 39-39V99c0-21.5-17-39-39-39H99c-22 0-39 17.5-39 39v682c0 21.5 17 39 39 39zm41-480c-11 0-20-9-20-20V140c0-11 9-20 20-20h360c11 0 20 9 20 20v180c0 11-9 20-20 20H140zm44.5 161c-22.5 0-41-18.5-41-41 0-22 18.5-40.5 41-40.5 22 0 40.5 18.5 40.5 40.5 0 22.5-18.5 41-40.5 41zm136.5 0c-22.5 0-41-18.5-41-41 0-22 18.5-40.5 41-40.5 22 0 40.5 18.5 40.5 40.5 0 22.5-18.5 41-40.5 41zm136.5 0c-22.5 0-41-18.5-41-41 0-22 18.5-40.5 41-40.5 22 0 40.5 18.5 40.5 40.5 0 22.5-18.5 41-40.5 41zm-273 120c-22.5 0-41-18.5-41-41 0-22 18.5-40.5 41-40.5 22 0 40.5 18.5 40.5 40.5 0 22.5-18.5 41-40.5 41zm136.5 0c-22.5 0-41-18.5-41-41 0-22 18.5-40.5 41-40.5 22 0 40.5 18.5 40.5 40.5 0 22.5-18.5 41-40.5 41zm136.5 0c-22.5 0-41-18.5-41-41 0-22 18.5-40.5 41-40.5 22 0 40.5 18.5 40.5 40.5 0 22.5-18.5 41-40.5 41zm-273 120c-22.5 0-41-18.5-41-41 0-22 18.5-40.5 41-40.5 22 0 40.5 18.5 40.5 40.5 0 22.5-18.5 41-40.5 41zm136.5 0c-22.5 0-41-18.5-41-41 0-22 18.5-40.5 41-40.5 22 0 40.5 18.5 40.5 40.5 0 22.5-18.5 41-40.5 41zm136.5 0c-22.5 0-41-18.5-41-41 0-22 18.5-40.5 41-40.5 22 0 40.5 18.5 40.5 40.5 0 22.5-18.5 41-40.5 41z"
  })));
};

var _path$w;
function _extends$I() { _extends$I = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$I.apply(this, arguments); }
var SvgChat = function SvgChat(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$I({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 880 805"
  }, props), _path$w || (_path$w = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M880 0v600H495.5L220 805V600H0V0h880zm-60 60H60v480h220v147l189.5-147H820V60z"
  })));
};

var _path$v;
function _extends$H() { _extends$H = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$H.apply(this, arguments); }
var SvgCheckmark = function SvgCheckmark(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$H({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 890 781"
  }, props), _path$v || (_path$v = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M0 425.5 48 382l266.5 299L839 0l51 39-570.5 742L0 425.5z"
  })));
};

var _path$u, _path2$b;
function _extends$G() { _extends$G = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$G.apply(this, arguments); }
var SvgCross = function SvgCross(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$G({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.5 16.5"
  }, props), _path$u || (_path$u = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M-3.8-3.7h24v24h-24v-24z",
    fill: "none"
  })), _path2$b || (_path2$b = /*#__PURE__*/React__namespace.createElement("path", {
    d: "m.8.9 14.8 14.8M15.7.9.8 15.7",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$t;
function _extends$F() { _extends$F = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$F.apply(this, arguments); }
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$F({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 829 829"
  }, props), _path$t || (_path$t = /*#__PURE__*/React__namespace.createElement("path", {
    d: "m578 0 251 250-578 579H0V578L578 0zm1 85-99.5 99.5 165.1 165.1L744 250 579 85zM226 769l383.6-384.4-165.1-165.1L60 604v165h166z"
  })));
};

var _path$s;
function _extends$E() { _extends$E = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$E.apply(this, arguments); }
var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$E({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 879.5 640"
  }, props), _path$s || (_path$s = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M0 0h879.5v640H0V0zm774.8 60H105l260.5 268c29 30 53 43 74 43 23 0 48.5-13.5 76-42L774.8 60zM60 580h759.5V93.6L548.5 374c-36.5 38-73.5 57-109 57-34 0-71.5-19.5-108-57L60 93.4V580z"
  })));
};

var _defs$7, _path$r, _path2$a, _path3$7;
function _extends$D() { _extends$D = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$D.apply(this, arguments); }
var SvgExternalLink = function SvgExternalLink(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$D({
    id: "external-link_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _defs$7 || (_defs$7 = /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("style", null, ".external-link_svg__cls-1{fill:none;stroke:#192550;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _path$r || (_path$r = /*#__PURE__*/React__namespace.createElement("path", {
    className: "external-link_svg__cls-1",
    d: "M17.25 12.1v5.881a1.269 1.269 0 0 1-1.269 1.269H2.019A1.269 1.269 0 0 1 .75 17.981V4.019A1.269 1.269 0 0 1 2.019 2.75H7.9"
  })), _path2$a || (_path2$a = /*#__PURE__*/React__namespace.createElement("path", {
    fill: "none",
    d: "M0 0h20v20H0z"
  })), _path3$7 || (_path3$7 = /*#__PURE__*/React__namespace.createElement("path", {
    className: "external-link_svg__cls-1",
    d: "M18.25 9.132V1.75h-7.423m-2.369 9.792 9.214-9.214"
  })));
};

var _path$q;
function _extends$C() { _extends$C = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$C.apply(this, arguments); }
var SvgHeadphones = function SvgHeadphones(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$C({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800.5 820"
  }, props), _path$q || (_path$q = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M800.5 820H742l-2-420C739 206.5 592 60 400 60 207 60 60 206.5 60 400v420H0V400C0 172.5 173 0 400 0c226.5 0 399.5 172.5 400 400l.5 420zM120 540h60v280h-60V540zm500 0h60v280h-60V540z"
  })));
};

var _path$p, _path2$9;
function _extends$B() { _extends$B = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$B.apply(this, arguments); }
var SvgIconDownChevronS = function SvgIconDownChevronS(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$B({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path$p || (_path$p = /*#__PURE__*/React__namespace.createElement("path", {
    fill: "none",
    d: "M20 20H0V0h20z"
  })), _path2$9 || (_path2$9 = /*#__PURE__*/React__namespace.createElement("path", {
    stroke: "#192550",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    fill: "none",
    d: "M3.113 6.792 10 12.625l6.887-5.833"
  })));
};

var _path$o, _path2$8;
function _extends$A() { _extends$A = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$A.apply(this, arguments); }
var SvgIconDownChevronM = function SvgIconDownChevronM(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$A({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path$o || (_path$o = /*#__PURE__*/React__namespace.createElement("path", {
    fill: "none",
    d: "M24 24H0V0h24z"
  })), _path2$8 || (_path2$8 = /*#__PURE__*/React__namespace.createElement("path", {
    stroke: "#192550",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    fill: "none",
    d: "m3.735 8.5 8.265 7 8.264-7"
  })));
};

var _path$n;
function _extends$z() { _extends$z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$z.apply(this, arguments); }
var SvgIconRightChevron = function SvgIconRightChevron(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$z({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    "aria-labelledby": "##TITLE## ##DESCRIPTION##"
  }, props), _path$n || (_path$n = /*#__PURE__*/React__namespace.createElement("path", {
    d: "m15.8 54.2 22.7-22.7L15.8 8.8 20.7 4l27.5 27.5L20.7 59l-4.9-4.8z"
  })));
};

var _path$m;
function _extends$y() { _extends$y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$y.apply(this, arguments); }
var SvgMenu = function SvgMenu(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$y({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path$m || (_path$m = /*#__PURE__*/React__namespace.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M2.7 5.75h18.5m-18.5 7h13.258m-13.258 7h18.5",
    style: {
      fill: "none",
      stroke: "#192550",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }));
};

var _path$l;
function _extends$x() { _extends$x = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$x.apply(this, arguments); }
var SvgMinus = function SvgMinus(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$x({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 840 60"
  }, props), _path$l || (_path$l = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M840 0v60H0V0h840z"
  })));
};

var _path$k;
function _extends$w() { _extends$w = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$w.apply(this, arguments); }
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$w({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 880"
  }, props), _path$k || (_path$k = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M600 0v880H0V0h600zm-60 60H60v760h480V60zm-310 50h140v60H230v-60zm115 605c0-25.5-19.5-45-45-45s-45 19.5-45 45 19.5 45 45 45 45-19.5 45-45z"
  })));
};

var _path$j;
function _extends$v() { _extends$v = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$v.apply(this, arguments); }
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$v({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 811.1 872.4"
  }, props), _path$j || (_path$j = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M0 16.5C0 3.4 12-4.1 24 2.3l777.2 417.5c13.3 7.2 13.3 23.3 0 30.5L24 870c-12 6.5-24-1.1-24-14.2V16.5z"
  })));
};

var _path$i;
function _extends$u() { _extends$u = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$u.apply(this, arguments); }
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$u({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 860 860"
  }, props), _path$i || (_path$i = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M860 400v60H460v400h-60V460H0v-60h400V0h60v400h400z"
  })));
};

var _g$8;
function _extends$t() { _extends$t = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$t.apply(this, arguments); }
var SvgSad = function SvgSad(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$t({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 880 880"
  }, props), _g$8 || (_g$8 = /*#__PURE__*/React__namespace.createElement("g", {
    "data-name": "Lager 2"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M440 0q120 0 221 59t160 160q59 101 59 221t-59 221q-59 101-160 160t-221 59q-120 0-221-59T59 661Q0 560 0 440t59-221q59-101 160-160T440 0zm0 60q-102 0-189.5 51.5T111.5 250Q60 337 60 440q0 102 51.5 189.5a385.86 385.86 0 0 0 139 139Q338 820 440 820q103 0 190-51.5t138.5-139Q820 542 820 440q0-103-51.5-190A388.3 388.3 0 0 0 630 111.5Q543 60 440 60zm142 367q-21 0-36.5-15T530 376q0-22 15.5-37t36.5-15q21 0 36.5 15t15.5 37q0 21-15.5 36T582 427zm-284 0a51.21 51.21 0 0 1-51-51q0-22 15-36.5a49.94 49.94 0 0 1 36-14.5q22 0 37 14.5t15 36.5a49.1 49.1 0 0 1-15 36q-15 15-37 15zm-47 183q37-35 86-59a233 233 0 0 1 206 0q49 24 86 59l-42 43a253.49 253.49 0 0 0-67.5-48.5A177.4 177.4 0 0 0 440 586a180.53 180.53 0 0 0-80 18.5 262.53 262.53 0 0 0-68 47.5z",
    "data-name": "Lager 1"
  }))));
};

var _defs$6, _circle$2, _path$h, _path2$7, _path3$6, _path4$2, _path5$2;
function _extends$s() { _extends$s = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$s.apply(this, arguments); }
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$s({
    id: "search_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs$6 || (_defs$6 = /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("style", null, ".search_svg__cls-1,.search_svg__cls-3{fill:none}.search_svg__cls-1{stroke:#192550;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _circle$2 || (_circle$2 = /*#__PURE__*/React__namespace.createElement("circle", {
    className: "search_svg__cls-1",
    cx: 9.5,
    cy: 9.5,
    r: 7.75
  })), _path$h || (_path$h = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M9.02 4.517a5.008 5.008 0 0 0-4.5 4.471",
    strokeMiterlimit: 10,
    strokeWidth: 0.75,
    stroke: "#192550",
    strokeLinecap: "round",
    fill: "none"
  })), _path2$7 || (_path2$7 = /*#__PURE__*/React__namespace.createElement("path", {
    className: "search_svg__cls-1",
    d: "m15.19 15.107 5.041 6.065a1.269 1.269 0 0 1-.218 1.78 1.268 1.268 0 0 1-1.78-.219l-3.2-3.878"
  })), _path3$6 || (_path3$6 = /*#__PURE__*/React__namespace.createElement("path", {
    className: "search_svg__cls-3",
    d: "M0 0h24v24H0z"
  })), _path4$2 || (_path4$2 = /*#__PURE__*/React__namespace.createElement("path", {
    className: "search_svg__cls-3",
    d: "M0 0h24v24H0z"
  })), _path5$2 || (_path5$2 = /*#__PURE__*/React__namespace.createElement("path", {
    className: "search_svg__cls-3",
    d: "M0 0h24v24H0z"
  })));
};

var _path$g;
function _extends$r() { _extends$r = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$r.apply(this, arguments); }
var SvgSettings = function SvgSettings(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$r({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 907 907"
  }, props), _path$g || (_path$g = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M454.5 0 588 133.5h185.5V319L907 452.5 773.5 586v187.5H588L454.5 907 321 773.5H133.5V586L0 452.5 133.5 319V133.5H321L454.5 0zm0 85L346 193.5H193.5v150L85 452.5 193.5 561v152.5H346L454.5 822l109-108.5h150V561L822 452.5l-108.5-109v-150h-150L454.5 85zm-1 528.5c-89 0-160-71-160-160s71-160 160-160 160 71 160 160-71 160-160 160zm0-59c55.5 0 101-45.5 101-101s-45.5-101-101-101-101 45.5-101 101 45.5 101 101 101z"
  })));
};

var _path$f;
function _extends$q() { _extends$q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$q.apply(this, arguments); }
var SvgSliders = function SvgSliders(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$q({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 880"
  }, props), _path$f || (_path$f = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M160 454.1c57 13.7 100 65 100 126.4 0 61.8-43.4 113.2-100.9 126.6L160 880h-60l-.9-173C42 693.2 0 641.6 0 580.5c0-61.4 42.4-113.2 100-126.6V0h60v454.1zm319.1-280.3C537.2 187.1 580 238.7 580 301c0 61.8-43.2 113-100.9 126.2L480 880h-60l-.9-453C362 413.4 320 362.5 320 301s42-113.2 99.1-126.9L420 0h60l-.9 173.8zM900 580.5c0 61.7-42.5 113.1-100 126.6v173h-60v-173c-57.5-13.5-100-64.9-100-126.6S682.6 467.4 740 454V0h60v454c57.5 13.4 100 64.8 100 126.5zm-450.5-210c39 0 70.5-31.5 70.5-69.5 0-39-31.5-70.5-70.5-70.5-38 0-69.5 31.5-69.5 70.5 0 38.5 31 69.5 69.5 69.5zm-320 280c38.5 0 70.5-32 70.5-70s-32-70-70.5-70c-38 0-69.5 31.5-69.5 70s31.5 70 69.5 70zm640.5 0c38.5 0 70-31.5 70-70s-31.5-70-70-70-70 31.5-70 70 31.5 70 70 70z"
  })));
};

var _path$e;
function _extends$p() { _extends$p = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$p.apply(this, arguments); }
var SvgSmile = function SvgSmile(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$p({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 880 880"
  }, props), _path$e || (_path$e = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M440 0c243 0 440 197 440 440S683 880 440 880 0 683 0 440 197 0 440 0zm0 60C231.5 60 60 231.5 60 440s171.5 380 380 380 380-171.5 380-380S648.5 60 440 60zm142 371.5c-28.5 0-52-23.5-52-52s23.5-51.5 52-51.5c28 0 51.5 23 51.5 51.5s-23.5 52-51.5 52zm-284 0c-28 0-51.5-24-51.5-52C246.5 351 270 329 298 329c28.5 0 52 22 52 50.5 0 28-23.5 52-52 52zM440 684c-78 0-147.5-42.5-188.5-83l41-41.5C328.5 594 380 625 440 625s111.5-31 147.5-65.5l41 41.5c-41 40.5-110.5 83-188.5 83z"
  })));
};

var _path$d;
function _extends$o() { _extends$o = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$o.apply(this, arguments); }
var SvgNeutral = function SvgNeutral(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$o({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 880 880"
  }, props), _path$d || (_path$d = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M440 0c243 0 440 197 440 440S683 880 440 880 0 683 0 440 197 0 440 0zm0 60C231.5 60 60 231.5 60 440s171.5 380 380 380 380-171.5 380-380S648.5 60 440 60zm142 371.5c-28.5 0-52-23.5-52-52s23.5-51.5 52-51.5c28 0 51.5 23 51.5 51.5s-23.5 52-51.5 52zm-284 0c-28 0-51.5-24-51.5-52C246.5 351 270 329 298 329c28.5 0 52 22 52 50.5 0 28-23.5 52-52 52zM633.5 633h-387v-57h387v57z"
  })));
};

var _path$c;
function _extends$n() { _extends$n = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$n.apply(this, arguments); }
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$n({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 918.4 887.9"
  }, props), _path$c || (_path$c = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M185.2 886.8c-8.5 4-18-3-16-12.5l52-302c.5-3 0-5-2.5-7.5L4.2 348.8c-8.5-8.5-3-18 6.5-19.5l296.5-41c3-1.5 5-3 6.5-4.5L447.2 8.2c5.5-11 17-11 22 0l133.5 275.5c.5 1.5 3.5 3 6.5 4.5l298.5 41c9.5 1.5 15 11 6.5 19.5l-216 216c-2 2.5-2.5 4.5-2 7.5l51 302c1.5 9.5-7.5 16.5-16 12.5l-269.5-142c-2-1-4-1-6 0L185.2 886.8zm59-98 214.5-113.5 213.5 113.5-42.5-240 172.5-172.5-237.5-34-106-219-107 219-237.5 34 173.5 172.5-43.5 240z"
  })));
};

var _circle$1;
function _extends$m() { _extends$m = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$m.apply(this, arguments); }
var SvgCircle = function SvgCircle(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$m({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle$1 || (_circle$1 = /*#__PURE__*/React__namespace.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50
  })));
};

var _g$7, _defs$5;
function _extends$l() { _extends$l = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$l.apply(this, arguments); }
var SvgPrimaryPositive = function SvgPrimaryPositive(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$l({
    viewBox: "0 0 220 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$7 || (_g$7 = /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#primary-positive_svg__a)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M199.873 64.1c7.216 0 13.905-2.78 17.881-6.86.746-.75.746-1.63 0-2.38l-4.323-4.28c-.875-.88-1.76-.88-2.764 0-1.689 1.49-5.397 4.07-10.396 4.07-6.342 0-11.401-4.35-12.146-11.27h29.42c1.551 0 2.426-.48 2.426-2.24.477-14.66-9.244-24.58-21.867-24.58-13.23 0-21.797 10.93-21.797 23.83.01 14.27 10.267 23.71 23.566 23.71Zm-11.271-28.85c0-3.53 3.24-9.23 9.721-9.23 6.878 0 9.243 6.04 9.243 8.35 0 .41-.338.88-.944.88h-18.02ZM2.385 10.93H45.98V1.5c0-.83-.666-1.5-1.491-1.5H2.385C1.561 0 .895.67.895 1.5v7.93c0 .82.665 1.5 1.49 1.5Zm-.954 52.08H44.56c.785 0 1.43-.64 1.43-1.44v-8.05c0-.79-.635-1.44-1.43-1.44H0v9.49c0 .79.636 1.44 1.431 1.44Z",
    fill: "#003087"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M32.204 10.93 0 52.08h14.402L45.98 10.93H32.204Z",
    fill: "#0070E0"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M72.856 64.1c7.216 0 13.905-2.78 17.88-6.86.746-.75.746-1.63 0-2.38l-4.323-4.28c-.875-.88-1.76-.88-2.763 0-1.69 1.49-5.397 4.07-10.397 4.07-6.341 0-11.4-4.35-12.146-11.27h29.42c1.551 0 2.426-.48 2.426-2.24.477-14.66-9.244-24.58-21.867-24.58-13.23 0-21.797 10.93-21.797 23.83.01 14.27 10.267 23.71 23.567 23.71ZM61.584 35.25c0-3.53 3.24-9.23 9.721-9.23 6.878 0 9.244 6.04 9.244 8.35 0 .41-.338.88-.945.88h-18.02ZM168.016 63.01h-8.23c-.805 0-1.431-.63-1.431-1.44V1.44c0-.81.626-1.44 1.431-1.44h8.23c.805 0 1.432.63 1.432 1.44v60.12c0 .82-.627 1.45-1.432 1.45Zm-60.66 0h8.23c.715 0 1.431-.63 1.431-1.44V27.45h15.118v34.11c0 .81.626 1.44 1.431 1.44h8.23c.805 0 1.431-.63 1.431-1.44v-33.3c0-.45.358-.81.895-.81h7.872c.805 0 1.431-.54 1.431-1.26v-7.2c0-.81-.626-1.35-1.431-1.35h-7.872a.9.9 0 0 1-.895-.9V6.75c0-.81-.626-1.44-1.431-1.44h-8.23c-.805 0-1.431.63-1.431 1.44v10.89h-15.118V6.75c0-.81-.716-1.44-1.431-1.44h-8.23c-.805 0-1.432.63-1.432 1.44v9.99c0 .45-.357.9-.894.9h-7.962c-.805 0-1.341.54-1.341 1.35v7.02c0 .81.536 1.44 1.341 1.44h7.962c.537 0 .894.36.894.81v33.3c0 .82.627 1.45 1.432 1.45ZM121.214 92.32l-4.175 6.07h2.207l9.532-14.26h-2.167l-4.056 6.24-2.315-6.24h-2.227l3.201 8.19ZM113.013 83.7c-1.481 0-2.803.78-3.797 1.98h-.03l1.6-10.23h-1.918l-2.942 18.59h1.938l.229-1.55h.059c.567 1.12 1.69 1.9 3.081 1.9 3.082 0 5.199-2.56 5.656-5.43.437-2.76-.994-5.26-3.876-5.26Zm1.938 5.32c-.318 1.98-1.74 3.65-3.827 3.65-2.028 0-2.882-1.75-2.574-3.65.288-1.87 1.739-3.59 3.717-3.59 2.087 0 3.002 1.63 2.684 3.59ZM192.179 75.45h-6.649a.921.921 0 0 0-.914.79l-2.694 17.16c-.05.34.209.65.547.65h3.409c.318 0 .586-.23.636-.55l.765-4.87c.07-.45.457-.79.915-.79h2.107c4.383 0 6.908-2.13 7.574-6.36.298-1.85.01-3.3-.845-4.32-.944-1.11-2.624-1.71-4.851-1.71Zm.766 6.27c-.368 2.4-2.187 2.4-3.956 2.4h-1.004l.706-4.49a.555.555 0 0 1 .546-.47h.458c1.202 0 2.335 0 2.922.69.358.42.457 1.03.328 1.87ZM144.729 75.45h-6.65a.921.921 0 0 0-.914.79l-2.694 17.16c-.05.34.209.65.547.65h3.18c.457 0 .845-.33.915-.79l.725-4.63c.07-.45.458-.79.915-.79h2.107c4.383 0 6.908-2.13 7.574-6.36.298-1.85.01-3.3-.845-4.32-.964-1.11-2.634-1.71-4.86-1.71Zm.765 6.27c-.368 2.4-2.187 2.4-3.956 2.4h-1.004l.706-4.49c.04-.27.278-.47.546-.47h.458c1.202 0 2.335 0 2.922.69.358.42.457 1.03.328 1.87ZM164.607 81.65h-3.191a.55.55 0 0 0-.547.47l-.139.9-.219-.32c-.685-1.01-2.226-1.34-3.767-1.34-3.518 0-6.53 2.68-7.106 6.45-.308 1.88.129 3.67 1.183 4.92.974 1.15 2.355 1.63 4.015 1.63 2.833 0 4.413-1.83 4.413-1.83l-.139.89c-.05.34.209.65.547.65h2.872c.457 0 .845-.33.915-.79l1.719-10.97a.564.564 0 0 0-.556-.66Zm-4.433 6.24c-.309 1.83-1.75 3.06-3.599 3.06-.924 0-1.659-.3-2.137-.87-.467-.56-.646-1.36-.497-2.25.289-1.81 1.76-3.08 3.569-3.08.904 0 1.64.3 2.127.87.477.57.676 1.38.537 2.27ZM212.067 81.65h-3.19c-.268 0-.507.2-.547.47l-.139.9-.219-.32c-.685-1.01-2.226-1.34-3.767-1.34-3.518 0-6.53 2.68-7.106 6.45-.308 1.88.129 3.67 1.182 4.92.975 1.15 2.356 1.63 4.016 1.63 2.833 0 4.413-1.83 4.413-1.83l-.139.89c-.05.34.209.65.547.65h2.872c.457 0 .845-.33.915-.79l1.719-10.97c.04-.36-.219-.66-.557-.66Zm-4.442 6.24c-.309 1.83-1.75 3.06-3.599 3.06-.924 0-1.659-.3-2.137-.87-.467-.56-.646-1.36-.497-2.25.289-1.81 1.76-3.08 3.569-3.08.904 0 1.64.3 2.127.87.487.57.676 1.38.537 2.27ZM181.585 81.65h-3.201a.907.907 0 0 0-.765.41l-4.413 6.55-1.869-6.29a.928.928 0 0 0-.885-.66h-3.15a.563.563 0 0 0-.527.74l3.528 10.41-3.32 4.71c-.258.37 0 .88.448.88h3.2c.308 0 .587-.15.756-.4l10.645-15.46c.258-.39 0-.89-.447-.89ZM215.816 75.93l-2.734 17.48c-.049.34.209.64.547.64h2.743c.457 0 .845-.33.915-.79l2.693-17.16a.554.554 0 0 0-.546-.64h-3.072c-.268 0-.497.2-.546.47Z",
    fill: "#003087"
  }))), _defs$5 || (_defs$5 = /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "primary-positive_svg__a"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#fff",
    d: "M0 0h220v98.39H0z"
  })))));
};

var _g$6, _defs$4;
function _extends$k() { _extends$k = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$k.apply(this, arguments); }
var SvgPrimaryNegative = function SvgPrimaryNegative(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$k({
    viewBox: "0 0 220 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$6 || (_g$6 = /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#primary-negative_svg__a)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M45.58 53.321c0-.797-.637-1.434-1.434-1.434H0v8.936c0 .797.638 1.435 1.435 1.435h42.71c.797 0 1.435-.638 1.435-1.435v-7.502ZM.877 8.857c0 .877.717 1.514 1.514 1.514h43.19V1.514C45.58.638 44.942 0 44.145 0H2.39C1.594 0 .877.638.877 1.514v7.343Z",
    fill: "#fff"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M32.489 10.381 0 51.887h13.809L45.58 10.38H32.49Z",
    fill: "#0070E0"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M116.795 26.82h15.642v34.003c0 .797.717 1.435 1.434 1.435h7.742c.797 0 1.434-.638 1.434-1.435V27.697c0-.478.399-.877.877-.877h7.98c.797 0 1.355-.558 1.355-1.434V18.92c0-.797-.558-1.355-1.355-1.355h-7.98c-.478 0-.877-.479-.877-.877V6.705c0-.797-.637-1.434-1.434-1.434h-7.742c-.717 0-1.434.637-1.434 1.434v10.86h-15.642V6.705c0-.797-.717-1.434-1.435-1.434h-7.741c-.797 0-1.434.637-1.434 1.434v9.983c0 .399-.399.877-.877.877h-7.98c-.797 0-1.355.558-1.355 1.355v6.465c0 .877.558 1.435 1.355 1.435h7.98c.478 0 .877.399.877.877v33.126c0 .797.637 1.435 1.434 1.435h7.741c.718 0 1.435-.638 1.435-1.435V26.82ZM169.339 1.435v59.388c0 .797-.638 1.435-1.435 1.435h-7.741a1.429 1.429 0 0 1-1.435-1.435V1.435c0-.797.638-1.435 1.435-1.435h7.741c.797 0 1.435.638 1.435 1.435ZM220.001 40.47c0-13.73-8.698-23.951-21.629-23.951-13.171 0-21.63 10.7-21.63 23.472 0 13.65 9.744 23.393 23.393 23.393 6.864 0 13.649-2.63 17.565-6.625.797-.797.797-1.515-.08-2.392l-3.916-3.915c-.876-.877-1.753-.797-2.55-.16-1.833 1.435-5.589 4.155-10.62 4.155-6.546 0-11.657-4.393-12.454-11.736h29.54c1.504 0 2.381-.478 2.381-2.242Zm-12.932-5.35h-18.521c-.159-3.518 3.198-9.744 9.983-9.744 7.104 0 9.495 6.226 9.495 8.777 0 .488-.319.966-.957.966ZM90.233 54.358l-3.916-3.916c-.876-.877-1.753-.797-2.55-.16-1.833 1.435-5.59 4.155-10.62 4.155-6.546 0-11.657-4.393-12.454-11.736h29.54c1.514 0 2.391-.478 2.47-2.232.638-13.729-8.777-23.95-21.708-23.95-13.171 0-21.63 10.7-21.63 23.472 0 13.65 9.744 23.393 23.393 23.393 6.865 0 13.65-2.63 17.565-6.625.787-.797.787-1.515-.09-2.401Zm-10.53-19.239H61.18c-.16-3.517 3.188-9.744 9.983-9.744 7.103 0 9.495 6.227 9.495 8.778 0 .488-.32.966-.957.966ZM121.497 91.708l-4.175 6.048h2.202l9.564-14.207h-2.181l-4.065 6.217-2.312-6.217h-2.241l3.208 8.16ZM113.277 83.12c-1.484 0-2.809.777-3.805 1.973h-.03l1.604-10.192h-1.923l-2.949 18.52h1.943l.229-1.543h.06a3.417 3.417 0 0 0 3.088 1.892c3.088 0 5.211-2.55 5.669-5.41.438-2.749-.996-5.24-3.886-5.24Zm1.943 5.3c-.319 1.973-1.743 3.637-3.836 3.637-2.032 0-2.889-1.744-2.58-3.636.289-1.864 1.744-3.577 3.726-3.577 2.092 0 3.009 1.624 2.69 3.577ZM192.124 74.9h-6.665a.923.923 0 0 0-.917.788l-2.7 17.096a.563.563 0 0 0 .548.648h3.418c.318 0 .587-.23.637-.548l.767-4.852a.932.932 0 0 1 .917-.787h2.112c4.394 0 6.924-2.122 7.592-6.337.299-1.843.01-3.287-.847-4.303-.957-1.106-2.63-1.704-4.862-1.704Zm.767 6.248c-.368 2.39-2.192 2.39-3.965 2.39h-1.006l.707-4.473a.557.557 0 0 1 .548-.468h.458c1.206 0 2.342 0 2.929.688.359.418.459 1.026.329 1.863ZM144.561 74.9h-6.665a.922.922 0 0 0-.916.788l-2.7 17.096a.562.562 0 0 0 .548.648h3.188a.922.922 0 0 0 .916-.787l.728-4.613a.93.93 0 0 1 .916-.787h2.112c4.394 0 6.924-2.122 7.592-6.337.299-1.843.01-3.287-.847-4.303-.966-1.106-2.64-1.704-4.872-1.704Zm.767 6.248c-.368 2.39-2.191 2.39-3.965 2.39h-1.006l.707-4.473a.557.557 0 0 1 .548-.468h.459c1.205 0 2.341 0 2.929.688.358.418.458 1.026.328 1.863ZM164.488 81.078h-3.198c-.279 0-.508.2-.548.468l-.14.897-.219-.319c-.687-1.006-2.232-1.335-3.776-1.335-3.527 0-6.546 2.67-7.123 6.426-.309 1.873.129 3.656 1.185 4.902.977 1.146 2.361 1.624 4.025 1.624 2.84 0 4.424-1.823 4.424-1.823l-.14.886a.562.562 0 0 0 .548.648h2.87a.922.922 0 0 0 .916-.787l1.724-10.93a.552.552 0 0 0-.548-.657Zm-4.444 6.217c-.309 1.823-1.753 3.049-3.606 3.049-.927 0-1.664-.3-2.142-.867-.469-.558-.648-1.355-.498-2.242.288-1.803 1.763-3.069 3.576-3.069.907 0 1.644.3 2.132.867.479.568.678 1.375.538 2.262ZM212.06 81.078h-3.198c-.269 0-.508.2-.548.468l-.14.897-.219-.319c-.687-1.006-2.231-1.335-3.776-1.335-3.526 0-6.545 2.67-7.123 6.426-.309 1.873.129 3.656 1.185 4.902.977 1.146 2.362 1.624 4.025 1.624 2.84 0 4.424-1.823 4.424-1.823l-.139.886a.562.562 0 0 0 .547.648h2.88a.922.922 0 0 0 .916-.787l1.724-10.93c.04-.358-.219-.657-.558-.657Zm-4.453 6.217c-.309 1.823-1.754 3.049-3.607 3.049-.927 0-1.664-.3-2.142-.867-.468-.558-.648-1.355-.498-2.242.289-1.803 1.763-3.069 3.577-3.069.906 0 1.643.3 2.132.867.488.568.677 1.375.538 2.262ZM181.494 81.078h-3.208a.913.913 0 0 0-.767.408l-4.423 6.526-1.873-6.267a.93.93 0 0 0-.887-.657h-3.158a.561.561 0 0 0-.528.737l3.537 10.371-3.328 4.693a.555.555 0 0 0 .448.876h3.208a.91.91 0 0 0 .758-.398l10.67-15.403c.269-.388.01-.886-.449-.886ZM215.816 75.379l-2.74 17.415a.555.555 0 0 0 .548.638h2.75a.923.923 0 0 0 .917-.788l2.7-17.096a.554.554 0 0 0-.548-.637h-3.079a.555.555 0 0 0-.548.468Z",
    fill: "#fff"
  }))), _defs$4 || (_defs$4 = /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "primary-negative_svg__a"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#fff",
    d: "M0 0h220v97.756H0z"
  })))));
};

var _g$5, _path$b, _defs$3;
function _extends$j() { _extends$j = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$j.apply(this, arguments); }
var SvgOnelinePrimaryPositive = function SvgOnelinePrimaryPositive(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$j({
    viewBox: "0 0 155 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$5 || (_g$5 = /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#oneline-primary-positive_svg__a)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M62.458 20.031c2.255 0 4.346-.869 5.588-2.144.233-.234.233-.51 0-.743l-1.351-1.338c-.273-.275-.55-.275-.863 0-.529.466-1.687 1.272-3.25 1.272-1.981 0-3.562-1.36-3.795-3.522h9.194c.484 0 .758-.15.758-.7.149-4.581-2.889-7.681-6.834-7.681-4.134 0-6.811 3.415-6.811 7.447.003 4.46 3.208 7.41 7.364 7.41Zm-3.522-9.016c0-1.103 1.013-2.884 3.038-2.884 2.15 0 2.888 1.888 2.888 2.61a.283.283 0 0 1-.295.274h-5.631ZM.745 3.416H14.37V.469A.467.467 0 0 0 13.903 0H.745A.467.467 0 0 0 .28.469v2.478c0 .256.208.469.465.469ZM.447 19.69h13.478c.245 0 .447-.2.447-.45v-2.516a.449.449 0 0 0-.447-.45H0v2.966c0 .247.199.45.447.45Z",
    fill: "#003087"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M10.064 3.416 0 16.275h4.5l9.869-12.86h-4.305Z",
    fill: "#0070E0"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M22.767 20.031c2.255 0 4.345-.869 5.588-2.144.233-.234.233-.51 0-.743l-1.351-1.338c-.274-.275-.55-.275-.864 0-.528.466-1.687 1.272-3.249 1.272-1.982 0-3.563-1.36-3.795-3.522h9.194c.484 0 .757-.15.757-.7.15-4.581-2.888-7.681-6.833-7.681-4.134 0-6.812 3.415-6.812 7.447.003 4.46 3.209 7.41 7.365 7.41Zm-3.522-9.016c0-1.103 1.012-2.884 3.037-2.884 2.15 0 2.889 1.888 2.889 2.61a.283.283 0 0 1-.295.274h-5.631ZM52.505 19.69h-2.572a.443.443 0 0 1-.447-.45V.45c0-.253.195-.45.447-.45h2.572c.251 0 .447.197.447.45v18.788a.444.444 0 0 1-.447.453Zm-18.957 0h2.572a.461.461 0 0 0 .447-.45V8.579h4.725v10.66c0 .253.195.45.447.45h2.572a.443.443 0 0 0 .447-.45V8.83c0-.14.112-.253.28-.253h2.46c.251 0 .447-.169.447-.394v-2.25c0-.253-.196-.421-.447-.421h-2.46a.281.281 0 0 1-.28-.282V2.11a.443.443 0 0 0-.447-.45h-2.572a.443.443 0 0 0-.447.45v3.404h-4.725V2.109a.461.461 0 0 0-.447-.45h-2.572a.443.443 0 0 0-.447.45v3.122c0 .14-.112.282-.28.282h-2.488c-.251 0-.419.168-.419.421v2.194c0 .253.168.45.42.45h2.487c.168 0 .28.113.28.253v10.407c0 .256.196.453.447.453Z",
    fill: "#003087"
  }))), _path$b || (_path$b = /*#__PURE__*/React__namespace.createElement("path", {
    d: "m85.721 17.762-2.928 4.232h1.548l6.685-9.942h-1.52l-2.844 4.35-1.624-4.35h-1.562l2.245 5.71ZM79.97 11.751c-1.038 0-1.965.544-2.662 1.38h-.021L78.409 6h-1.346L75 18.96h1.36l.16-1.08h.042a2.393 2.393 0 0 0 2.16 1.324c2.162 0 3.647-1.785 3.968-3.786.306-1.924-.698-3.667-2.72-3.667Zm1.36 3.71c-.223 1.38-1.22 2.544-2.684 2.544-1.422 0-2.022-1.22-1.805-2.545.202-1.303 1.22-2.503 2.607-2.503 1.464 0 2.105 1.137 1.882 2.503ZM135.5 6h-4.664a.646.646 0 0 0-.642.55l-1.889 11.964a.393.393 0 0 0 .384.453h2.391a.45.45 0 0 0 .446-.384l.537-3.395a.65.65 0 0 1 .641-.55h1.478c3.074 0 4.845-1.485 5.312-4.434.209-1.29.007-2.3-.592-3.012C138.239 6.418 137.061 6 135.5 6Zm.536 4.371c-.258 1.673-1.533 1.673-2.774 1.673h-.704l.495-3.13a.39.39 0 0 1 .383-.328h.321c.843 0 1.638 0 2.049.481.251.293.321.718.23 1.304ZM102.218 6h-4.663c-.321 0-.593.23-.642.55l-1.89 11.964a.393.393 0 0 0 .384.453h2.231c.32 0 .593-.23.641-.55l.51-3.229a.652.652 0 0 1 .64-.55h1.479c3.074 0 4.845-1.485 5.312-4.434.209-1.29.007-2.3-.593-3.012C104.951 6.418 103.78 6 102.218 6Zm.537 4.371c-.258 1.673-1.534 1.673-2.774 1.673h-.705l.495-3.13a.39.39 0 0 1 .384-.328h.321c.843 0 1.638 0 2.049.481.251.293.321.718.23 1.304ZM116.161 10.32h-2.238a.385.385 0 0 0-.384.329l-.097.627-.154-.223c-.481-.704-1.561-.934-2.642-.934-2.468 0-4.58 1.868-4.984 4.496-.217 1.31.09 2.559.829 3.43.683.802 1.652 1.136 2.817 1.136 1.986 0 3.095-1.275 3.095-1.275l-.098.62a.394.394 0 0 0 .384.453h2.015c.32 0 .592-.23.641-.55l1.206-7.648a.394.394 0 0 0-.39-.46Zm-3.11 4.351c-.216 1.276-1.227 2.133-2.523 2.133-.649 0-1.165-.209-1.499-.606-.328-.39-.453-.948-.349-1.569.202-1.262 1.234-2.147 2.503-2.147.634 0 1.15.21 1.492.607.334.397.474.961.376 1.582ZM149.45 10.32h-2.238a.39.39 0 0 0-.384.329l-.097.627-.154-.223c-.481-.704-1.561-.934-2.642-.934-2.468 0-4.58 1.868-4.984 4.496-.216 1.31.09 2.559.829 3.43.683.802 1.652 1.136 2.817 1.136 1.987 0 3.095-1.275 3.095-1.275l-.098.62a.394.394 0 0 0 .384.453h2.015c.32 0 .592-.23.641-.55l1.206-7.648c.028-.251-.153-.46-.39-.46Zm-3.117 4.351c-.216 1.276-1.227 2.133-2.523 2.133-.649 0-1.165-.209-1.499-.606-.328-.39-.453-.948-.349-1.569.202-1.262 1.234-2.147 2.503-2.147.634 0 1.15.21 1.492.607.342.397.474.961.376 1.582ZM128.068 10.322h-2.245a.638.638 0 0 0-.537.286l-3.095 4.566-1.311-4.385a.65.65 0 0 0-.62-.46h-2.21a.394.394 0 0 0-.37.516l2.475 7.257-2.328 3.283a.388.388 0 0 0 .313.614h2.245a.637.637 0 0 0 .53-.279l7.466-10.778c.182-.272 0-.62-.313-.62ZM152.078 6.335l-1.917 12.186a.387.387 0 0 0 .383.446h1.924c.321 0 .593-.23.641-.55l1.89-11.964a.388.388 0 0 0-.384-.446h-2.154a.395.395 0 0 0-.383.328Z",
    fill: "#003087"
  })), _defs$3 || (_defs$3 = /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "oneline-primary-positive_svg__a"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#fff",
    d: "M0 0h68.75v20H0z"
  })))));
};

var _circle, _circle2, _circle3, _path$a;
function _extends$i() { _extends$i = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$i.apply(this, arguments); }
var SvgPlayVideo = function SvgPlayVideo(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$i({
    xmlns: "http://www.w3.org/2000/svg",
    height: "70%",
    viewBox: "0 0 48 48"
  }, props), _circle || (_circle = /*#__PURE__*/React__namespace.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 30,
    "data-highlight": "true",
    "data-outer": "true"
  })), _circle2 || (_circle2 = /*#__PURE__*/React__namespace.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 26,
    "data-highlight": "true"
  })), _circle3 || (_circle3 = /*#__PURE__*/React__namespace.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24
  })), _path$a || (_path$a = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M20 17.5 31.5 24 20 30.5z"
  })));
};

var _path$9;
function _extends$h() { _extends$h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$h.apply(this, arguments); }
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60"
  }, props), _path$9 || (_path$9 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M0 30C0 13.4 13.4 0 30 0s30 13.4 30 30-13.4 30-30 30S0 46.6 0 30zm30.8 18.7V32H37l.7-5.9h-6.9v-5c0-1.7.4-2.7 2.6-2.7h4.2v-5.9s-1.9-.2-4.5-.2c-6.3 0-9.4 3.6-9.4 7.8v6h-4.3V32h4.3v16.7h7.1z"
  })));
};

var _path$8;
function _extends$g() { _extends$g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g.apply(this, arguments); }
var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$g({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60"
  }, props), _path$8 || (_path$8 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M0 30C0 13.4 13.4 0 30 0s30 13.4 30 30-13.4 30-30 30S0 46.6 0 30zm23.7-4.2c1.5-2 3.7-3.1 6.3-3.1s4.8 1.2 6.3 3.1h8.3v-8.2c0-1.3-1-2.3-2.3-2.3H17.7c-1.3 0-2.3 1-2.3 2.3v8.2h8.3zm18.6 18.8c1.3 0 2.3-1 2.3-2.3V29h-7c.1.4.1 1 .1 1.5 0 4.3-3.4 7.8-7.8 7.8s-7.8-3.4-7.8-7.8c0-.5.1-1 .1-1.5h-7v13.4c0 1.3 1 2.3 2.3 2.3h24.8v-.1zm-7.6-14.2c0-2.6-2.1-4.6-4.7-4.6s-4.7 2-4.7 4.6 2.1 4.7 4.7 4.7 4.7-2.1 4.7-4.7zm2.2-8.2V19c0-.5.4-1 1-1H41c.6 0 1 .4 1 1v3.1c0 .6-.4 1-1 1h-3.1c-.6.1-1-.3-1-.9z"
  })));
};

var _path$7;
function _extends$f() { _extends$f = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f.apply(this, arguments); }
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$f({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60"
  }, props), _path$7 || (_path$7 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M0 30C0 13.4 13.4 0 30 0s30 13.4 30 30-13.4 30-30 30S0 46.6 0 30zm30.5-5.8c0 .5 0 1.1.1 1.5-5.6-.3-10.6-3-14-7.1-.6 1-.9 2.2-.9 3.4 0 2.3 1.2 4.5 3 5.6-1.2-.1-2.1-.3-3.1-.9v.1c0 3.4 2.3 6.1 5.4 6.7-.6.1-1.2.2-1.8.2-.5 0-.9 0-1.2-.1.8 2.7 3.4 4.8 6.3 4.8-2.3 1.8-5.3 2.9-8.5 2.9-.5 0-1 0-1.5-.1 3 1.9 6.6 3.1 10.4 3.1C37.2 44.4 44 34 44 25v-.9c1.3-1 2.5-2.2 3.4-3.5-1.2.5-2.5.9-3.9 1.1 1.4-.9 2.5-2.2 3-3.8-1.3.8-2.8 1.3-4.3 1.6-1.2-1.3-3-2.1-5-2.1-3.8 0-6.7 3.1-6.7 6.8z"
  })));
};

var _defs$2, _g$4;
function _extends$e() { _extends$e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e.apply(this, arguments); }
var SvgAx = function SvgAx(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$e({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 480"
  }, props), _defs$2 || (_defs$2 = /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "ax_svg__a"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    fillOpacity: 0.7,
    d: "M106.3 0h1133.3v850H106.3z"
  })))), _g$4 || (_g$4 = /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#ax_svg__a)",
    transform: "matrix(.56472 0 0 .56482 -60 -.1)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#0053a5",
    d: "M0 0h1300v850H0z"
  }), /*#__PURE__*/React__namespace.createElement("g", {
    fill: "#ffce00"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M400 0h250v850H400z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M0 300h1300v250H0z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    fill: "#d21034"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M475 0h100v850H475z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M0 375h1300v100H0z"
  })))));
};

var _g$3;
function _extends$d() { _extends$d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d.apply(this, arguments); }
var SvgBr = function SvgBr(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$d({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 480"
  }, props), _g$3 || (_g$3 = /*#__PURE__*/React__namespace.createElement("g", {
    strokeWidth: "1pt"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#229e45",
    fillRule: "evenodd",
    d: "M0 0h640v480H0z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#f8e509",
    fillRule: "evenodd",
    d: "m321.4 436 301.5-195.7L319.6 44 17.1 240.7 321.4 436z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#2b49a3",
    fillRule: "evenodd",
    d: "M452.8 240c0 70.3-57.1 127.3-127.6 127.3A127.4 127.4 0 1 1 452.8 240z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#ffffef",
    fillRule: "evenodd",
    d: "m283.3 316.3-4-2.3-4 2 .9-4.5-3.2-3.4 4.5-.5 2.2-4 1.9 4.2 4.4.8-3.3 3m86 26.3-3.9-2.3-4 2 .8-4.5-3.1-3.3 4.5-.5 2.1-4.1 2 4.2 4.4.8-3.4 3.1m-36.2-30-3.4-2-3.5 1.8.8-3.9-2.8-2.9 4-.4 1.8-3.6 1.6 3.7 3.9.7-3 2.7m87-8.5-3.4-2-3.5 1.8.8-3.9-2.7-2.8 3.9-.4 1.8-3.5 1.6 3.6 3.8.7-2.9 2.6m-87.3-22-4-2.2-4 2 .8-4.6-3.1-3.3 4.5-.5 2.1-4.1 2 4.2 4.4.8-3.4 3.2m-104.6-35-4-2.2-4 2 1-4.6-3.3-3.3 4.6-.5 2-4.1 2 4.2 4.4.8-3.3 3.1m13.3 57.2-4-2.3-4 2 .9-4.5-3.2-3.3 4.5-.6 2.1-4 2 4.2 4.4.8-3.3 3.1m132-67.3-3.6-2-3.6 1.8.8-4-2.8-3 4-.5 1.9-3.6 1.7 3.8 4 .7-3 2.7m-6.7 38.3-2.7-1.6-2.9 1.4.6-3.2-2.2-2.3 3.2-.4 1.5-2.8 1.3 3 3 .5-2.2 2.2m-142.2 50.4-2.7-1.5-2.7 1.3.6-3-2.1-2.2 3-.4 1.4-2.7 1.3 2.8 3 .6-2.3 2M419 299.8l-2.2-1.1-2.2 1 .5-2.3-1.7-1.6 2.4-.3 1.2-2 1 2 2.5.5-1.9 1.5"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#ffffef",
    fillRule: "evenodd",
    d: "m219.3 287.6-2.7-1.5-2.7 1.3.6-3-2.1-2.2 3-.4 1.4-2.7 1.3 2.8 3 .6-2.3 2"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#ffffef",
    fillRule: "evenodd",
    d: "m219.3 287.6-2.7-1.5-2.7 1.3.6-3-2.1-2.2 3-.4 1.4-2.7 1.3 2.8 3 .6-2.3 2m42.3 3-2.6-1.4-2.7 1.3.6-3-2.1-2.2 3-.4 1.4-2.7 1.3 2.8 3 .5-2.3 2.1m-4.8 17-2.6-1.5-2.7 1.4.6-3-2.1-2.3 3-.4 1.4-2.7 1.3 2.8 3 .6-2.3 2m87.4-22.2-2.6-1.6-2.8 1.4.6-3-2-2.3 3-.3 1.4-2.7 1.2 2.8 3 .5-2.2 2.1m-25.1 3-2.7-1.5-2.7 1.4.6-3-2-2.3 3-.3 1.4-2.8 1.2 2.9 3 .5-2.2 2.1m-68.8-5.8-1.7-1-1.7.8.4-1.9-1.3-1.4 1.9-.2.8-1.7.8 1.8 1.9.3-1.4 1.3m167.8 45.4-2.6-1.5-2.7 1.4.6-3-2.1-2.3 3-.4 1.4-2.7 1.3 2.8 3 .6-2.3 2m-20.8 6-2.2-1.4-2.3 1.2.5-2.6-1.7-1.8 2.5-.3 1.2-2.3 1 2.4 2.5.4-1.9 1.8m10.4 2.3-2-1.2-2.1 1 .4-2.3-1.6-1.7 2.3-.3 1.1-2 1 2 2.3.5-1.7 1.6m29.1-22.8-2-1-2 1 .5-2.3-1.6-1.7 2.3-.3 1-2 1 2.1 2.1.4-1.6 1.6m-38.8 41.8-2.5-1.4-2.7 1.2.6-2.8-2-2 3-.3 1.3-2.5 1.2 2.6 3 .5-2.3 1.9m.6 14.2-2.4-1.4-2.4 1.3.6-2.8-1.9-2 2.7-.4 1.2-2.5 1.1 2.6 2.7.5-2 2m-19-23.1-1.9-1.2-2 1 .4-2.2-1.5-1.7 2.2-.2 1-2 1 2 2.2.4-1.6 1.6m-17.8 2.3-2-1.2-2 1 .5-2.2-1.6-1.7 2.3-.2 1-2 1 2 2.1.4-1.6 1.6m-30.4-24.6-2-1.1-2 1 .5-2.3-1.6-1.6 2.2-.3 1-2 1 2 2.2.5-1.6 1.5m3.7 57-1.6-.9-1.8.9.4-2-1.3-1.4 1.9-.2.9-1.7.8 1.8 1.9.3-1.4 1.3m-46.2-86.6-4-2.3-4 2 .9-4.5-3.2-3.3 4.5-.6 2.2-4 1.9 4.2 4.4.8-3.3 3.1"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M444.4 285.8a124.6 124.6 0 0 0 5.8-19.8c-67.8-59.5-143.3-90-238.7-83.7a124.5 124.5 0 0 0-8.5 20.9c113-10.8 196 39.2 241.4 82.6z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#309e3a",
    d: "m414 252.4 2.3 1.3a3.4 3.4 0 0 0-.3 2.2 3 3 0 0 0 1.4 1.7c.7.5 1.4.8 2 .7.6 0 1-.3 1.3-.7a1.3 1.3 0 0 0 .2-.9 2.3 2.3 0 0 0-.5-1c-.2-.3-.7-1-1.5-1.8a7.7 7.7 0 0 1-1.8-3 3.7 3.7 0 0 1 2-4.4 3.8 3.8 0 0 1 2.3-.2 7 7 0 0 1 2.6 1.2c1.4 1 2.3 2 2.6 3.2a4.1 4.1 0 0 1-.6 3.3l-2.4-1.5c.3-.6.4-1.2.2-1.7-.1-.5-.5-1-1.2-1.4a3.2 3.2 0 0 0-1.8-.7 1 1 0 0 0-.9.5c-.2.3-.2.6-.1 1s.6 1.2 1.6 2.2c1 1 1.6 1.9 2 2.5a3.9 3.9 0 0 1-.3 4.2 4.1 4.1 0 0 1-1.9 1.5 4 4 0 0 1-2.4.3c-.9-.2-1.8-.6-2.8-1.3-1.5-1-2.4-2.1-2.7-3.3a5.4 5.4 0 0 1 .6-4zm-11.6-7.6 2.5 1.3a3.4 3.4 0 0 0-.2 2.2 3 3 0 0 0 1.4 1.6c.8.5 1.4.7 2 .6.6 0 1-.3 1.3-.8a1.3 1.3 0 0 0 .2-.8c0-.3-.2-.7-.5-1a34.6 34.6 0 0 0-1.6-1.8c-1.1-1.1-1.8-2-2-2.8a3.7 3.7 0 0 1 .4-3.1 3.6 3.6 0 0 1 1.6-1.4 3.8 3.8 0 0 1 2.2-.3 7 7 0 0 1 2.6 1c1.5 1 2.4 2 2.7 3.1a4.1 4.1 0 0 1-.4 3.4l-2.5-1.4c.3-.7.4-1.2.2-1.7s-.6-1-1.3-1.4a3.2 3.2 0 0 0-1.9-.6 1 1 0 0 0-.8.5c-.2.3-.2.6-.1 1s.7 1.2 1.7 2.2c1 1 1.7 1.8 2 2.4a3.9 3.9 0 0 1 0 4.2 4.2 4.2 0 0 1-1.8 1.6 4 4 0 0 1-2.4.3 8 8 0 0 1-2.9-1.1 6 6 0 0 1-2.8-3.2 5.4 5.4 0 0 1 .4-4zm-14.2-3.8 7.3-12 8.8 5.5-1.2 2-6.4-4-1.6 2.7 6 3.7-1.3 2-6-3.7-2 3.3 6.7 4-1.2 2-9-5.5zm-20.7-17 1.1-2 5.4 2.7-2.5 5c-.8.2-1.8.3-3 .2a9.4 9.4 0 0 1-3.3-1 7.7 7.7 0 0 1-3-2.6 6 6 0 0 1-1-3.5 8.6 8.6 0 0 1 1-3.7 8 8 0 0 1 2.6-3 6.2 6.2 0 0 1 3.6-1.1c1 0 2 .3 3.2 1 1.6.7 2.6 1.7 3.1 2.8a5 5 0 0 1 .3 3.5l-2.7-.8a3 3 0 0 0-.2-2c-.3-.6-.8-1-1.6-1.4a3.8 3.8 0 0 0-3.1-.3c-1 .3-1.9 1.2-2.6 2.6-.7 1.4-1 2.7-.7 3.8a3.7 3.7 0 0 0 2 2.4c.5.3 1.1.5 1.7.5a6 6 0 0 0 1.8 0l.8-1.6-2.9-1.5zm-90.2-22.3 2-14 4.2.7 1.1 9.8 3.9-9 4.2.6-2 13.8-2.7-.4 1.7-10.9-4.4 10.5-2.7-.4-1.1-11.3-1.6 11-2.6-.4zm-14.1-1.7 1.3-14 10.3 1-.2 2.4-7.5-.7-.3 3 7 .7-.3 2.4-7-.7-.3 3.8 7.8.7-.2 2.4-10.6-1z"
  }), /*#__PURE__*/React__namespace.createElement("g", {
    strokeOpacity: 0.5
  }, /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#309e3a",
    d: "M216.5 191.3c0-1.5.3-2.6.7-3.6a6.7 6.7 0 0 1 1.4-1.9 5.4 5.4 0 0 1 1.8-1.2c1-.3 2-.5 3-.5 2.1 0 3.7.8 5 2a7.4 7.4 0 0 1 1.6 5.5c0 2.2-.7 4-2 5.3a6.5 6.5 0 0 1-5 1.7 6.6 6.6 0 0 1-4.8-2 7.3 7.3 0 0 1-1.7-5.3z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#f7ffff",
    d: "M219.4 191.3c0 1.5.3 2.7 1 3.6.7.8 1.6 1.3 2.8 1.3a3.5 3.5 0 0 0 2.8-1.1c.7-.8 1-2 1.1-3.7 0-1.6-.2-2.8-1-3.6a3.5 3.5 0 0 0-2.7-1.3 3.6 3.6 0 0 0-2.8 1.2c-.8.8-1.1 2-1.2 3.6z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    strokeOpacity: 0.5
  }, /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#309e3a",
    d: "m233 198.5.2-14h6c1.5 0 2.5.2 3.2.5.7.2 1.2.7 1.6 1.3s.6 1.4.6 2.3a3.8 3.8 0 0 1-1 2.6 4.5 4.5 0 0 1-2.7 1.2l1.5 1.2c.4.4.9 1.2 1.5 2.3l1.7 2.8h-3.4l-2-3.2-1.4-2a2.1 2.1 0 0 0-.9-.6 5 5 0 0 0-1.4-.2h-.6v5.8H233z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#fff",
    d: "M236 190.5h2c1.4 0 2.3 0 2.6-.2.3 0 .6-.3.8-.5s.3-.7.3-1c0-.6-.1-1-.4-1.2-.2-.3-.6-.5-1-.6h-2l-2.3-.1v3.5z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    strokeOpacity: 0.5
  }, /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#309e3a",
    d: "m249 185.2 5.2.3c1.1 0 2 .1 2.6.3a4.7 4.7 0 0 1 2 1.4 6 6 0 0 1 1.2 2.4c.3.9.4 2 .3 3.3a9.3 9.3 0 0 1-.5 3c-.4 1-1 1.8-1.7 2.4a5 5 0 0 1-2 1c-.6.2-1.5.2-2.5.2l-5.3-.3.7-14z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#fff",
    d: "m251.7 187.7-.5 9.3h3.8c.5 0 .9-.2 1.2-.5.3-.3.6-.7.8-1.3.2-.6.4-1.5.4-2.6l-.1-2.5a3.2 3.2 0 0 0-.8-1.4 2.7 2.7 0 0 0-1.2-.7 13 13 0 0 0-2.3-.3h-1.3z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    strokeOpacity: 0.5
  }, /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#309e3a",
    d: "m317.6 210.2 3.3-13.6 4.4 1 3.2 1c.7.4 1.3 1 1.6 1.9.4.8.4 1.7.2 2.8-.2.8-.5 1.5-1 2a3.9 3.9 0 0 1-3 1.4c-.7 0-1.7-.2-3-.5l-1.7-.5-1.2 5.2-2.8-.7z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#fff",
    d: "m323 199.6-.8 3.8 1.5.4c1 .2 1.8.4 2.2.3a1.9 1.9 0 0 0 1.6-1.5c0-.5 0-.9-.2-1.3a2 2 0 0 0-1-.9l-1.9-.5-1.3-.3z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    strokeOpacity: 0.5
  }, /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#309e3a",
    d: "m330.6 214.1 4.7-13.2 5.5 2c1.5.5 2.4 1 3 1.4.5.5.9 1 1 1.8s.2 1.5 0 2.3c-.4 1-1 1.7-1.8 2.2-.8.4-1.8.5-3 .3.4.5.8 1 1 1.6l.8 2.7.6 3.1-3.1-1.1-1-3.6a19.5 19.5 0 0 0-.7-2.4 2.1 2.1 0 0 0-.6-.8c-.2-.3-.6-.5-1.3-.7l-.5-.2-2 5.6-2.6-1z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#fff",
    d: "m336 207.4 1.9.7c1.3.5 2.1.7 2.5.7.3 0 .6 0 .9-.3.3-.2.5-.5.6-.9.2-.4.2-.8 0-1.2a1.7 1.7 0 0 0-.8-.9l-2-.7-2-.7-1.2 3.3z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    strokeOpacity: 0.5
  }, /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#309e3a",
    d: "M347 213.6a9 9 0 0 1 1.7-3.2 6.6 6.6 0 0 1 1.8-1.5 6 6 0 0 1 2-.7c1 0 2 0 3.1.4a6.5 6.5 0 0 1 4.2 3.3c.8 1.6.8 3.5.2 5.7a7.4 7.4 0 0 1-3.4 4.5c-1.5.9-3.3 1-5.2.4a6.6 6.6 0 0 1-4.2-3.3 7.3 7.3 0 0 1-.2-5.6z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#fff",
    d: "M349.8 214.4c-.4 1.5-.5 2.8 0 3.8s1.2 1.6 2.3 2c1 .3 2 .2 3-.4 1-.5 1.6-1.6 2.1-3.2.5-1.5.5-2.7 0-3.7a3.5 3.5 0 0 0-2.2-2 3.6 3.6 0 0 0-3 .3c-1 .6-1.7 1.6-2.2 3.2z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    strokeOpacity: 0.5
  }, /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#309e3a",
    d: "m374.3 233.1 6.4-12.4 5.3 2.7a10 10 0 0 1 2.7 1.9c.5.5.8 1.1.8 1.9s0 1.5-.4 2.2a3.8 3.8 0 0 1-2 2c-1 .2-2 .2-3.1-.2.4.6.6 1.2.8 1.7.2.6.3 1.5.4 2.8l.2 3.2-3-1.5-.4-3.7a20 20 0 0 0-.3-2.5 2 2 0 0 0-.5-1l-1.2-.7-.5-.3-2.7 5.2-2.5-1.3z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#fff",
    d: "m380.5 227.2 1.9 1c1.2.6 2 1 2.3 1 .3 0 .7 0 1-.2.3-.1.5-.4.7-.8.2-.4.3-.8.2-1.2a2 2 0 0 0-.7-1 23.7 23.7 0 0 0-1.8-1l-2-1-1.6 3.2z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    strokeOpacity: 0.5
  }, /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#309e3a",
    d: "M426.1 258.7a8.9 8.9 0 0 1 2.5-2.6 6.6 6.6 0 0 1 2.2-.9 5.5 5.5 0 0 1 2.2 0c1 .2 1.9.6 2.8 1.2a6.6 6.6 0 0 1 3 4.4c.3 1.7-.2 3.6-1.4 5.5a7.3 7.3 0 0 1-4.5 3.3 6.5 6.5 0 0 1-5.2-1.1 6.6 6.6 0 0 1-3-4.4c-.3-1.8.2-3.6 1.4-5.4z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#fff",
    d: "M428.6 260.3c-1 1.3-1.3 2.5-1.1 3.6a3.6 3.6 0 0 0 1.6 2.5c1 .7 2 .9 3 .6 1-.3 2-1 2.9-2.4.9-1.4 1.3-2.6 1.1-3.6-.1-1-.7-1.9-1.6-2.6s-2-.8-3-.5c-1 .2-2 1-3 2.4z"
  })), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#309e3a",
    d: "m301.8 204.5 2.3-9.8 7.2 1.7-.3 1.6-5.3-1.2-.5 2.2 4.9 1.1-.4 1.7-4.9-1.2-.6 2.7 5.5 1.3-.4 1.6-7.5-1.7z"
  }))));
};

var _path$6, _path2$6, _path3$5;
function _extends$c() { _extends$c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c.apply(this, arguments); }
var SvgDk = function SvgDk(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$c({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 480"
  }, props), _path$6 || (_path$6 = /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#c8102e",
    d: "M0 0h640.1v480H0z"
  })), _path2$6 || (_path2$6 = /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#fff",
    d: "M205.7 0h68.6v480h-68.6z"
  })), _path3$5 || (_path3$5 = /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#fff",
    d: "M0 205.7h640.1v68.6H0z"
  })));
};

var _path$5, _path2$5, _path3$4;
function _extends$b() { _extends$b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }
var SvgDe = function SvgDe(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$b({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 480"
  }, props), _path$5 || (_path$5 = /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#ffce00",
    d: "M0 320h640v160H0z"
  })), _path2$5 || (_path2$5 = /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#050505",
    d: "M0 0h640v160H0z"
  })), _path3$4 || (_path3$4 = /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#d00",
    d: "M0 160h640v160H0z"
  })));
};

function _extends$a() { _extends$a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }
var SvgEs = function SvgEs(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$a({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 160 120"
    },
    viewBox: "0 0 160 120"
  }, props), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M0 0h160v120H0V0z",
    style: {
      fill: "#aa151b"
    }
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M0 30h160v60H0V30z",
    style: {
      fill: "#f1bf00"
    }
  }));
};

var _path$4, _path2$4, _path3$3;
function _extends$9() { _extends$9 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }
var SvgFi = function SvgFi(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$9({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 480"
  }, props), _path$4 || (_path$4 = /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#fff",
    d: "M0 0h640v480H0z"
  })), _path2$4 || (_path2$4 = /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#003580",
    d: "M0 174.5h640v131H0z"
  })), _path3$3 || (_path3$3 = /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#003580",
    d: "M175.5 0h130.9v480h-131z"
  })));
};

var _g$2;
function _extends$8() { _extends$8 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }
var SvgFr = function SvgFr(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$8({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 480"
  }, props), _g$2 || (_g$2 = /*#__PURE__*/React__namespace.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#fff",
    d: "M0 0h640v480H0z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#00267f",
    d: "M0 0h213.3v480H0z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#f31830",
    d: "M426.7 0H640v480H426.7z"
  }))));
};

var _path$3, _path2$3, _path3$2, _path4$1, _path5$1;
function _extends$7() { _extends$7 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }
var SvgGb = function SvgGb(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$7({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 480"
  }, props), _path$3 || (_path$3 = /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#012169",
    d: "M0 0h640v480H0z"
  })), _path2$3 || (_path2$3 = /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#FFF",
    d: "m75 0 244 181L562 0h78v62L400 241l240 178v61h-80L320 301 81 480H0v-60l239-178L0 64V0h75z"
  })), _path3$2 || (_path3$2 = /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#C8102E",
    d: "m424 281 216 159v40L369 281h55zm-184 20 6 35L54 480H0l240-179zM640 0v3L391 191l2-44L590 0h50zM0 0l239 176h-60L0 42V0z"
  })), _path4$1 || (_path4$1 = /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#FFF",
    d: "M241 0v480h160V0H241zM0 160v160h640V160H0z"
  })), _path5$1 || (_path5$1 = /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#C8102E",
    d: "M0 193v96h640v-96H0zM273 0v480h96V0h-96z"
  })));
};

var _g$1;
function _extends$6() { _extends$6 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }
var SvgIt = function SvgIt(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$6({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 480"
  }, props), _g$1 || (_g$1 = /*#__PURE__*/React__namespace.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#fff",
    d: "M0 0h640v480H0z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#009246",
    d: "M0 0h213.3v480H0z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#ce2b37",
    d: "M426.7 0H640v480H426.7z"
  }))));
};

var _image;
function _extends$5() { _extends$5 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }
var SvgMx = function SvgMx(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$5({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 160 120"
  }, props), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M106.68 0H160v120h-53.32V0Z",
    style: {
      fill: "#ce1126"
    }
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M53.33 0h53.35v120H53.33V0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M0 0h53.33v120H0V0Z",
    style: {
      fill: "#006847"
    }
  }), _image || (_image = /*#__PURE__*/React__namespace.createElement("image", {
    width: 82,
    height: 75,
    transform: "matrix(.5 0 0 .5 59.51 40.86)",
    xlinkHref: "data:image/jpeg;base64,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"
  })));
};

var _path$2, _path2$2, _path3$1;
function _extends$4() { _extends$4 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }
var SvgNl = function SvgNl(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$4({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 480"
  }, props), _path$2 || (_path$2 = /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#21468b",
    d: "M0 0h640v480H0z"
  })), _path2$2 || (_path2$2 = /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#fff",
    d: "M0 0h640v320H0z"
  })), _path3$1 || (_path3$1 = /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#ae1c28",
    d: "M0 0h640v160H0z"
  })));
};

var _path$1, _path2$1, _path3, _path4, _path5;
function _extends$3() { _extends$3 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }
var SvgNo = function SvgNo(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$3({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 480"
  }, props), _path$1 || (_path$1 = /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#ed2939",
    d: "M0 0h640v480H0z"
  })), _path2$1 || (_path2$1 = /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#fff",
    d: "M180 0h120v480H180z"
  })), _path3 || (_path3 = /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#fff",
    d: "M0 180h640v120H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#002664",
    d: "M210 0h60v480h-60z"
  })), _path5 || (_path5 = /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#002664",
    d: "M0 210h640v60H0z"
  })));
};

var _path, _path2;
function _extends$2() { _extends$2 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }
var SvgSct = function SvgSct(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 480"
  }, props), _path || (_path = /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#0065bd",
    d: "M0 0h640v480H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React__namespace.createElement("path", {
    stroke: "#fff",
    strokeWidth: 0.6,
    d: "m0 0 5 3M0 3l5-3",
    transform: "scale(128 160)"
  })));
};

var _defs$1, _g;
function _extends$1() { _extends$1 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }
var SvgSe = function SvgSe(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 480"
  }, props), _defs$1 || (_defs$1 = /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "se_svg__a"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    fillOpacity: 0.7,
    d: "M-53.4 0h682.6v512H-53.4z"
  })))), _g || (_g = /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#se_svg__a)",
    transform: "translate(50) scale(.9375)"
  }, /*#__PURE__*/React__namespace.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#006aa7",
    d: "M-121.1.3h256v204.8h-256zm0 306.9h256V512h-256z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#fecc00",
    d: "M-121.1 205h256v102.4h-256z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#fecc00",
    d: "M133.8 0h102.4v512H133.8z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#fecc00",
    d: "M233 205h460.8v102.4H233z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#006aa7",
    d: "M236.2 307.2H697V512H236.2zm0-306.9H697v204.8H236.2z"
  })))));
};

var _defs, _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _use10, _use11, _use12, _use13, _use14, _use15, _use16, _use17, _use18, _use19, _use20, _use21, _use22, _use23, _use24, _use25, _use26, _use27, _use28, _use29, _use30, _use31, _use32, _use33, _use34, _use35, _use36, _use37, _use38, _use39, _use40, _use41, _use42, _use43, _use44, _use45, _use46, _use47, _use48, _use49, _use50;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgUs = function SvgUs(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 480"
  }, props), _defs || (_defs = /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("use", {
    id: "us_svg__b",
    href: "#us_svg__a"
  }), /*#__PURE__*/React__namespace.createElement("use", {
    id: "us_svg__h",
    href: "#us_svg__a"
  }), /*#__PURE__*/React__namespace.createElement("use", {
    id: "us_svg__c",
    href: "#us_svg__a"
  }), /*#__PURE__*/React__namespace.createElement("use", {
    id: "us_svg__j",
    href: "#us_svg__a"
  }), /*#__PURE__*/React__namespace.createElement("use", {
    id: "us_svg__i",
    href: "#us_svg__a"
  }), /*#__PURE__*/React__namespace.createElement("use", {
    id: "us_svg__k",
    href: "#us_svg__a"
  }), /*#__PURE__*/React__namespace.createElement("use", {
    id: "us_svg__f",
    href: "#us_svg__a"
  }), /*#__PURE__*/React__namespace.createElement("use", {
    id: "us_svg__g",
    href: "#us_svg__a"
  }), /*#__PURE__*/React__namespace.createElement("use", {
    id: "us_svg__d",
    href: "#us_svg__a"
  }), /*#__PURE__*/React__namespace.createElement("use", {
    id: "us_svg__l",
    href: "#us_svg__a"
  }), /*#__PURE__*/React__namespace.createElement("use", {
    id: "us_svg__m",
    href: "#us_svg__a"
  }), /*#__PURE__*/React__namespace.createElement("use", {
    id: "us_svg__e",
    href: "#us_svg__a"
  }), /*#__PURE__*/React__namespace.createElement("image", {
    id: "us_svg__a",
    width: 30,
    height: 28,
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAdCAYAAABSZrcyAAAACXBIWXMAAAsSAAALEgHS3X78AAABZ0lEQVRIicWWPUvDUBSGT8RVCAiu9ReUTE76B6RDt64OoYO49He4dVZHJ8HBxUEUobMIBXFQRCehDiIUNdQ+DrlqGpP05t58vGNy3vc599xwiIihgHVTr7WAG2CzLvgEuKwD3CXUuA74gD95VcODCPykSnCbWb1VCT/lv6oZPfCRAD+oAhwf+Y9eTPIWgY6ILInInUb9TsrzZcDXzPBE5NhxnEcBfOAz5URl6B5o/LYCuMBtydApsJ86D2C3JPArsDH3QgBPFRelc8DV+BZmruHCEhoA29rQhCa2gHcD8ANFLB7Ca5jmAD/pZi9o1KyKiJOj35UctdkCrgzG3i4C7BqAAQY6+fPG7me8OxORUcq7NR14pkjeegHQitQcpZy+awNOGvmQhIUBtIBxrPbaBt6PBE2Ankazw1gD+pstFjZSAc9AM4evB3wpb98E3FTmw9zm0N9QzWsvnKi5Q/iTYSVgzzajNH0D8tcz3NSfMrwAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M0 0h640v480H0z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M0 0h640v36.16H0zm0 74.67h640v36.16H0zm0 73.06h640v36.16H0zm0 74.67h640v36.16H0zM0 296h640v36.16H0zm0 73.07h640v36.16H0zm0 74.66h640v36.16H0z",
    style: {
      fill: "#b41f30"
    }
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M0 0h364.8v258.45H0z",
    style: {
      fill: "#113d96"
    }
  }), _use || (_use = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__a",
    transform: "translate(46 36)"
  })), _use2 || (_use2 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__a",
    transform: "translate(107 36)"
  })), _use3 || (_use3 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__a",
    transform: "translate(168 36)"
  })), _use4 || (_use4 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__a",
    transform: "translate(228 36)"
  })), _use5 || (_use5 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__a",
    transform: "translate(289 36)"
  })), _use6 || (_use6 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__b",
    transform: "translate(76.1 10.07)"
  })), _use7 || (_use7 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__c",
    transform: "translate(137.1 10.07)"
  })), _use8 || (_use8 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__d",
    transform: "translate(198.1 10.07)"
  })), _use9 || (_use9 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__e",
    transform: "translate(258.1 10.07)"
  })), _use10 || (_use10 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__f",
    transform: "translate(319.1 10.07)"
  })), _use11 || (_use11 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__a",
    transform: "translate(16 11)"
  })), _use12 || (_use12 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__g",
    transform: "translate(45.78 87.03)"
  })), _use13 || (_use13 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__h",
    transform: "translate(106.78 87.03)"
  })), _use14 || (_use14 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__i",
    transform: "translate(167.78 87.03)"
  })), _use15 || (_use15 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__j",
    transform: "translate(227.78 87.03)"
  })), _use16 || (_use16 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__k",
    transform: "translate(288.78 87.03)"
  })), _use17 || (_use17 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__g",
    transform: "translate(75.88 61.1)"
  })), _use18 || (_use18 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__h",
    transform: "translate(136.88 61.1)"
  })), _use19 || (_use19 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__i",
    transform: "translate(197.88 61.1)"
  })), _use20 || (_use20 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__j",
    transform: "translate(257.88 61.1)"
  })), _use21 || (_use21 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__k",
    transform: "translate(318.88 61.1)"
  })), _use22 || (_use22 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__l",
    transform: "translate(15.78 62.03)"
  })), _use23 || (_use23 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__b",
    transform: "translate(46.12 139.37)"
  })), _use24 || (_use24 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__c",
    transform: "translate(107.12 139.37)"
  })), _use25 || (_use25 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__d",
    transform: "translate(168.12 139.37)"
  })), _use26 || (_use26 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__e",
    transform: "translate(228.12 139.37)"
  })), _use27 || (_use27 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__f",
    transform: "translate(289.12 139.37)"
  })), _use28 || (_use28 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__b",
    transform: "translate(76.22 113.43)"
  })), _use29 || (_use29 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__c",
    transform: "translate(137.22 113.43)"
  })), _use30 || (_use30 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__d",
    transform: "translate(198.22 113.43)"
  })), _use31 || (_use31 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__e",
    transform: "translate(258.22 113.43)"
  })), _use32 || (_use32 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__f",
    transform: "translate(319.22 113.43)"
  })), _use33 || (_use33 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__m",
    transform: "translate(16.12 114.37)"
  })), _use34 || (_use34 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__g",
    transform: "translate(45.78 190.5)"
  })), _use35 || (_use35 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__h",
    transform: "translate(106.78 190.5)"
  })), _use36 || (_use36 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__i",
    transform: "translate(167.78 190.5)"
  })), _use37 || (_use37 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__j",
    transform: "translate(227.78 190.5)"
  })), _use38 || (_use38 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__k",
    transform: "translate(288.78 190.5)"
  })), _use39 || (_use39 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__a",
    transform: "translate(75.88 164.57)"
  })), _use40 || (_use40 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__a",
    transform: "translate(136.88 164.57)"
  })), _use41 || (_use41 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__a",
    transform: "translate(197.88 164.57)"
  })), _use42 || (_use42 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__a",
    transform: "translate(257.88 164.57)"
  })), _use43 || (_use43 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__a",
    transform: "translate(318.88 164.57)"
  })), _use44 || (_use44 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__l",
    transform: "translate(15.78 165.5)"
  })), _use45 || (_use45 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__b",
    transform: "translate(76.15 216.4)"
  })), _use46 || (_use46 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__c",
    transform: "translate(137.15 216.4)"
  })), _use47 || (_use47 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__d",
    transform: "translate(198.15 216.4)"
  })), _use48 || (_use48 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__e",
    transform: "translate(258.15 216.4)"
  })), _use49 || (_use49 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__f",
    transform: "translate(319.15 216.4)"
  })), _use50 || (_use50 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__m",
    transform: "translate(16.05 217.33)"
  })));
};

var icons = {
    AlertCircle: SvgAlertCircle,
    ArrowRight: SvgArrowRight,
    ArrowRightOtto: SvgArrowRightOtto,
    Bank: SvgBank,
    BarDiagram: SvgBarDiagram,
    Bulb: SvgBulb,
    CardReader: SvgCardReader,
    Chat: SvgChat,
    Checkmark: SvgCheckmark,
    Cross: SvgCross,
    Edit: SvgEdit,
    Email: SvgEmail,
    ExternalLink: SvgExternalLink,
    Headphones: SvgHeadphones,
    IconDownChevron: SvgIconDownChevronS,
    IconDownChevronM: SvgIconDownChevronM,
    IconRightChevron: SvgIconRightChevron,
    LogoPayPalPrimaryPositive: SvgPrimaryPositive,
    LogoPayPalPrimaryNegetive: SvgPrimaryNegative,
    LogoPayPalPrimaryPositiveOneline: SvgOnelinePrimaryPositive,
    PlayVideo: SvgPlayVideo,
    Menu: SvgMenu,
    Minus: SvgMinus,
    Phone: SvgPhone,
    Play: SvgPlay,
    Plus: SvgPlus,
    Sad: SvgSad,
    Search: SvgSearch,
    Settings: SvgSettings,
    Sliders: SvgSliders,
    Smile: SvgSmile,
    Neutral: SvgNeutral,
    Star: SvgStar,
    Circle: SvgCircle,
    Facebook: SvgFacebook,
    Instagram: SvgInstagram,
    Twitter: SvgTwitter,
    FlagAx: SvgAx,
    FlagBr: SvgBr,
    FlagDe: SvgDe,
    FlagDk: SvgDk,
    FlagEs: SvgEs,
    FlagFi: SvgFi,
    FlagFr: SvgFr,
    FlagGb: SvgGb,
    FlagIt: SvgIt,
    FlagMx: SvgMx,
    FlagNo: SvgNo,
    FlagNl: SvgNl,
    FlagSct: SvgSct,
    FlagSe: SvgSe,
    FlagUs: SvgUs
};

var css$11 = {"icon":"styles_icon__-PHBS"};

var Svg = function (_a) {
    var name = _a.name, className = _a.className, ariaHidden = _a.ariaHidden, ariaLabel = _a.ariaLabel;
    var svgClasses = classNames__default.default(css$11.icon, className);
    var Icon = icons[name] || null;
    var ariaLabelAttr = ariaLabel ? { 'aria-label': ariaLabel } : undefined;
    var ariaHiddenAttr = ariaHidden || !ariaLabel ? { 'aria-hidden': true } : undefined;
    var roleImgAttr = ariaLabel ? { role: 'img' } : undefined;
    return (React__namespace.default.createElement("span", { className: svgClasses }, Icon && React__namespace.default.createElement(Icon, __assign({}, ariaHiddenAttr, ariaLabelAttr, roleImgAttr))));
};

var css$10 = {"imageContainer":"styles_imageContainer__y2Nds","image":"styles_image__9UhmU","default":"styles_default__UgSq8","twoImageContainer":"styles_twoImageContainer__fojvC","imageOne":"styles_imageOne__lXTht","imageTwo":"styles_imageTwo__azcBJ","threeImageContainer":"styles_threeImageContainer__sOM4D","sectionOne":"styles_sectionOne__dpwJm","sectionTwo":"styles_sectionTwo__86EPp","imageThree":"styles_imageThree__DSyPf","fourImageContainer":"styles_fourImageContainer__ZNw4t","columnOne":"styles_columnOne__04OZL","columnTwo":"styles_columnTwo__LimvC","row":"styles_row__ou-47","imageFour":"styles_imageFour__RA3OA"};

var ImageCluster = function (_a) {
    var _b = _a.image1, image1 = _b === void 0 ? [] : _b, _c = _a.image2, image2 = _c === void 0 ? [] : _c, _d = _a.image3, image3 = _d === void 0 ? [] : _d, _e = _a.image4, image4 = _e === void 0 ? [] : _e, _f = _a.classes, classes = _f === void 0 ? [] : _f, _editable = _a._editable;
    var filteredImages = [image1, image2, image3, image4].filter(function (image) { var _a; return checkImage((_a = image[0]) === null || _a === void 0 ? void 0 : _a.asset); });
    var Image = function (_a) {
        var _b, _c;
        var image = _a.image;
        var hasImageResizing = !!((_b = image[0]) === null || _b === void 0 ? void 0 : _b.cropAlignment);
        var hasImage = checkImage((_c = image[0]) === null || _c === void 0 ? void 0 : _c.asset);
        if (hasImageResizing) {
            return (React__namespace.default.createElement(React__namespace.default.Fragment, null, (_editable && validateBreakpointCollection(image)) ||
                image.map(function (imgResized, index) { return (React__namespace.default.createElement(ImgResized, __assign({ className: css$10.image }, imgResized, { key: imgResized._uid + String(index) }))); })));
        }
        else if (hasImage) {
            return (React__namespace.default.createElement(AdvanceImage, __assign({ className: css$10.image }, image[0].asset, { src: image[0].asset.image, key: image[0]._uid })));
        }
        return null;
    };
    var getClusterVersion = function () {
        switch (filteredImages.length) {
            case 1:
                return (React__namespace.default.createElement("div", { className: classNames__default.default(css$10.imageContainer, classes[1]) },
                    React__namespace.default.createElement(Image, { image: filteredImages[0] })));
            case 2:
                return (React__namespace.default.createElement("div", { className: classNames__default.default(css$10.imageContainer, css$10.twoImageContainer, classes[2]) },
                    React__namespace.default.createElement("div", { className: css$10.imageOne },
                        React__namespace.default.createElement(Image, { image: filteredImages[0] })),
                    React__namespace.default.createElement("div", { className: css$10.imageTwo },
                        React__namespace.default.createElement(Image, { image: filteredImages[1] }))));
            case 3:
                return (React__namespace.default.createElement("div", { className: classNames__default.default(css$10.imageContainer, css$10.threeImageContainer, classes[3]) },
                    React__namespace.default.createElement("div", { className: css$10.sectionOne },
                        React__namespace.default.createElement("div", { className: css$10.imageOne },
                            React__namespace.default.createElement(Image, { image: filteredImages[0] }))),
                    React__namespace.default.createElement("div", { className: css$10.sectionTwo },
                        React__namespace.default.createElement("div", { className: css$10.imageTwo },
                            React__namespace.default.createElement(Image, { image: filteredImages[1] })),
                        React__namespace.default.createElement("div", { className: css$10.imageThree },
                            React__namespace.default.createElement(Image, { image: filteredImages[2] })))));
            case 4:
                return (React__namespace.default.createElement("div", { className: classNames__default.default(css$10.imageContainer, css$10.fourImageContainer, classes[4]) },
                    React__namespace.default.createElement("div", { className: css$10.columnOne },
                        React__namespace.default.createElement("div", { className: css$10.imageOne },
                            React__namespace.default.createElement(Image, { image: filteredImages[0] }))),
                    React__namespace.default.createElement("div", { className: css$10.columnTwo },
                        React__namespace.default.createElement("div", { className: css$10.row },
                            React__namespace.default.createElement("div", { className: css$10.imageTwo },
                                React__namespace.default.createElement(Image, { image: filteredImages[1] })),
                            React__namespace.default.createElement("div", { className: css$10.imageThree },
                                React__namespace.default.createElement(Image, { image: filteredImages[2] }))),
                        React__namespace.default.createElement("div", { className: css$10.imageFour },
                            React__namespace.default.createElement(Image, { image: filteredImages[3] })))));
            default:
                return (React__namespace.default.createElement("div", { className: classNames__default.default(css$10.imageContainer, classes[0]) },
                    React__namespace.default.createElement("div", { className: css$10.default })));
        }
    };
    return getClusterVersion();
};

var css$$ = {"clusterContainer":"styles_clusterContainer__Hv0JV","one":"styles_one__DUiTX","two":"styles_two__ZesLc","three":"styles_three__dC-vj","four":"styles_four__HKA9r"};

var ImageSection = function (_a) {
    var imageCluster = _a.imageCluster, layout = _a.layout, rest = __rest(_a, ["imageCluster", "layout"]);
    var classes = ['', css$$.one, css$$.two, css$$.three, css$$.four];
    return (React__namespace.default.createElement(ContainerLayout, __assign({}, layout[0], react.storyblokEditable(rest)),
        React__namespace.default.createElement("div", { className: css$$.clusterContainer }, (imageCluster === null || imageCluster === void 0 ? void 0 : imageCluster[0]) && (React__namespace.default.createElement(ImageCluster, __assign({}, imageCluster[0], { classes: classes }))))));
};

var ImageStatic = function (_a) {
    var asset = _a.asset, rest = __rest(_a, ["asset"]);
    return (React__namespace.default.createElement("section", { style: { width: '100%' } }, checkImage(asset) ? (React__namespace.default.createElement(Img, __assign({}, rest, { src: asset.image, isStatic: true }))) : (React__namespace.default.createElement("div", { style: { backgroundColor: '#f8f8f8', width: '100%' } }, "Select image..."))));
};

var ActiveStoryContext = React.createContext({
    activeStory: '',
    /* eslint-disable @typescript-eslint/no-empty-function */
    setActiveStory: function () { }
});
var ActiveStoryContextProvider = function (_a) {
    var initialActiveStory = _a.initialActiveStory, children = _a.children;
    var _b = React.useState(initialActiveStory), activeStory = _b[0], setActiveStory = _b[1];
    return (React__namespace.default.createElement(ActiveStoryContext.Provider, { value: {
            activeStory: activeStory,
            setActiveStory: setActiveStory
        } }, children));
};

var NavigationTreeContext = React.createContext({
    activeCategories: [],
    /* eslint-disable @typescript-eslint/no-empty-function */
    setActiveCategories: function () { },
    categoryInteraction: {
        _uid: '',
        level: 0
    },
    /* eslint-disable @typescript-eslint/no-empty-function */
    setCategoryInteraction: function () { },
    initialOpen: true,
    closeOthers: false,
    isMobile: false,
    isMobileExpanded: false,
    isExpandingMenuOpen: false,
    isMegaMenuOpen: undefined,
    treeHeight: 0,
    /* eslint-disable @typescript-eslint/no-empty-function */
    setTreeHeight: function () { },
    /* eslint-disable @typescript-eslint/no-empty-function */
    setClickedCategory: function () { },
    clickedCategory: '',
    /* eslint-disable @typescript-eslint/no-empty-function */
    setIsFixed: function () { },
    isFixed: false
});
var NavigationTreeContextProvider = function (_a) {
    var initialOpen = _a.initialOpen, closeOthers = _a.closeOthers, initialActiveCategories = _a.initialActiveCategories, children = _a.children, isMobile = _a.isMobile, isMobileExpanded = _a.isMobileExpanded, isMegaMenuOpen = _a.isMegaMenuOpen, isExpandingMenuOpen = _a.isExpandingMenuOpen;
    var _b = React.useState(initialActiveCategories || []), activeCategories = _b[0], setActiveCategories = _b[1];
    var _c = React.useState({
        _uid: '',
        level: 0
    }), categoryInteraction = _c[0], setCategoryInteraction = _c[1];
    var _d = React.useState(0), treeHeight = _d[0], setTreeHeight = _d[1];
    var _e = React.useState(''), clickedCategory = _e[0], setClickedCategory = _e[1];
    var _f = React.useState(false), isFixed = _f[0], setIsFixed = _f[1];
    return (React__namespace.default.createElement(NavigationTreeContext.Provider, { value: {
            activeCategories: activeCategories,
            setActiveCategories: setActiveCategories,
            categoryInteraction: categoryInteraction,
            setCategoryInteraction: setCategoryInteraction,
            initialOpen: initialOpen,
            closeOthers: closeOthers,
            isMobile: isMobile,
            isMobileExpanded: isMobileExpanded,
            isExpandingMenuOpen: isExpandingMenuOpen,
            isMegaMenuOpen: isMegaMenuOpen,
            treeHeight: treeHeight,
            setTreeHeight: setTreeHeight,
            setClickedCategory: setClickedCategory,
            clickedCategory: clickedCategory,
            isFixed: isFixed,
            setIsFixed: setIsFixed
        } }, children));
};

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
var isNonEmptyArray = function (el) {
    return Array.isArray(el) && el.length > 0;
};

var isCategory = function (element) { return element.component === 'navigation-group'; };
var isPage = function (element) { return element.component === 'navigation-item'; };
function hasCategories(component) {
    if (isCategory(component)) {
        return component.body.find(function (child) { return isCategory(child); }) !== undefined;
    }
    return false;
}
function hasPages(component) {
    if (isCategory(component)) {
        return component.body.find(function (child) { return isPage(child); }) !== undefined;
    }
    return false;
}
var storyUuidMatch = function (uuid, linkId) {
    return uuid === linkId;
};
var hasPage = function (category, uuid) {
    if (!hasPages(category))
        return false;
    var match = category.body.find(function (component) {
        if (isPage(component)) {
            return storyUuidMatch(uuid, component.link.id);
        }
    });
    return match !== undefined;
};
/**
 * Find category ids of active path
 *
 * * Returns nested category ids that lead to an active path.
 * * Returns an empty array if there are no active categories.
 * * Uses Array.some() to stop recursion once a match is found.
 */
var findCatIds = function (categories, catIds, activeStory) {
    var containsActivePage = categories.some(function (category) {
        if (hasPage(category, activeStory)) {
            catIds.push(category._uid);
            return true;
        }
        if (hasCategories(category)) {
            catIds.push(category._uid);
            var subCategories = category.body.filter(isCategory);
            return isNonEmptyArray(findCatIds(subCategories, catIds, activeStory));
        }
        return false;
    });
    if (containsActivePage)
        return catIds;
    return [];
};
/**
 * Find parent category ids of the active page
 */
var findActiveCategories = function (menu, activeStory) {
    var catIds = [];
    menu.some(function (category) {
        if (!category.body) {
            return false;
        }
        var subCategories = category.body.filter(isCategory);
        // Reset category id search for each top-level category
        catIds = findCatIds(subCategories, [], activeStory);
        if (isNonEmptyArray(catIds) || hasPage(category, activeStory)) {
            catIds.unshift(category._uid);
        }
        return isNonEmptyArray(catIds);
    });
    return catIds;
};

var updateHtml = function (input, selectorUpdaterMap) {
    if (!input) {
        return input;
    }
    var updaters = Object.entries(selectorUpdaterMap);
    var document = htmlparser2.parseDocument(input);
    if (!document) {
        return input;
    }
    var _loop_1 = function (selector, updater) {
        cssSelect.selectAll(selector, document).forEach(function (element) {
            if (domhandler.isTag(element)) {
                var updated = updater(element);
                if (updated != null && updated != element) {
                    if (typeof updated === 'string') {
                        domutils.replaceElement(element, htmlparser2.parseDocument(updated));
                    }
                    else {
                        domutils.replaceElement(element, updated);
                    }
                }
            }
        });
    };
    for (var _i = 0, updaters_1 = updaters; _i < updaters_1.length; _i++) {
        var _a = updaters_1[_i], selector = _a[0], updater = _a[1];
        _loop_1(selector, updater);
    }
    return domSerializer.render(document, {
        emptyAttrs: false,
        selfClosingTags: true
    });
};

var _a$2, _b, _c, _d;
var wrapTables = function (className) {
    var _a;
    return (_a = {},
        _a['table'] = function (table) {
            var _a;
            return new domhandler.Element('div', (_a = {}, _a['class'] = className, _a), [table]);
        },
        _a);
};
var setLinksHidden = (_a$2 = {},
    _a$2['a:not([tabindex])'] = function (anchorElem) {
        var _a;
        return new domhandler.Element('a', __assign(__assign({}, anchorElem.attribs), (_a = {}, _a['tabindex'] = '-1', _a['aria-hidden'] = 'true', _a)), domutils.getChildren(anchorElem));
    },
    _a$2);
var setLinksRel = (_b = {},
    _b['a:not([rel])'] = function (anchorElem) {
        var _a;
        var _b;
        return new domhandler.Element('a', ((_b = anchorElem.attribs.href) === null || _b === void 0 ? void 0 : _b.includes('www.zettle.com'))
            ? anchorElem.attribs
            : __assign(__assign({}, anchorElem.attribs), (_a = {}, _a['rel'] = 'noopener', _a)), domutils.getChildren(anchorElem));
    },
    _b);
(_c = {},
    _c['table'] = function (table) {
        var _a;
        return new domhandler.Element('div', (_a = {}, _a['class'] = 'table-responsive', _a), [table]);
    },
    _c);
var extractPx = function (value) {
    if (value.indexOf('px') >= 0 || /^\d+$/.test(value)) {
        return parseInt(value);
    }
    return false;
};
var getIframeAspectRatio = function (iframe) {
    var _a, _b;
    var height = extractPx((_a = domutils.getAttributeValue(iframe, 'height')) !== null && _a !== void 0 ? _a : '');
    var width = extractPx((_b = domutils.getAttributeValue(iframe, 'width')) !== null && _b !== void 0 ? _b : '');
    return height && width ? width / height : 1 / 0.5625;
};
var setIframeAspectRatio = (_d = {},
    _d['iframe'] = function (iframe) {
        var _a;
        return new domhandler.Element('div', (_a = {}, _a['style'] = "--aspect-ratio: ".concat(getIframeAspectRatio(iframe), ";"), _a), [iframe]);
    },
    _d);
var setLinkStyle = function (classNames) {
    var _a;
    return (_a = {},
        _a[[
            "a[href]",
            ":not(.styled-button)",
            ":not(.styled-link)",
            ":not(.btn)",
            ":not([class^=\"styles_\"])",
            ":not([class*=\" styles_\"])"
        ].join('')] = function (anchorElem) {
            var _a;
            return new domhandler.Element('a', __assign(__assign({}, anchorElem.attribs), (_a = {}, _a['class'] = classNames, _a)), domutils.getChildren(anchorElem));
        },
        _a);
};

var Html = function (_a) {
    var html = _a.html, className = _a.className;
    var updatedHtml = html
        ? updateHtml(html, __assign({}, setLinksRel))
        : '';
    return (React__namespace.default.createElement(React__namespace.default.Fragment, null, html && (React__namespace.default.createElement("div", { className: className, dangerouslySetInnerHTML: {
            __html: updatedHtml
        } }))));
};

var ExternalLink = function (_a) {
    var href = _a.href, onClick = _a.onClick, children = _a.children, props = __rest(_a, ["href", "onClick", "children"]);
    return (React__namespace.default.createElement("a", __assign({ href: href, onClick: onClick }, props, { rel: "noopener" }), children));
};

var HeaderContext$1 = React.createContext({
    isMobileMenuOpen: false,
    isDesktopMenuOpen: false,
    headerHeight: 0,
    /* eslint-disable @typescript-eslint/no-empty-function */
    setIsMobileMenuOpen: function () { },
    setHeaderHeight: function () { },
    setActiveHeaderText: function () { },
    activeHeaderText: '',
    toggleMenu: function () { },
    closeDesktopMenu: function () { },
    closeSideMenu: function () { },
    openDesktopMenu: function () { },
    isSideMenuOpen: false,
    setIsSideMenuOpen: function () { },
    activeMenuItems: [],
    setActiveMenuItems: function () { },
    activeMainMenuItem: '',
    setActiveMainMenuItem: function () { },
    closeSideAndMobileMenu: function () { },
    isNarrowMobileCta: true,
    setIsNarrowMobileCta: function () { }
});

var AnchorLink = function (_a) {
    var to = _a.to, children = _a.children, _b = _a.offset, offset = _b === void 0 ? 0 : _b, className = _a.className, props = __rest(_a, ["to", "children", "offset", "className"]);
    var headerHeight = React.useContext(HeaderContext$1).headerHeight;
    var _c = React.useContext(NavigationTreeContext), setActiveCategories = _c.setActiveCategories, isMobile = _c.isMobile, treeHeight = _c.treeHeight, isFixed = _c.isFixed;
    var handleNavigationTreeClick = function () {
        if (setActiveCategories && isMobile) {
            var height = treeHeight && !isFixed ? treeHeight : 0;
            var mobileMenuHeight = height + 60;
            offset = -mobileMenuHeight;
            setActiveCategories([]);
        }
    };
    var handleClick = function (e) {
        var element = document.getElementById(to);
        if (element) {
            e.preventDefault();
            handleNavigationTreeClick();
            var y = (element === null || element === void 0 ? void 0 : element.getBoundingClientRect().top) +
                window.pageYOffset +
                offset -
                headerHeight;
            window.scrollTo({ top: y, behavior: 'smooth' });
        }
    };
    return (React__namespace.default.createElement(ExternalLink, __assign({ href: "#".concat(to), onClick: handleClick, className: className }, props), children));
};

var DefaultLink = function (_a) {
    var href = _a.href, children = _a.children, props = __rest(_a, ["href", "children"]);
    return (React__namespace.default.createElement("a", __assign({ href: href }, props), children));
};

var variables = {"anchorLinkOffsetY":"-56"};

var isValidInternalLink = function (url) {
    // is not an internal link type
    if (url.linktype !== 'story') {
        return false;
    }
    // no entry has been set
    if (!url.id) {
        return false;
    }
    return true;
};
var Link = function (_a) {
    var url = _a.url, anchor = _a.anchor, children = _a.children, onClick = _a.onClick, trackingId = _a.trackingId, noFocus = _a.noFocus, props = __rest(_a, ["url", "anchor", "children", "onClick", "trackingId", "noFocus"]);
    var _b = React.useContext(SiteComponentContext), provider = _b.provider, Link = _b.components.Link, internalLinks = _b.internalLinks, lang = _b.lang;
    var hiddenLink = noFocus
        ? {
            'aria-hidden': true,
            tabIndex: -1
        }
        : undefined;
    if (anchor) {
        return (React__namespace.default.createElement(AnchorLink, __assign({ to: url.url, "data-tracking": trackingId, offset: parseInt(variables.anchorLinkOffsetY) }, props, hiddenLink), children));
    }
    if (url.linktype === 'url' || !isValidInternalLink(url)) {
        return (React__namespace.default.createElement(ExternalLink, __assign({ href: url.url, onClick: onClick, "data-tracking": trackingId }, props, hiddenLink), children));
    }
    var cachedUrl = "/".concat(url.cached_url)
        .replace(/^\/{2,}/g, '/')
        .replace(/\/$/, '');
    switch (provider) {
        case 'gatsby':
            return (React__namespace.default.createElement(Link, __assign({ to: (internalLinks[url.id] && internalLinks[url.id][lang]) || cachedUrl, "data-tracking": trackingId }, props), children));
        case 'next':
            return (React__namespace.default.createElement(Link, { href: (internalLinks[url.id] && internalLinks[url.id][lang]) || cachedUrl },
                React__namespace.default.createElement("a", __assign({ className: props.className || '', "data-tracking": trackingId }, props, hiddenLink), children)));
        default:
            return (React__namespace.default.createElement(DefaultLink, __assign({ href: cachedUrl, "data-tracking": trackingId }, props, hiddenLink), children));
    }
};

var HeadingsContext = React.createContext({
    headings: [],
    /* eslint-disable @typescript-eslint/no-empty-function */
    setHeadings: function () { }
});
var HeadingsContextProvider = function (_a) {
    var children = _a.children;
    var _b = React.useState([]), headings = _b[0], setHeadings = _b[1];
    return (React__namespace.default.createElement(HeadingsContext.Provider, { value: {
            headings: headings,
            setHeadings: setHeadings
        } }, children));
};

var css$_ = {"navigationTree":"styles_navigationTree__DiQfl","hasActiveChild":"styles_hasActiveChild__j1jzc","active":"styles_active__X-fh-","level-0":"styles_level-0__4SdEv","open":"styles_open__UGhhu","level-1":"styles_level-1__DCVaU","level-2":"styles_level-2__WM28B","noBorders":"styles_noBorders__ZCvoF","pages":"styles_pages__DOcbQ","icon":"styles_icon__AlcKl","transformDisabled":"styles_transformDisabled__Pd-zY","hasChildren":"styles_hasChildren__RoTk5","zeroHeight":"styles_zeroHeight__8OPUx","legal":"styles_legal__0cDWR"};

/**
 * Page Navigation Element
 *
 * Characteristics:
 * * Contains a link.
 * * Has an active state.
 * * Resets category interaction flag to show active page.
 */
var Page = React.memo(function (_a) {
    var _b;
    var element = _a.element, invisible = _a.invisible, rootToggle = _a.rootToggle;
    var activeStory = React.useContext(ActiveStoryContext).activeStory;
    var _c = React.useContext(NavigationTreeContext), setCategoryInteraction = _c.setCategoryInteraction, isMobile = _c.isMobile;
    var toggle = React.useCallback(function () {
        isMobile && (rootToggle === null || rootToggle === void 0 ? void 0 : rootToggle());
        setCategoryInteraction({ _uid: '', level: 0 });
    }, [isMobile]);
    var isActive = React.useCallback(function () { return storyUuidMatch(activeStory, element.link.id); }, [activeStory]);
    var _d = React.useState(isActive()), active = _d[0], setActive = _d[1];
    React.useEffect(function () {
        setActive(isActive());
    }, [activeStory]);
    return (React__namespace.default.createElement("li", { key: element._uid },
        React__namespace.default.createElement(Link, { "data-testid": element.link.id, onClick: toggle, url: element.link, "aria-current": active, "aria-hidden": invisible, tabIndex: invisible ? -1 : 0, className: classNames__default.default((_b = {},
                _b[css$_.active] = active,
                _b['color-action-inline'] = isMobile,
                _b['color-action-secondary--active'] = !isMobile,
                _b['bg-action-secondary--active'] = !isMobile,
                _b['border-action-primary--active'] = !isMobile,
                _b), 'color-default', 'bg-grouped-secondary--focus', 'bg-grouped-secondary--hover', 'text_undecorated') },
            React__namespace.default.createElement(Html, { html: element.text }))));
});
var PageHeading = React.memo(function (_a) {
    var _b, _c;
    var element = _a.element, activeId = _a.activeId, invisible = _a.invisible, rootToggle = _a.rootToggle;
    var isMobile = React.useContext(NavigationTreeContext).isMobile;
    var id = element.link.id;
    var active = activeId === id;
    var handleClick = React.useCallback(function () {
        rootToggle === null || rootToggle === void 0 ? void 0 : rootToggle();
    }, [rootToggle]);
    return (React__namespace.default.createElement("li", { "aria-hidden": invisible, key: element._uid, className: classNames__default.default((_b = {},
            _b[css$_.active] = active,
            _b)) },
        React__namespace.default.createElement(AnchorLink, { to: id, onClick: isMobile ? handleClick : undefined, className: classNames__default.default((_c = {},
                _c[css$_.active] = active,
                _c['color-action-inline'] = isMobile,
                _c['color-action-secondary--active'] = !isMobile,
                _c['bg-action-secondary--active'] = !isMobile,
                _c['border-action-primary--active'] = !isMobile,
                _c), 'color-default', 'bg-grouped-secondary--focus', 'bg-grouped-secondary--hover', 'text_undecorated'), "aria-hidden": invisible, tabIndex: invisible ? -1 : 0 }, element.text)));
});
var PageGroup = React.memo(function (_a) {
    var elements = _a.elements, level = _a.level, invisible = _a.invisible, rootToggle = _a.rootToggle;
    var headings = React.useContext(HeadingsContext).headings;
    if (headings && headings.length > 0) {
        return (React__namespace.default.createElement(PageGroupHeadings, { elements: elements, level: level, invisible: invisible, rootToggle: rootToggle }));
    }
    return (React__namespace.default.createElement(PageGroupPages, { elements: elements, invisible: invisible, rootToggle: rootToggle, level: level }));
});
var PageGroupPages = React.memo(function (_a) {
    var elements = _a.elements, level = _a.level, invisible = _a.invisible, rootToggle = _a.rootToggle;
    var _b = reactUse.useMeasure(), ref = _b[0], height = _b[1].height;
    var isPageGroupInvisible = invisible || height === 0;
    return (React__namespace.default.createElement("ul", { ref: ref, "aria-hidden": invisible, className: classNames__default.default(css$_["level-".concat(level + 1)], css$_.pages, 'bg-grouped-primary') }, elements.map(function (page) { return (React__namespace.default.createElement(Page, { key: page._uid, element: page, invisible: isPageGroupInvisible, rootToggle: rootToggle })); })));
});
var PageGroupHeadings = React.memo(function (_a) {
    var elements = _a.elements, level = _a.level, invisible = _a.invisible, rootToggle = _a.rootToggle;
    var _b = reactUse.useMeasure(), ref = _b[0], height = _b[1].height;
    var isPageHeadingsInvisible = invisible || height === 0;
    return (React__namespace.default.createElement("ul", { ref: ref, "aria-hidden": isPageHeadingsInvisible, className: classNames__default.default(css$_["level-".concat(level + 1)], css$_.pages, 'bg-grouped-primary') }, elements.map(function (heading) { return (React__namespace.default.createElement(PageHeading, { key: heading._uid, element: heading, invisible: isPageHeadingsInvisible, rootToggle: rootToggle })); })));
});

var Button = function (_a) {
    var trackingId = _a.trackingId, _b = _a.className, className = _b === void 0 ? 'styled-button styled-button-primary' : _b, tabIndex = _a.tabIndex, children = _a.children, props = __rest(_a, ["trackingId", "className", "tabIndex", "children"]);
    var ref = React.useRef(null);
    var buttonProps = button.useButton(__assign({}, props), ref).buttonProps;
    return (React__namespace.default.createElement("button", __assign({}, buttonProps, { className: className, "data-tracking": trackingId, tabIndex: tabIndex, ref: ref }), children));
};
var OtherTagButton = React.forwardRef(function (_a, forwardedRef) {
    var _b = _a.tag, tag = _b === void 0 ? 'div' : _b, trackingId = _a.trackingId, className = _a.className, tabIndex = _a.tabIndex, children = _a.children, props = __rest(_a, ["tag", "trackingId", "className", "tabIndex", "children"]);
    var ref = React.useRef(null);
    ref = forwardedRef || ref;
    var buttonProps = button.useButton(__assign(__assign({}, props), { elementType: tag }), ref).buttonProps;
    // skip JSX to avoid ts errors with ElementType with refs
    // To be able to have JSX again, there might be less conflicts in later
    // versions of react, typescript, ts-jest and their type definitions.
    return React__namespace.default.createElement(tag, __assign(__assign({}, buttonProps), { className: className, 'data-tracking': trackingId, tabIndex: tabIndex, ref: ref }), children);
});

/**
 * Category Navigation Element
 *
 * Characteristics:
 * * Open and close only: no page link.
 * * On initial load, shows active path.
 * * On interaction with a category, initial load state is ignored.
 */
var Category = React.memo(function (_a) {
    var _b, _c;
    var _uid = _a._uid, element = _a.element, level = _a.level, invisible = _a.invisible, rootToggle = _a.rootToggle;
    var _d = React.useState(false), open = _d[0], setOpen = _d[1];
    var _e = React.useContext(NavigationTreeContext), activeCategories = _e.activeCategories, categoryInteraction = _e.categoryInteraction, setCategoryInteraction = _e.setCategoryInteraction, initialOpen = _e.initialOpen, isExpandingMenuOpen = _e.isExpandingMenuOpen, isMegaMenuOpen = _e.isMegaMenuOpen, closeOthers = _e.closeOthers, setClickedCategory = _e.setClickedCategory;
    var _f = reactUse.useMeasure(), ref = _f[0], height = _f[1].height;
    var _g = React.useState(false), transformActive = _g[0], setTransformActive = _g[1];
    var hasChildren = React.useCallback(function () {
        if (isCategory(element)) {
            return isNonEmptyArray(element.body);
        }
        return false;
    }, [element]);
    var hasActiveChild = React.useCallback(function () { return activeCategories.includes(element._uid); }, [activeCategories, element]);
    var isPeerThatShouldBeClosed = React.useCallback(function () {
        if (closeOthers) {
            return (level === categoryInteraction.level &&
                _uid !== categoryInteraction._uid);
        }
    }, [_uid, level, closeOthers, categoryInteraction]);
    var toggle = function () {
        setTransformActive(true);
        setCategoryInteraction({ _uid: _uid, level: level });
        setOpen(!open);
        if (setClickedCategory)
            setClickedCategory(_uid);
    };
    var categories = [];
    var pages = [];
    if (isCategory(element)) {
        categories = element.body.filter(isCategory);
        pages = element.body.filter(isPage);
    }
    React.useEffect(function () {
        if (initialOpen) {
            setOpen(hasActiveChild());
        }
    }, [activeCategories]);
    React.useEffect(function () {
        setOpen(function (prevOpen) {
            if (prevOpen && isPeerThatShouldBeClosed()) {
                return false;
            }
            return prevOpen;
        });
    }, [categoryInteraction]);
    // a collapsed menu has height 0
    var isCategoryInvisible = invisible ||
        height === 0 ||
        isExpandingMenuOpen === false ||
        isMegaMenuOpen === false;
    return (React__namespace.default.createElement("li", { key: element._uid, className: classNames__default.default((_b = {}, _b[css$_.open] = open, _b)), ref: ref },
        React__namespace.default.createElement(Button, { onPress: toggle, "aria-expanded": open, "aria-hidden": isCategoryInvisible, tabIndex: isCategoryInvisible ? -1 : 0, className: classNames__default.default((_c = {},
                _c[css$_.hasChildren] = hasChildren(),
                _c[css$_.hasActiveChild] = hasActiveChild(),
                _c[css$_.open] = open,
                _c[css$_.transformDisabled] = !transformActive,
                _c), 'bg-grouped-secondary--focus', 'bg-grouped-secondary--hover', 'text_undecorated') },
            isCategory(element) && (React__namespace.default.createElement(Html, { html: element.title })),
            React__namespace.default.createElement(Svg, { name: "IconDownChevron", className: css$_.icon })),
        isNonEmptyArray(categories) && (React__namespace.default.createElement(CategoryGroup, { elements: categories, level: level + 1, open: open, invisible: isCategoryInvisible, rootToggle: rootToggle || toggle })),
        isNonEmptyArray(pages) && (React__namespace.default.createElement(PageGroup, { elements: pages, level: level, invisible: isCategoryInvisible, rootToggle: rootToggle || toggle }))));
});
var CategoryGroup = React.memo(function (_a) {
    var elements = _a.elements, level = _a.level, invisible = _a.invisible, rootToggle = _a.rootToggle;
    var _b = reactUse.useMeasure(), ref = _b[0], height = _b[1].height;
    if (!elements)
        return null;
    // a collapsed menu has height 0
    var isCategoryGroupInvisible = invisible || height === 0;
    return (React__namespace.default.createElement("ul", { className: css$_["level-".concat(level)], "aria-hidden": isCategoryGroupInvisible, ref: ref }, elements.map(function (element) { return (React__namespace.default.createElement(Category, { key: element._uid, _uid: element._uid, element: element, level: level, invisible: isCategoryGroupInvisible, rootToggle: rootToggle })); })));
});

var NavigationTree = React.memo(function (_a) {
    var _b;
    var initialActiveStory = _a.initialActiveStory, _c = _a.menu, menu = _c === void 0 ? [] : _c, _d = _a.initialOpen, initialOpen = _d === void 0 ? true : _d, _e = _a.closeOthers, closeOthers = _e === void 0 ? false : _e, _f = _a.noBorders, noBorders = _f === void 0 ? false : _f, _g = _a.cssClass, cssClass = _g === void 0 ? '' : _g, _h = _a.initialOpenCategories, initialOpenCategories = _h === void 0 ? [] : _h, isMobile = _a.isMobile, isMobileExpanded = _a.isMobileExpanded, isExpandingMenuOpen = _a.isExpandingMenuOpen, isMegaMenuOpen = _a.isMegaMenuOpen, isFixed = _a.isFixed, _j = _a.title, title = _j === void 0 ? '' : _j, _k = _a.ariaNavTitle, ariaNavTitle = _k === void 0 ? '' : _k, toggle = _a.toggle;
    var setActiveStory = React.useContext(ActiveStoryContext).setActiveStory;
    var initialActiveCategories = initialOpenCategories;
    if (initialActiveStory) {
        initialActiveCategories = findActiveCategories(menu, initialActiveStory);
    }
    React.useEffect(function () {
        setActiveStory(initialActiveStory);
    }, []);
    var ContainerTag = isMobile ? 'div' : 'nav';
    var isHidden = isMegaMenuOpen === false || isExpandingMenuOpen == false;
    return (React__namespace.default.createElement(ContainerTag, { "aria-label": ariaNavTitle ? ariaNavTitle : title ? title : 'navigation tree', "aria-hidden": isHidden, className: classNames__default.default(css$_.navigationTree, (_b = {},
            _b[css$_.noBorders] = noBorders,
            _b[css$_.legal] = cssClass === 'legal',
            _b), 'bg-default') },
        toggle && (React__namespace.default.createElement("button", { onClick: toggle, "aria-hidden": true, className: css$_.zeroHeight, tabIndex: -1 })),
        React__namespace.default.createElement(NavigationTreeContextProvider, { initialOpen: initialOpen, closeOthers: closeOthers, initialActiveCategories: initialActiveCategories, isMobile: isMobile, isMobileExpanded: isMobileExpanded, isMegaMenuOpen: isMegaMenuOpen, isExpandingMenuOpen: isExpandingMenuOpen },
            React__namespace.default.createElement(NavigationTreeRoot, { menu: menu, isFixed: isFixed, open: initialOpen }))));
});
var NavigationTreeRoot = React.memo(function (_a) {
    var menu = _a.menu, isFixed = _a.isFixed, open = _a.open;
    var root = React.useRef(null);
    var activeStory = React.useContext(ActiveStoryContext).activeStory;
    var _b = React.useContext(NavigationTreeContext), setActiveCategories = _b.setActiveCategories, setTreeHeight = _b.setTreeHeight, clickedCategory = _b.clickedCategory, setIsFixed = _b.setIsFixed, isMobileExpanded = _b.isMobileExpanded, isExpandingMenuOpen = _b.isExpandingMenuOpen, isMegaMenuOpen = _b.isMegaMenuOpen;
    var categories = menu.filter(isCategory);
    var pages = menu.filter(isPage);
    React.useEffect(function () {
        if (activeStory) {
            setActiveCategories(findActiveCategories(menu, activeStory));
        }
    }, [activeStory]);
    React.useEffect(function () {
        var _a;
        if (setTreeHeight && (root === null || root === void 0 ? void 0 : root.current)) {
            setTreeHeight((_a = root.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().height);
        }
    }, [clickedCategory]);
    React.useEffect(function () {
        if (setIsFixed && isFixed)
            setIsFixed(isFixed);
    }, [isFixed]);
    var isHiddenByOuterMenu = isMobileExpanded === false ||
        isExpandingMenuOpen === false ||
        isMegaMenuOpen === false;
    return (React__namespace.default.createElement("div", { ref: root },
        React__namespace.default.createElement(CategoryGroup, { elements: categories, level: 0, invisible: isHiddenByOuterMenu, open: open }),
        React__namespace.default.createElement(PageGroup, { elements: pages, level: 0, invisible: isHiddenByOuterMenu })));
});

exports.OttoIconSizes = void 0;
(function (OttoIconSizes) {
    OttoIconSizes["ExtraLarge"] = "ExtraLarge";
    OttoIconSizes["Large"] = "Large";
    OttoIconSizes["ExtraSmall"] = "ExtraSmall";
    OttoIconSizes["Small"] = "Small";
    OttoIconSizes["Medium"] = "Medium";
})(exports.OttoIconSizes || (exports.OttoIconSizes = {}));
var OttoIconContext = React.createContext({
    ottoIcons: {}
});
var useOttoIcons = function () {
    var context = React.useContext(OttoIconContext);
    if (context === undefined) {
        throw new Error('useOttoIcons must be used within OttoIconProvider');
    }
    return context;
};
var OttoIconProvider = function (_a) {
    var ottoIcons = _a.ottoIcons, children = _a.children;
    for (var icon in ottoIcons) {
        if (typeof ottoIcons[icon] === 'object') {
            ottoIcons[icon].svg = ottoIcons[icon].svgPaypal;
        }
    }
    return (React__namespace.default.createElement(OttoIconContext.Provider, { value: { ottoIcons: ottoIcons !== null && ottoIcons !== void 0 ? ottoIcons : {} } }, children));
};

var css$Z = {"ottoIcon":"styles_ottoIcon__EgH7u"};

var OttoIcon = function (_a) {
    var _b;
    var icon = _a.icon, color = _a.color, nonStandardSizeOverride = _a.nonStandardSizeOverride, label = _a.label, block = _a.block, offsetX = _a.offsetX, offsetY = _a.offsetY;
    if (icon && !icon.svg)
        icon.svg = icon.svgPaypal;
    var originalSize = React.useMemo(function () { return getOriginalSize(icon); }, [icon]);
    var overriddenSize = React.useMemo(function () { return getOverriddenSize(icon, nonStandardSizeOverride); }, [icon, nonStandardSizeOverride]);
    var adjustedSvg = React.useMemo(function () {
        return getAdjustedSvg(icon, overriddenSize, originalSize, nonStandardSizeOverride, !label);
    }, [icon, overriddenSize, originalSize, nonStandardSizeOverride, label]);
    var imgRoleWithLabel = label
        ? {
            'aria-label': label,
            title: label,
            role: 'img'
        }
        : undefined;
    return (React__namespace.default.createElement("span", __assign({}, imgRoleWithLabel, { className: css$Z.ottoIcon, style: (_b = {
                color: color,
                minWidth: overriddenSize,
                minHeight: overriddenSize,
                maxHeight: overriddenSize
            },
            _b[block ? 'display' : ''] = block ? 'block' : '',
            _b.transform = "translate(".concat(offsetX || 0, "px, ").concat(offsetY || 0, "px)"),
            _b), dangerouslySetInnerHTML: { __html: adjustedSvg } })));
};
var getOriginalSize = function (icon) {
    switch (icon === null || icon === void 0 ? void 0 : icon.size) {
        case exports.OttoIconSizes.ExtraSmall:
            return 16;
        case exports.OttoIconSizes.Small:
            return 20;
        case exports.OttoIconSizes.Medium:
            return 24;
        case exports.OttoIconSizes.Large:
            return 48;
        default:
        case exports.OttoIconSizes.ExtraLarge:
            return 96;
    }
};
var getOverriddenSize = function (icon, nonStandardSizeOverride) {
    switch (nonStandardSizeOverride || (icon === null || icon === void 0 ? void 0 : icon.size)) {
        case exports.OttoIconSizes.ExtraSmall:
            return 16;
        case exports.OttoIconSizes.Small:
            return 20;
        case exports.OttoIconSizes.Medium:
            return 24;
        case exports.OttoIconSizes.Large:
            return 48;
        default:
        case exports.OttoIconSizes.ExtraLarge:
            return 96;
    }
};
var getAdjustedSvg = function (icon, overriddenSize, originalSize, nonStandardSizeOverride, ariaHidden) {
    var _a, _b;
    if (!nonStandardSizeOverride) {
        return icon === null || icon === void 0 ? void 0 : icon.svg;
    }
    return (_b = (_a = icon === null || icon === void 0 ? void 0 : icon.svg) === null || _a === void 0 ? void 0 : _a.replace) === null || _b === void 0 ? void 0 : _b.call(_a, /\swidth="\d*"/g, " width=\"".concat(overriddenSize, "\"")).replace(/\sheight="\d*"/g, " height=\"".concat(overriddenSize, "\"")).replace(/\sviewBox="[\d|\s]*"/g, '').replace('<svg ', "<svg focusable=\"false\" viewBox=\"0 0 ".concat(originalSize, " ").concat(originalSize, "\"").concat(ariaHidden ? ' aria-hidden="true"' : '', " "));
};

var module$1 = {
    collectIcons: collectIcons,
    isOttoIconData: isOttoIconData
};
var iconSizes = Object.keys(exports.OttoIconSizes);
function isBlockTree(value) {
    var potentialBlockTree = value;
    return (isNonEmptyArray(potentialBlockTree) &&
        typeof potentialBlockTree[0].component === 'string');
}
function isGlobalReference(value) {
    return value === 'global-reference';
}
function isOttoIconField(fieldName) {
    return fieldName.startsWith('ottoIcon');
}
function isMultiSizeIcon(value) {
    return isNonEmptyArray(value) && typeof value[0] === 'string';
}
function isOttoIconBlock(value) {
    return (isNonEmptyArray(value) &&
        value[0].component === 'otto-icon');
}
function isOttoIconName(value) {
    return (typeof value === 'string' &&
        new RegExp(iconSizes.join('|') + '$').test(value));
}
function isOttoIconData(entry) {
    var icon = entry;
    return (typeof (icon === null || icon === void 0 ? void 0 : icon.name) === 'string' &&
        iconSizes.includes(icon === null || icon === void 0 ? void 0 : icon.size) &&
        (typeof (icon === null || icon === void 0 ? void 0 : icon.svg) === 'string' || typeof (icon === null || icon === void 0 ? void 0 : icon.svgPaypal) === 'string'));
}
function loadOttoIcons(data, ottoModule) {
    return Array.from(collectIcons(new Set(), data)).reduce(function (acc, name) {
        acc[name] = ottoModule[name];
        return acc;
    }, {});
}
/*
 * Reduce a storyblok page json to list of otto icon names
 */
function collectIcons() {
    var _a, _b, _c, _d, _e;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var coll = args[0];
    var block = args[1];
    for (var _f = 0, _g = Object.entries(block); _f < _g.length; _f++) {
        var _h = _g[_f], fieldName = _h[0], value = _h[1];
        if (isOttoIconField(fieldName)) {
            if (isMultiSizeIcon(value)) {
                value.map(function (icon) { return isOttoIconName(icon) && coll.add(icon); });
            }
            else if (isOttoIconBlock(value)) {
                value.map(function (_a) {
                    var icon = _a.icon;
                    return isOttoIconName(icon) && coll.add(icon);
                });
            }
            else if (isOttoIconName(value)) {
                coll.add(value);
            }
        }
        if (isBlockTree(value)) {
            coll = value.reduce(module$1.collectIcons, coll);
        }
        if (isGlobalReference(value)) {
            coll =
                (_e = (_d = (_c = (_b = (_a = block.reference) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.global) === null || _c === void 0 ? void 0 : _c.reduce) === null || _d === void 0 ? void 0 : _d.call(_c, module$1.collectIcons, coll)) !== null && _e !== void 0 ? _e : coll;
        }
        if (isStoryblokRichTextField(value)) {
            coll = richTextRecurse(coll, value);
        }
    }
    return coll;
}
function isStoryblokRichTextField(data) {
    var block = data;
    return (block.type === 'doc' &&
        block.content !== undefined &&
        isNonEmptyArray(block.content));
}
function isStoryblokRichTextComponent(data) {
    var block = data;
    return (isNonEmptyArray(block) &&
        block[0].component === 'richtext' &&
        block[0].body !== undefined &&
        isNonEmptyArray(block[0].body.content));
}
function richTextRecurse(iconColl, block) {
    if (isStoryblokRichTextComponent(block)) {
        return block.reduce(function (acc, next) {
            return collectRichTextOttoIcons(acc, next.body);
        }, iconColl);
    }
    else if (Array.isArray(block)) {
        return block.reduce(function (acc, next) { return collectRichTextOttoIcons(acc, next); }, iconColl);
    }
    else if (isStoryblokRichTextField(block)) {
        collectRichTextOttoIcons(iconColl, block);
    }
    return iconColl;
}
function collectRichTextOttoIcons(iconColl, body) {
    var _a, _b, _c;
    if (!body)
        return iconColl;
    var richtextObject = body;
    switch (body.type) {
        case 'blok':
            return (((_c = (_b = ((_a = richtextObject.attrs) === null || _a === void 0 ? void 0 : _a.body)).reduce) === null || _c === void 0 ? void 0 : _c.call(_b, module$1.collectIcons, iconColl)) || iconColl);
        case 'doc':
            return richTextRecurse(iconColl, body.content);
        default:
            return iconColl;
    }
}
var ottoUtils = module$1;

var initialized = false;
var initializeStoryblok = function () {
    if (!initialized) {
        react.storyblokInit({});
        initialized = true;
    }
};

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
initializeStoryblok();
var richTextSchema = cloneDeep__default.default(react.RichTextSchema);
var createComponentResolver = function (Components, _a) {
    if (Components === void 0) { Components = {}; }
    var additionalProps = _a.additionalProps, _b = _a.ottoIcons, ottoIcons = _b === void 0 ? {} : _b;
    return function (component, blok) {
        if (typeof Components[component] !== 'undefined') {
            var Component = Components[component];
            return ReactDOMServer__default.default.renderToStaticMarkup(React__namespace.default.createElement(OttoIconProvider, { ottoIcons: ottoIcons },
                React__namespace.default.createElement(Component, __assign({}, blok, additionalProps))));
        }
    };
};
var isStoryblokRichText = function (data) {
    return (data === null || data === void 0 ? void 0 : data.content) && isNonEmptyArray(data.content);
};
var recursivelyFindTextContent = function (jsonObject) {
    return jsonObject.find(function (obj) {
        return (isNonEmptyArray(obj.content) &&
            recursivelyFindTextContent(obj.content)) ||
            (obj.text && obj.type === 'text');
    });
};
var filterStoryblokRichText = function (body, disallowedEmptyTextTypes) { return (__assign(__assign({}, body), { content: filterStoryblokRichTextContent(body.content, disallowedEmptyTextTypes) })); };
// Check if Storyblok component has real content
// Storyblok API sends a json even though the field might be empty
var filterStoryblokRichTextContent = function (body, disallowedEmptyTextTypes) {
    function bodyIsArray(value) {
        return Array.isArray(value);
    }
    var result = bodyIsArray(body) ? [] : {};
    var filterObject = function (jsonObject) {
        if (!jsonObject)
            return { type: 'paragraph' };
        if (disallowedEmptyTextTypes.includes(jsonObject.type)) {
            if (!Array.isArray(jsonObject.content)) {
                // stop recursion
                return { type: 'paragraph' };
            }
            else {
                // lift up and recurse nested content if there's not text-content
                var hasTextContent = recursivelyFindTextContent(jsonObject.content);
                return hasTextContent
                    ? __assign(__assign({}, cloneDeep__default.default(jsonObject)), { content: filterStoryblokRichTextContent(jsonObject.content, disallowedEmptyTextTypes) }) : filterStoryblokRichTextContent(jsonObject.content, disallowedEmptyTextTypes);
            }
        }
        else if (Array.isArray(jsonObject.content)) {
            // recurse nested content
            return __assign(__assign({}, cloneDeep__default.default(jsonObject)), { content: filterStoryblokRichTextContent(jsonObject.content, disallowedEmptyTextTypes) });
        }
        else {
            // stop recursion
            return cloneDeep__default.default(jsonObject);
        }
    };
    if (bodyIsArray(body)) {
        result = body.map(function (bodyElement) {
            return filterObject(bodyElement);
        });
    }
    else if (body) {
        result = filterObject(body);
    }
    return result;
};
var renderStoryblokRichText = function (data, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.Components, Components = _c === void 0 ? {} : _c, _d = _b.noFocus, noFocus = _d === void 0 ? false : _d, _e = _b.disallowedEmptyTextTypes, disallowedEmptyTextTypes = _e === void 0 ? ['heading'] : _e, _f = _b.ottoIcons, ottoIcons = _f === void 0 ? {} : _f;
    var filteredData = !!data && disallowedEmptyTextTypes.length >= 1
        ? filterStoryblokRichText(data, disallowedEmptyTextTypes)
        : data;
    if (isStoryblokRichText(filteredData)) {
        var result = react.renderRichText(filteredData, {
            schema: richTextSchema,
            resolver: createComponentResolver(Components, {
                additionalProps: { noFocus: noFocus },
                ottoIcons: ottoIcons
            })
        });
        return result == '<p></p>' ? '' : result;
    }
    return '';
};

var css$Y = {"statusBanner":"styles_statusBanner__Uac9s","icon-container":"styles_icon-container__vIhoE"};

var VIEWER_COUNTRY_KEY = 'viewerCountry';
var isCrawlerUserAgent = function () {
    var _a, _b;
    return /bot|crawler|spider|crawling/i.test((_b = (_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent) !== null && _b !== void 0 ? _b : '');
};
var getCountryCodeFromCache = function () {
    var _a, _b;
    return (_b = (_a = window.sessionStorage) === null || _a === void 0 ? void 0 : _a.getItem(VIEWER_COUNTRY_KEY)) !== null && _b !== void 0 ? _b : null;
};
var getCountryCodeFromServer = function () {
    return fetch('/api/viewer-country', {
        method: 'GET'
    })
        .then(function (res) { return res.json(); }, function (error) {
        console.error(error);
        return null;
    })
        .then(function (response) {
        var _a;
        return (_a = response === null || response === void 0 ? void 0 : response.viewerCountry) !== null && _a !== void 0 ? _a : null;
    });
};
var getCountryCode = function () { return __awaiter(void 0, void 0, void 0, function () {
    var code, serverCode;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                code = getCountryCodeFromCache();
                if (!code) return [3 /*break*/, 1];
                return [2 /*return*/, code];
            case 1: return [4 /*yield*/, getCountryCodeFromServer()];
            case 2:
                serverCode = _a.sent();
                if (serverCode && window.sessionStorage) {
                    window.sessionStorage.setItem(VIEWER_COUNTRY_KEY, serverCode);
                }
                return [2 /*return*/, serverCode];
        }
    });
}); };

var StatusBanner = function (_a) {
    var ottoIcon = _a.ottoIcon, layout = _a.layout, defaultBody = _a.body, _b = _a.countryContent, countryContent = _b === void 0 ? [] : _b, rest = __rest(_a, ["ottoIcon", "layout", "body", "countryContent"]);
    var ottoIcons = useOttoIcons().ottoIcons;
    var countryContentMap = React.useMemo(function () {
        return new Map(countryContent.map(function (_a) {
            var country = _a.country, content = _a.content;
            return [
                country === null || country === void 0 ? void 0 : country.toLocaleLowerCase(),
                content
            ];
        }));
    }, [countryContent]);
    var _c = React.useState(countryContentMap.size === 0 ? defaultBody === null || defaultBody === void 0 ? void 0 : defaultBody.content : null), content = _c[0], setContent = _c[1];
    React.useEffect(function () {
        if (countryContentMap.size > 0 && !isCrawlerUserAgent()) {
            getCountryCode().then(function (code) {
                var _a, _b;
                var countryContentBlock = (_b = countryContentMap.get((_a = code === null || code === void 0 ? void 0 : code.toLocaleLowerCase()) !== null && _a !== void 0 ? _a : 'ZZ')) !== null && _b !== void 0 ? _b : null;
                var renderedContent = renderStoryblokRichText(countryContentBlock, {
                    ottoIcons: ottoIcons
                });
                setContent(renderedContent);
            });
        }
    }, [countryContentMap]);
    return content ? (React__namespace.default.createElement(SectionLayout, __assign({}, layout[0], react.storyblokEditable(rest)),
        React__namespace.default.createElement("div", { className: css$Y.statusBanner },
            React__namespace.default.createElement("div", { className: classNames__default.default(css$Y['icon-container']) }, isOttoIconBlock(ottoIcon) &&
                isOttoIconData(ottoIcons[String(ottoIcon[0].icon)]) && (React__namespace.default.createElement(OttoIcon, __assign({}, ottoIcon[0], { icon: ottoIcons[String(ottoIcon[0].icon)] })))),
            React__namespace.default.createElement("div", null,
                React__namespace.default.createElement(Html, { html: content, className: "last-element-nospace" }))))) : null;
};

var css$X = {"standard":"styles_standard__tzykN","standard-media-center-mobile":"styles_standard-media-center-mobile__BXQRo","standard-media-right-desktop":"styles_standard-media-right-desktop__gC3FO","standard-media-left-desktop":"styles_standard-media-left-desktop__bfogo","standard-media-center-desktop":"styles_standard-media-center-desktop__cZMk9","titleAboveMedia":"styles_titleAboveMedia__Km4xN","title":"styles_title__I84q9","subtitle":"styles_subtitle__y0iFs","body":"styles_body__LHQRq","list":"styles_list__PziT-","rounded":"styles_rounded__2G6HF","contentContainer":"styles_contentContainer__WmHt7","contentContainer-media-center-desktop":"styles_contentContainer-media-center-desktop__iR9--","contentContainer-media-center-desktop-reverse":"styles_contentContainer-media-center-desktop-reverse__zb5Ns","width-5":"styles_width-5__AzxVt","width-6":"styles_width-6__rwSaw","width-7":"styles_width-7__DFNFz","width-8":"styles_width-8__8gzqY","contentContainer-media-left-mobile":"styles_contentContainer-media-left-mobile__bJYC4","contentContainer-media-right-mobile":"styles_contentContainer-media-right-mobile__6JGOM","contentContainer-media-left-desktop":"styles_contentContainer-media-left-desktop__xBriz","contentContainer-media-right-desktop":"styles_contentContainer-media-right-desktop__H2b1D","mediaContainer":"styles_mediaContainer__cdsvz","videoContainer":"styles_videoContainer__z6EE6","roundedCorners":"styles_roundedCorners__9Lqo8","iframeContainer":"styles_iframeContainer__kKhSK","mediaContainer-full-width-mobile":"styles_mediaContainer-full-width-mobile__kz4j3","mediaContainer-media-left-mobile":"styles_mediaContainer-media-left-mobile__digiC","mediaContainer-media-right-mobile":"styles_mediaContainer-media-right-mobile__rY3w-","mediaContainer-media-left-desktop":"styles_mediaContainer-media-left-desktop__fUGau","mediaContainer-media-right-desktop":"styles_mediaContainer-media-right-desktop__Q1y3O","mediaContainer-media-center-desktop":"styles_mediaContainer-media-center-desktop__dhFKj","mediaContainer-media-center-mobile":"styles_mediaContainer-media-center-mobile__3tLq3","mediaContainer-media-center-mobile-reverse":"styles_mediaContainer-media-center-mobile-reverse__sEbly","mediaContainer-media-center-desktop-reverse":"styles_mediaContainer-media-center-desktop-reverse__KGl3O"};

var css$W = {"container":"styles_container__lNw-d","table":"styles_table__v9nLm","checkmarkIcon":"styles_checkmarkIcon__GldQR","crossIcon":"styles_crossIcon__isktC","striped":"styles_striped__gssA8","hover":"styles_hover__4Qwpw"};

var getContent = function (text) {
    switch (text) {
        case '[checkmark]':
            return (React__namespace.default.createElement("span", { "aria-label": "yes" },
                React__namespace.default.createElement(Svg, { className: css$W.checkmarkIcon, ariaHidden: true, name: 'Checkmark' })));
        case '[cross]':
            return (React__namespace.default.createElement("span", { "aria-label": "no" },
                React__namespace.default.createElement(Svg, { className: css$W.crossIcon, ariaHidden: true, name: 'Cross' })));
        default:
            return text;
    }
};
var Table = function (_a) {
    var content = _a.content, type = _a.type, _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.tableHeadHidden, tableHeadHidden = _c === void 0 ? false : _c;
    return (React__namespace.default.createElement("div", { className: css$W.container },
        React__namespace.default.createElement("table", { className: classNames__default.default(css$W.table, css$W[type], className) },
            React__namespace.default.createElement("thead", { hidden: tableHeadHidden },
                React__namespace.default.createElement("tr", null, content &&
                    content.thead.map(function (th, index) { return (React__namespace.default.createElement("th", { key: index }, th.value)); }))),
            React__namespace.default.createElement("tbody", null, content &&
                content.tbody.map(function (tr) { return (React__namespace.default.createElement("tr", { key: tr._uid }, tr.body.map(function (td) { return (React__namespace.default.createElement("td", { key: td._uid, "aria-hidden": !td.value }, getContent(td.value))); }))); })))));
};

var css$V = {"calloutBlock":"styles_calloutBlock__ArdkO"};

var CalloutBlock = function (_a) {
    var body = _a.body, _b = _a.colorProfile, colorProfile = _b === void 0 ? 'info' : _b, _c = _a.transparentBackground, transparentBackground = _c === void 0 ? false : _c, _d = _a.layout, layout = _d === void 0 ? [] : _d, rest = __rest(_a, ["body", "colorProfile", "transparentBackground", "layout"]);
    var colorClasses = colorProfile in colors
        ? Object.values(getColorClasses(colorProfile)).filter(Boolean)
        : [colorProfile];
    var bodyHtml = body
        ? updateHtml(body.content, __assign({}, setLinkStyle('color-inherit text-underline')))
        : null;
    var calloutBlockMarkup = function () {
        return (React__namespace.default.createElement("div", __assign({ className: classNames__default.default.apply(void 0, __spreadArray(__spreadArray([[css$V.calloutBlock]], colorClasses, false), [transparentBackground && 'bg-transparent'], false)) }, (!layout.length ? react.storyblokEditable(rest) : {})), bodyHtml && React__namespace.default.createElement(Html, { html: bodyHtml })));
    };
    if (layout.length)
        return (React__namespace.default.createElement(SectionLayout, __assign({}, layout[0], react.storyblokEditable(rest)), calloutBlockMarkup()));
    else
        return React__namespace.default.createElement(React__namespace.default.Fragment, null, calloutBlockMarkup());
};

var types = {
    primary: {
        classes: 'styled-button styled-button-primary'
    },
    secondary: {
        classes: 'styled-button styled-button-secondary'
    },
    'primary-floating': {
        classes: 'styled-button styled-button-primary-floating'
    },
    'secondary-floating': {
        classes: 'styled-button styled-button-secondary-floating'
    },
    'stand-alone': {
        classes: 'styled-link styled-link-alone'
    },
    'stand-alone-bullet': {
        classes: 'styled-link styled-link-bullet',
        icon: 'Circle'
    },
    'stand-alone-arrow': {
        classes: 'styled-link styled-link-arrow',
        icon: 'ArrowRight'
    }
};
var typeNames = Object.keys(types);
var StyledLink = function (_a) {
    var _b, _c, _d, _e;
    var url = _a.url, text = _a.text, type = _a.type, target = _a.target, trackingId = _a.trackingId, id = _a.id, ottoIcon = _a.ottoIcon, className = _a.className, noFocus = _a.noFocus;
    var icon = (_b = types[type]) === null || _b === void 0 ? void 0 : _b.icon;
    var ottoIcons = useOttoIcons().ottoIcons;
    var isValidOttoIcon = isOttoIconBlock(ottoIcon) &&
        isOttoIconData(ottoIcons[String(ottoIcon[0].icon)]);
    return (React__namespace.default.createElement(Link, { url: url, id: id, className: classNames__default.default((_c = types[type]) === null || _c === void 0 ? void 0 : _c.classes, className), trackingId: trackingId, target: target, noFocus: noFocus },
        React__namespace.default.createElement("span", null, text),
        isValidOttoIcon ? (React__namespace.default.createElement(OttoIcon, __assign({}, ottoIcon === null || ottoIcon === void 0 ? void 0 : ottoIcon[0], { icon: ottoIcons[String((_d = ottoIcon === null || ottoIcon === void 0 ? void 0 : ottoIcon[0]) === null || _d === void 0 ? void 0 : _d.icon)], nonStandardSizeOverride: String((_e = ottoIcon === null || ottoIcon === void 0 ? void 0 : ottoIcon[0]) === null || _e === void 0 ? void 0 : _e.nonStandardSizeOverride) ||
                exports.OttoIconSizes.Small }))) : (icon && React__namespace.default.createElement(Svg, { className: "styled-link-icon", name: icon }))));
};

var FOOTNOTE_PATTERN = /\[\^[^[\]]+\]/;

var slugify = function (str) {
    return makeSlug__default.default(str, { lower: true, strict: true });
};

var getFootnoteProps = function (name) {
    if (!name) {
        return null;
    }
    var text = name.replace(/^\[\^?/, '').replace(/\]$/, '');
    if (!text) {
        return null;
    }
    var key = slugify(text);
    var refId = "fnref-".concat(key);
    var contentId = "fn-".concat(key);
    return { refId: refId, contentId: contentId, text: text };
};

var css$U = {"ref":"styles_ref__oC-Qc","footnote":"styles_footnote__0Jtsi"};

var FootnoteRef = function (_a) {
    var name = _a.name, _b = _a.noFocus, noFocus = _b === void 0 ? false : _b;
    if (!name) {
        return null;
    }
    var props = getFootnoteProps(name);
    if (!props) {
        return null;
    }
    var contentId = props.contentId, refId = props.refId, text = props.text;
    var labelId = "".concat(refId, "-label");
    return (React__namespace.default.createElement("sup", { className: css$U.ref },
        React__namespace.default.createElement("a", { id: refId, href: "#".concat(contentId), rel: "footnote", "aria-labelledby": labelId, "aria-hidden": noFocus, tabIndex: noFocus ? -1 : 0, title: text },
            React__namespace.default.createElement("span", { id: labelId, className: "d-none", "aria-hidden": true }, text))));
};

var _a$1;
var replaceFootnoteRefInRichText = (_a$1 = {},
    _a$1['a:not(.styled-link):not(.styled-button)'] = function (el) {
        var text = domutils.textContent(el);
        if (text && FOOTNOTE_PATTERN.test(text)) {
            return ReactDOMServer__default.default.renderToStaticMarkup(React__namespace.default.createElement(FootnoteRef, { name: text }));
        }
        else {
            return el;
        }
    },
    _a$1);

function replaceReactString(input, pattern, render) {
    var result = [];
    if (!input) {
        result.push(input);
        return result;
    }
    if (!(pattern.source.startsWith('(') && pattern.source.endsWith(')'))) {
        pattern = new RegExp("(".concat(pattern.source, ")"), pattern.flags);
    }
    var parts = input.split(pattern);
    for (var i = 1; i < parts.length; i += 2) {
        result.push(parts[i - 1]);
        result.push(render(parts[i], i));
    }
    result.push(parts[parts.length - 1]);
    return result;
}

var replaceFootnoteRefInText = function (input) {
    return __spreadArray([], replaceReactString(input, FOOTNOTE_PATTERN, function (match, index) { return (React__namespace.default.createElement(FootnoteRef, { key: index, name: match })); }), true);
};

var css$T = {"primary-blue-600":"#001c64","list":"styles_list__7ti-1","item":"styles_item__tiDLh","text":"styles_text__ATqtl","ordered":"styles_ordered__xtreh"};

var List = function (_a) {
    var heading = _a.heading, listType = _a.listType, _b = _a.listItems, listItems = _b === void 0 ? [] : _b, className = _a.className;
    var ottoIcons = useOttoIcons().ottoIcons;
    var ListComponent = listType === 'ordered' ? 'ol' : 'ul';
    return (React__namespace.default.createElement(ListComponent, { className: classNames__default.default(css$T.list, css$T[listType], className) },
        heading && React__namespace.default.createElement("h3", { className: "title" }, heading),
        listItems.length > 0 &&
            listItems.map(function (_a) {
                var text = _a.text, ottoIcon = _a.ottoIcon, _uid = _a._uid;
                return (React__namespace.default.createElement("li", { key: _uid, className: classNames__default.default(listType === 'ordered' ? 'text-body-large' : 'text-body', css$T.item) },
                    isOttoIconBlock(ottoIcon) &&
                        isOttoIconData(ottoIcons[String(ottoIcon[0].icon)]) &&
                        listType.includes('icon') && (React__namespace.default.createElement(OttoIcon, __assign({}, ottoIcon[0], { color: listType === 'icon-inverted-tick'
                            ? css$T['primary-blue-600']
                            : ottoIcon[0].color, icon: ottoIcons[String(ottoIcon[0].icon)] }))),
                    text && (React__namespace.default.createElement("p", { className: css$T.text }, replaceFootnoteRefInText(text)))));
            })));
};

var css$S = {"listCircle":"styles_listCircle__woMsA","fill":"styles_fill__4DgAG"};

var ListCircle = function (_a) {
    var _b = _a.type, type = _b === void 0 ? 'border' : _b, items = _a.items, rest = __rest(_a, ["type", "items"]);
    return (React__namespace.default.createElement("ol", __assign({ className: classNames__default.default(css$S.listCircle, css$S[type]) }, react.storyblokEditable(rest)), items.map(function (item, index) { return (React__namespace.default.createElement("li", { key: index }, item.text)); })));
};

var css$R = {"table":"styles_table__kRUzH","bordered":"styles_bordered__lacQ-","striped":"styles_striped__TULJy","highlight-lilac":"styles_highlight-lilac__PLxmG","highlight-magnetic":"styles_highlight-magnetic__a52g5","hover":"styles_hover__bWFsl","table-responsive":"styles_table-responsive__WwFvI"};

var TableStandard = function (_a) {
    var _b;
    var _c, _d;
    var content = _a.content, type = _a.type, border = _a.border, highlightColor = _a.highlightColor;
    return (React__namespace.default.createElement("div", { className: css$R['table-responsive'] },
        React__namespace.default.createElement("table", { className: classNames__default.default(css$R.table, css$R[type], (_b = {},
                _b[css$R["highlight-".concat(highlightColor)]] = highlightColor,
                _b[css$R.bordered] = border,
                _b)) },
            React__namespace.default.createElement("thead", null,
                React__namespace.default.createElement("tr", null, (_c = content.thead) === null || _c === void 0 ? void 0 : _c.map(function (th, index) { return (React__namespace.default.createElement("th", { key: index }, th.value)); }))),
            React__namespace.default.createElement("tbody", null, (_d = content.tbody) === null || _d === void 0 ? void 0 : _d.map(function (tr) { return (React__namespace.default.createElement("tr", { key: tr._uid }, tr.body.map(function (td) { return (React__namespace.default.createElement("td", { key: td._uid }, td.value)); }))); })))));
};

var css$Q = {"spacer":"1rem","imageFlowContainer":"styles_imageFlowContainer__zrPfp","align":"styles_align__eU0af","left":"styles_left__vYKVC","center":"styles_center__C6vRg","right":"styles_right__A6qwq"};

var VideoSource = function (_a) {
    var format = _a.format, url = _a.url, minBreakpoint = _a.minBreakpoint, maxBreakpoint = _a.maxBreakpoint;
    var query = constructQuery({
        minBreakpoint: minBreakpoint,
        maxBreakpoint: maxBreakpoint
    });
    var show = reactResponsive.useMediaQuery({ query: query });
    if (show) {
        return React__namespace.default.createElement("source", { src: url, type: format });
    }
    return null;
};

var isLink = function (link) { return Boolean(link === null || link === void 0 ? void 0 : link.url); };
var ImageFlow = function (_a) {
    var images = _a.images, align = _a.align, _b = _a.gap, gap = _b === void 0 ? css$Q.spacer : _b;
    return (React__namespace.default.createElement("div", { className: classNames__default.default(css$Q.imageFlowContainer, css$Q.align, css$Q[align || 'left']), style: { gap: "".concat(gap, "px") } }, images.map(function (_a) {
        var img = _a.img, link = _a.link, _b = _a.maxWidth, maxWidth = _b === void 0 ? 700 : _b;
        // max width defaults to 700 prevent image for getting to big in desktop
        var width = getOriginalImageDimensions(img.image).width;
        return (React__namespace.default.createElement(ConditionalWrapper, { key: img._uid, condition: isLink(link), wrapper: function (children) { return (React__namespace.default.createElement(Link, __assign({}, link, { url: link }), children)); } },
            React__namespace.default.createElement("div", { style: { width: width, maxWidth: "".concat(maxWidth, "px") } },
                React__namespace.default.createElement(Img, __assign({}, img, { src: img.image, isStatic: true })))));
    })));
};

var pascalCaseToKebabCase = function (str) {
    return str
        .split(/(?=[A-Z])/)
        .join('-')
        .toLowerCase();
};

var buildComponentsObject = function (components) {
    return Object.fromEntries(Object.entries(components).map(function (_a) {
        var k = _a[0], v = _a[1];
        return [pascalCaseToKebabCase(k), v];
    }));
};

var Components$6 = buildComponentsObject({
    Link: Link,
    Table: Table,
    CalloutBlock: CalloutBlock,
    StyledLink: StyledLink,
    List: List,
    ListCircle: ListCircle,
    TableStandard: TableStandard,
    ImageFlow: ImageFlow
});

var css$P = {"richtext":"styles_richtext__loLNP"};

var Richtext = function (_a) {
    var _b, _c;
    var body = _a.body, layout = _a.layout, textAlign = _a.textAlign, className = _a.className, noFocus = _a.noFocus, tableWrapperClassName = _a.tableWrapperClassName, rest = __rest(_a, ["body", "layout", "textAlign", "className", "noFocus", "tableWrapperClassName"]);
    var ottoIcons = useOttoIcons().ottoIcons;
    var html = renderStoryblokRichText(body, { Components: Components$6, ottoIcons: ottoIcons });
    if (!html) {
        return React__namespace.default.createElement("div", null);
    }
    html = updateHtml(html, __assign(__assign(__assign({}, replaceFootnoteRefInRichText), wrapTables(tableWrapperClassName || 'table-responsive')), (noFocus ? setLinksHidden : {})));
    var hasContainerLayout = ((_b = layout === null || layout === void 0 ? void 0 : layout[0]) === null || _b === void 0 ? void 0 : _b.component) === 'container-layout';
    var hasLegacyLayout = ((_c = layout === null || layout === void 0 ? void 0 : layout[0]) === null || _c === void 0 ? void 0 : _c.component) === 'section-layout';
    return (React__namespace.default.createElement(ConditionalWrapper, { condition: isNonEmptyArray(layout), wrapper: function (children) {
            if (hasContainerLayout)
                return (React__namespace.default.createElement(ContainerLayout, __assign({}, layout[0], react.storyblokEditable(rest)), children));
            else if (hasLegacyLayout) {
                return (React__namespace.default.createElement(SectionLayoutLegacy, __assign({}, layout[0], react.storyblokEditable(rest)), children));
            }
        } },
        React__namespace.default.createElement("div", __assign({ className: classNames__default.default('text-link-styling', [textAlign], hasLegacyLayout ? 'section-text-align' : '', css$P.richtext, className) }, (!isNonEmptyArray(layout)
            ? react.storyblokEditable(rest)
            : {})),
            React__namespace.default.createElement(Html, { html: html }))));
};

var css$O = {"iframeContainer":"styles_iframeContainer__aCKX-","idle":"styles_idle__P4wqE","overlay":"styles_overlay__FczIo","hide":"styles_hide__kd1EM","thumbnail":"styles_thumbnail__hV8Kl","reveal":"styles_reveal__Tfc8F"};

var resizeVimeoThumbnail = function (thumbnailUrl, width) {
    var _a;
    if (!thumbnailUrl.match(/https:\/\/i.vimeocdn.com\/video\/[a-z0-9-]+_[0-9]+x[0-9]+/)) {
        return thumbnailUrl;
    }
    var extension = (_a = thumbnailUrl.match(/\.[^/.]+$/)) !== null && _a !== void 0 ? _a : '';
    var thumbnailUrlWithoutExtension = thumbnailUrl.replace(new RegExp(extension + '$'), '');
    return "".concat(thumbnailUrlWithoutExtension.replace(/_[0-9]+x[0-9]+$/, "_".concat(width, "x0"))).concat(extension);
};
var createVimeoVideoUrl = function (vimeoId, muted, autoplay) {
    var url = "https://player.vimeo.com/video/".concat(vimeoId, "?app_id=122963");
    var mutedArg = muted ? '&muted=1' : '';
    var autoplayArg = autoplay ? '&autoplay=1' : '';
    return "".concat(url).concat(autoplayArg).concat(mutedArg);
};
var createYoutubeThumbnailUrl = function (youtubeId) {
    return "https://i3.ytimg.com/vi/".concat(youtubeId, "/hqdefault.jpg");
};
var createYoutubeVideoUrl = function (youtubeId, autoplay) {
    return "https://www.youtube.com/embed/".concat(youtubeId).concat(autoplay ? '?autoplay=1' : '');
};

var aspectRatio = 0.5625;
var LazyloadIframeVimeo = function (_a) {
    var vimeoOembed = _a.vimeoOembed, title = _a.title, width = _a.width, _b = _a.muted, muted = _b === void 0 ? false : _b, props = __rest(_a, ["vimeoOembed", "title", "width", "muted"]);
    var autoplay = true;
    var iframeWidth = width || vimeoOembed.response.width;
    var url = createVimeoVideoUrl("".concat(vimeoOembed.response.video_id), muted, autoplay);
    var thumbnail = width
        ? resizeVimeoThumbnail(vimeoOembed.response.thumbnail_url, width)
        : vimeoOembed.response.thumbnail_url;
    aspectRatio = vimeoOembed.response.height / vimeoOembed.response.width;
    return (React__namespace.default.createElement(LazyloadIframe, __assign({ width: iframeWidth, aspectRatio: aspectRatio, thumbnail: thumbnail, url: url, title: title || vimeoOembed.response.title || '' }, props)));
};
var LazyloadIframeYoutube = function (_a) {
    var youtubeId = _a.youtubeId, width = _a.width, props = __rest(_a, ["youtubeId", "width"]);
    var autoplay = true;
    var url = createYoutubeVideoUrl(youtubeId, autoplay), thumbnail = createYoutubeThumbnailUrl(youtubeId);
    return (React__namespace.default.createElement(LazyloadIframe, __assign({ width: width, aspectRatio: aspectRatio, thumbnail: thumbnail, url: url }, props)));
};
var LazyloadIframe = function (_a) {
    var _b = _a.aspectRatio, aspectRatio = _b === void 0 ? 0.5625 : _b, thumbnail = _a.thumbnail, url = _a.url, title = _a.title, buttonLabel = _a.buttonLabel, width = _a.width;
    var _c = React.useState(false), isClicked = _c[0], setClicked = _c[1];
    var style = { '--aspect-ratio': 1 / aspectRatio };
    var wrapperRef = React.useRef(null);
    var _d = useIntersectionObserver(wrapperRef), isVisible = _d.isVisible, shouldReveal = _d.shouldReveal, setShouldReveal = _d.setShouldReveal;
    React.useEffect(function () {
        var _a, _b;
        if (isClicked) {
            (_a = window.dataLayer) === null || _a === void 0 ? void 0 : _a.push({ event: 'vimeoTrackerActivate' });
            (_b = window.dataLayer) === null || _b === void 0 ? void 0 : _b.push({
                event: 'video',
                eventCategory: 'video interacted',
                eventAction: 'Played video',
                eventLabel: title
            });
            setTimeout(function () { var _a; return (_a = document.getElementById("iframeId-".concat(url))) === null || _a === void 0 ? void 0 : _a.focus(); }, 500);
        }
    }, [isClicked]);
    React.useEffect(function () {
        if (isVisible) {
            var img = new Image();
            img.onload = function () { return setShouldReveal(true); };
            img.src = thumbnail;
        }
    }, [isVisible]);
    return (React__namespace.default.createElement("div", { style: style, className: classNames__default.default(css$O.iframeContainer, isClicked ? '' : css$O.idle), ref: wrapperRef },
        React__namespace.default.createElement("iframe", { "data-testid": "iframe", width: width, height: width * aspectRatio, src: isClicked ? url : '', frameBorder: "0", allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture", allowFullScreen: true, title: title, "aria-hidden": !isClicked, tabIndex: -1, id: "iframeId-".concat(url) }),
        !isClicked && (React__namespace.default.createElement("button", { className: classNames__default.default(css$O.overlay, 'focus-play-icon', isClicked ? css$O.hide : ''), onClick: function () { return setClicked(true); }, "aria-label": buttonLabel },
            React__namespace.default.createElement("img", { src: isVisible ? thumbnail : undefined, alt: title, id: "playbutton-iframeId-".concat(url), className: classNames__default.default(css$O.thumbnail, shouldReveal ? css$O.reveal : '') }),
            React__namespace.default.createElement(Svg, { name: 'PlayVideo', ariaHidden: true })))));
};

var _a;
var mediaQuery;
if (typeof window !== 'undefined') {
    mediaQuery = (_a = window.matchMedia) === null || _a === void 0 ? void 0 : _a.call(window, '(prefers-reduced-motion: reduce)');
}
var handleReduceMotionChanged = function (videoRef) {
    var _a, _b;
    var video = videoRef.current;
    if (mediaQuery === null || mediaQuery === void 0 ? void 0 : mediaQuery.matches)
        (_a = video === null || video === void 0 ? void 0 : video.pause) === null || _a === void 0 ? void 0 : _a.call(video);
    else
        (_b = video === null || video === void 0 ? void 0 : video.play) === null || _b === void 0 ? void 0 : _b.call(video);
};
var ResponsiveVideoSource = function (_a) {
    var responsiveSourceList = _a.responsiveSourceList, _editable = _a._editable;
    var videoRef = React.useRef(null);
    React.useEffect(function () {
        var _a;
        if (mediaQuery.matches)
            (_a = videoRef.current) === null || _a === void 0 ? void 0 : _a.removeAttribute('autoplay');
        var mqEventHandler = function () { return handleReduceMotionChanged(videoRef); };
        mediaQuery.addEventListener('change', mqEventHandler);
        return function () { return mediaQuery.removeEventListener('change', mqEventHandler); };
    }, []);
    return ((isNonEmptyArray(responsiveSourceList) &&
        _editable &&
        validateBreakpointCollection(responsiveSourceList)) || (React__namespace.default.createElement("video", { autoPlay: true, loop: true, muted: true, playsInline: true, ref: videoRef }, responsiveSourceList.map(function (link) { return (React__namespace.default.createElement(VideoSource, __assign({}, link, { key: link._uid }))); }))));
};

var css$N = {"pricingSectionItem":"styles_pricingSectionItem__XY3wH","imageContainer":"styles_imageContainer__3bi7w","contentContainer":"styles_contentContainer__Vlj0l","row":"styles_row__CmLm8","pricingColumn":"styles_pricingColumn__4Ol-a","total":"styles_total__No5q-","pos":"styles_pos__00GAY","cta":"styles_cta__bSz1P","disclaimer":"styles_disclaimer__rB15f","disclaimerRichtext":"styles_disclaimerRichtext__lppRt","image":"styles_image__-VDes"};

var PricingSectionItem = function (_a) {
    var _b, _c, _d, _e, _f;
    var totalCostTitle = _a.totalCostTitle, totalCostSmallText = _a.totalCostSmallText, totalCost = _a.totalCost, firstTitle = _a.firstTitle, firstPrice = _a.firstPrice, secondTitle = _a.secondTitle, secondPrice = _a.secondPrice, thirdTitle = _a.thirdTitle, thirdPrice = _a.thirdPrice, fourthTitle = _a.fourthTitle, fourthPrice = _a.fourthPrice, cta = _a.cta, disclaimer = _a.disclaimer, disclaimerRichtext = _a.disclaimerRichtext, image = _a.image, className = _a.className, noFocus = _a.noFocus;
    var pricing = React.useContext(SiteComponentContext).pricing;
    return (React__namespace.default.createElement("div", { className: classNames__default.default(css$N.pricingSectionItem, 'px-grid-margin', className) },
        React__namespace.default.createElement("div", { className: css$N.contentContainer },
            totalCostTitle && (React__namespace.default.createElement("div", { className: css$N.row },
                React__namespace.default.createElement("div", null,
                    React__namespace.default.createElement("h3", { className: 'small-headline' }, totalCostTitle)),
                React__namespace.default.createElement("div", { className: css$N.pricingColumn },
                    ((_b = totalCost === null || totalCost === void 0 ? void 0 : totalCost.product) === null || _b === void 0 ? void 0 : _b.price) && (React__namespace.default.createElement("div", { className: classNames__default.default(css$N.total, 'default-headline') },
                        pricing.getPrice(totalCost.location, totalCost.product.product),
                        React__namespace.default.createElement(FootnoteRef, { noFocus: noFocus, name: totalCost === null || totalCost === void 0 ? void 0 : totalCost.disclaimer }))),
                    totalCostSmallText && (React__namespace.default.createElement("div", { className: classNames__default.default(css$N.total, 'text-body') }, totalCostSmallText))))),
            firstTitle && (React__namespace.default.createElement("div", { className: css$N.row },
                React__namespace.default.createElement("div", null, firstTitle),
                ((_c = firstPrice === null || firstPrice === void 0 ? void 0 : firstPrice.product) === null || _c === void 0 ? void 0 : _c.price) && (React__namespace.default.createElement("div", { className: 'text-body-large' },
                    React__namespace.default.createElement("strong", null, pricing.getPrice(firstPrice.location, firstPrice.product.product)),
                    React__namespace.default.createElement(FootnoteRef, { noFocus: noFocus, name: firstPrice === null || firstPrice === void 0 ? void 0 : firstPrice.disclaimer }))))),
            secondTitle && (React__namespace.default.createElement("div", { className: css$N.row },
                React__namespace.default.createElement("div", null, secondTitle),
                ((_d = secondPrice === null || secondPrice === void 0 ? void 0 : secondPrice.product) === null || _d === void 0 ? void 0 : _d.price) && (React__namespace.default.createElement("div", { className: 'text-body-large' },
                    React__namespace.default.createElement("strong", null, pricing.getPrice(secondPrice.location, secondPrice.product.product)),
                    React__namespace.default.createElement(FootnoteRef, { noFocus: noFocus, name: secondPrice === null || secondPrice === void 0 ? void 0 : secondPrice.disclaimer }))))),
            thirdTitle && (React__namespace.default.createElement("div", { className: css$N.row },
                React__namespace.default.createElement("div", null, thirdTitle),
                ((_e = thirdPrice === null || thirdPrice === void 0 ? void 0 : thirdPrice.product) === null || _e === void 0 ? void 0 : _e.price) && (React__namespace.default.createElement("div", { className: 'text-body-large' },
                    React__namespace.default.createElement("strong", null, pricing.getPrice(thirdPrice.location, thirdPrice.product.product)),
                    React__namespace.default.createElement(FootnoteRef, { noFocus: noFocus, name: thirdPrice === null || thirdPrice === void 0 ? void 0 : thirdPrice.disclaimer }))))),
            fourthTitle && (React__namespace.default.createElement("div", { className: css$N.row },
                React__namespace.default.createElement("div", null, fourthTitle),
                ((_f = fourthPrice === null || fourthPrice === void 0 ? void 0 : fourthPrice.product) === null || _f === void 0 ? void 0 : _f.price) && (React__namespace.default.createElement("div", { className: 'text-body-large' },
                    React__namespace.default.createElement("strong", null, pricing.getPrice(fourthPrice.location, fourthPrice.product.product)),
                    React__namespace.default.createElement(FootnoteRef, { noFocus: noFocus, name: fourthPrice === null || fourthPrice === void 0 ? void 0 : fourthPrice.disclaimer }))))),
            cta && cta[0] && (React__namespace.default.createElement("div", { className: css$N.cta },
                React__namespace.default.createElement(StyledLink, __assign({}, cta[0], { className: css$N.cta, noFocus: noFocus })))),
            disclaimer && (React__namespace.default.createElement("div", { className: classNames__default.default(css$N.disclaimer, 'text-body', 'text-muted') }, disclaimer)),
            disclaimerRichtext && (React__namespace.default.createElement("div", { className: classNames__default.default(css$N.disclaimer, css$N.disclaimerRichtext, 'text-body', 'text-muted') },
                React__namespace.default.createElement(Richtext, { body: disclaimerRichtext })))),
        React__namespace.default.createElement("div", { className: css$N.imageContainer }, image && image.image && (React__namespace.default.createElement("div", { className: css$N.row },
            React__namespace.default.createElement(AdvanceImage, __assign({ className: css$N.image }, image, { src: image.image })))))));
};

var css$M = {"accordionItem":"styles_accordionItem__5--zN","accordionButton":"styles_accordionButton__41xdl","subTitle":"styles_subTitle__Z4Ynx","title":"styles_title__FS-mT","open":"styles_open__-M8h4","content":"styles_content__yUbJF","richtextAccordion":"styles_richtextAccordion__P88K2","tableAccordion":"styles_tableAccordion__KDNCX"};

var contentComponents = {
    table: Table,
    richtext: Richtext,
    'pricing-section-item': PricingSectionItem
};
var AccordionItem = function (props) {
    var _a, _b, _c, _d;
    var _e;
    var title = props.title, subTitle = props.subTitle, ottoIcon = props.ottoIcon, content = props.content, _f = props.isItemOpen, isItemOpen = _f === void 0 ? false : _f, onItemOpen = props.onItemOpen, gtmEvent = props.gtmEvent, _g = props.classNameContent, classNameContent = _g === void 0 ? '' : _g, ottoIconDropdown = props.ottoIconDropdown, _uid = props._uid;
    var ottoIcons = useOttoIcons().ottoIcons;
    var _h = React.useState(false), isOpen = _h[0], setIsOpen = _h[1];
    var _j = React.useState('0px'), contentHeight = _j[0], setContentHeight = _j[1];
    var contentContainer = React.useRef(null);
    React.useEffect(function () {
        var _a;
        setContentHeight(isItemOpen ? "".concat((_a = contentContainer === null || contentContainer === void 0 ? void 0 : contentContainer.current) === null || _a === void 0 ? void 0 : _a.scrollHeight, "px") : '0px');
        setIsOpen(isItemOpen);
    }, [isItemOpen]);
    var clickHandler = function () {
        var _a, _b;
        setContentHeight(!isOpen ? "".concat((_a = contentContainer === null || contentContainer === void 0 ? void 0 : contentContainer.current) === null || _a === void 0 ? void 0 : _a.scrollHeight, "px") : '0px');
        setIsOpen(!isOpen);
        var _c = (gtmEvent === null || gtmEvent === void 0 ? void 0 : gtmEvent[0]) || {}, event = _c.event, eventCategory = _c.eventCategory, eventAction = _c.eventAction, eventLabel = _c.eventLabel;
        eventLabel &&
            ((_b = window === null || window === void 0 ? void 0 : window.dataLayer) === null || _b === void 0 ? void 0 : _b.push({
                event: event,
                eventCategory: eventCategory,
                eventAction: eventAction,
                eventLabel: props[eventLabel] || eventLabel
            }));
        onItemOpen === null || onItemOpen === void 0 ? void 0 : onItemOpen(_uid || '');
    };
    var Component = ((_e = content[0]) === null || _e === void 0 ? void 0 : _e.component) && contentComponents[content[0].component];
    var itemId = "item".concat(_uid);
    var itemTitleId = "title".concat(_uid);
    return (React__namespace.default.createElement("div", { className: classNames__default.default(css$M.accordionItem, 'focus-pp') },
        React__namespace.default.createElement(Button, { className: classNames__default.default(css$M.accordionButton, (_a = {}, _a[css$M.open] = isOpen, _a)), onPress: clickHandler, "aria-expanded": isOpen, "aria-controls": itemId },
            isOttoIconBlock(ottoIcon) &&
                isOttoIconData(ottoIcons[String(ottoIcon[0].icon)]) && (React__namespace.default.createElement("span", { className: classNames__default.default((_b = {}, _b[css$M.subTitle] = subTitle, _b)) },
                React__namespace.default.createElement(OttoIcon, __assign({}, ottoIcon[0], { icon: ottoIcons[String(ottoIcon[0].icon)] })))),
            React__namespace.default.createElement("div", { className: classNames__default.default(css$M.title, (_c = {}, _c[css$M.subTitle] = subTitle, _c)) },
                React__namespace.default.createElement("p", { className: "title", id: itemTitleId }, title),
                subTitle && React__namespace.default.createElement("p", { className: "text-body-large" }, subTitle)),
            React__namespace.default.createElement(OttoIcon, { icon: ottoIcons[String(ottoIconDropdown)] })),
        Component && (React__namespace.default.createElement("div", { className: classNames__default.default('text-body', css$M.content), ref: contentContainer, style: { maxHeight: contentHeight }, "data-testid": "accordion-content", id: itemId, "aria-hidden": !isOpen, "aria-labelledby": itemTitleId, role: 'region' },
            React__namespace.default.createElement(Component, __assign({}, content[0], { tableHeadHidden: true, className: classNames__default.default(classNameContent, (_d = {},
                    _d[css$M.richtextAccordion] = content[0].component === 'richtext',
                    _d[css$M.tableAccordion] = content[0].component === 'table',
                    _d)), noFocus: !isOpen }))))));
};

var css$L = {"accordion":"styles_accordion__e87Bx","transparent":"styles_transparent__PhFup","heading":"styles_heading__CUkMN","overrideSectionPadding":"styles_overrideSectionPadding__sy2-J"};

var makeStructuredData = function (_a) {
    var items = _a.items;
    return ({
        '@context': 'http://schema.org',
        '@type': 'FAQPage',
        mainEntity: isNonEmptyArray(items)
            ? items
                .filter(function (_a) {
                var title = _a.title, body = _a.body;
                return title && body && renderStoryblokRichText(body);
            })
                .map(function (_a) {
                var title = _a.title, body = _a.body;
                return ({
                    '@type': 'Question',
                    name: title,
                    acceptedAnswer: {
                        '@type': 'Answer',
                        text: renderStoryblokRichText(body)
                    }
                });
            })
            : undefined
    });
};
var FaqStructuredData = React.memo(function (props) { return (React__namespace.default.createElement("script", { type: "application/ld+json", dangerouslySetInnerHTML: {
        __html: "\n      ".concat(JSON.stringify(makeStructuredData(props), undefined, 2).replace(/\n/g, "\n      "), "\n      ")
    } })); });

var transformAccordionItemPropsToFaqItem = function (items) {
    return items.map(function (_a) {
        var _b;
        var title = _a.title, content = _a.content;
        return ({
            title: title,
            body: (_b = content[0]) === null || _b === void 0 ? void 0 : _b.body
        });
    });
};
var Accordion = function (_a) {
    var _b, _c;
    var _d, _e;
    var heading = _a.heading, _f = _a.items, items = _f === void 0 ? [] : _f, layout = _a.layout, headingAlign = _a.headingAlign, _g = _a.openedItemID, openedItemID = _g === void 0 ? '' : _g, onItemOpen = _a.onItemOpen, _h = _a.variant, variant = _h === void 0 ? '' : _h, _j = _a.classNameContent, classNameContent = _j === void 0 ? '' : _j, ottoIconDropdown = _a.ottoIconDropdown, enableFaqStructuredData = _a.enableFaqStructuredData, rest = __rest(_a, ["heading", "items", "layout", "headingAlign", "openedItemID", "onItemOpen", "variant", "classNameContent", "ottoIconDropdown", "enableFaqStructuredData"]);
    return (React__namespace.default.createElement(ContainerLayout, __assign({}, layout[0], react.storyblokEditable(rest)),
        heading && (React__namespace.default.createElement("h2", { className: classNames__default.default('headline-4', css$L.heading, [headingAlign], (_b = {},
                _b[css$L.overrideSectionPadding] = (_d = layout === null || layout === void 0 ? void 0 : layout[0]) === null || _d === void 0 ? void 0 : _d.overrideSectionPadding,
                _b)) }, heading)),
        React__namespace.default.createElement("div", { className: classNames__default.default(css$L.accordion, variant ? '' : 'white', (_c = {},
                _c[css$L[variant]] = variant,
                _c[css$L.overrideSectionPadding] = (_e = layout === null || layout === void 0 ? void 0 : layout[0]) === null || _e === void 0 ? void 0 : _e.overrideSectionPadding,
                _c)) }, items.length > 0 &&
            items.map(function (_a) {
                var _uid = _a._uid, data = __rest(_a, ["_uid"]);
                return (React__namespace.default.createElement(AccordionItem, __assign({ key: _uid, _uid: _uid, isItemOpen: openedItemID === _uid, onItemOpen: onItemOpen }, data, { classNameContent: classNameContent, ottoIconDropdown: ottoIconDropdown })));
            })),
        enableFaqStructuredData ? (React__namespace.default.createElement(FaqStructuredData, { items: transformAccordionItemPropsToFaqItem(items) })) : ('')));
};

var css$K = {"transcript":"styles_transcript__GVZ-2","richtextFixedPadding":"styles_richtextFixedPadding__8HVCv"};

var Transcript = function (_a) {
    var _b, _c;
    var transcript = _a.transcript, manualTitle = _a.manualTitle;
    return ((_c = (_b = transcript === null || transcript === void 0 ? void 0 : transcript[0]) === null || _b === void 0 ? void 0 : _b.items) === null || _c === void 0 ? void 0 : _c[0]) ? (React__namespace.default.createElement("div", { className: css$K.transcript },
        React__namespace.default.createElement(Accordion, __assign({}, __assign(__assign({}, transcript[0]), { items: [
                __assign(__assign({}, transcript[0].items[0]), { subTitle: transcript[0].items[0].subTitle || manualTitle })
            ], classNameContent: css$K.richtextFixedPadding }), { layout: [
                __assign(__assign({}, transcript[0].layout[0]), { paddingTop: 'none', paddingBottom: 'none' })
            ], headingAlign: "text-left" })))) : null;
};

var VideoContainer = function (_a) {
    var _b, _c;
    var source = _a.source, playButtonLabel = _a.playButtonLabel, manualTitle = _a.manualTitle, maxWidth = _a.maxWidth, transcript = _a.transcript, _editable = _a._editable;
    var sourceType = (_b = source === null || source === void 0 ? void 0 : source[0]) === null || _b === void 0 ? void 0 : _b.component;
    var videoComponent;
    switch (sourceType) {
        case 'youtube':
            videoComponent = (React__namespace.default.createElement(LazyloadIframeYoutube, { youtubeId: source[0].youtubeId, title: manualTitle || '', buttonLabel: playButtonLabel, width: maxWidth || 650 }));
            break;
        case 'vimeo':
            videoComponent = (React__namespace.default.createElement(LazyloadIframeVimeo, { vimeoOembed: source[0].settings.vimeo_oembed, title: manualTitle ||
                    ((_c = source[0].settings.vimeo_oembed) === null || _c === void 0 ? void 0 : _c.response.title) ||
                    '', width: maxWidth || 650, buttonLabel: playButtonLabel, muted: true }));
            break;
        case 'video-source':
            videoComponent = (React__namespace.default.createElement(ResponsiveVideoSource, { responsiveSourceList: source, _editable: _editable }));
            break;
        default:
            videoComponent = null;
            break;
    }
    return (React__namespace.default.createElement(React__namespace.default.Fragment, null,
        videoComponent,
        React__namespace.default.createElement(Transcript, { transcript: transcript, manualTitle: manualTitle })));
};

var Media = function (_a) {
    var _b, _c;
    var vimeo = _a.vimeo, youtube = _a.youtube, videoContainer = _a.videoContainer, titleAboveMedia = _a.titleAboveMedia, className = _a.className, classNameHeadline = _a.classNameHeadline, image = _a.image, setHeight = _a.setHeight;
    var hasImage = checkImage((_b = image[0]) === null || _b === void 0 ? void 0 : _b.asset);
    var hasImageResizing = !!((_c = image[0]) === null || _c === void 0 ? void 0 : _c.cropAlignment);
    var getMedia = function () {
        if (videoContainer === null || videoContainer === void 0 ? void 0 : videoContainer[0]) {
            return React__namespace.default.createElement(VideoContainer, __assign({}, videoContainer[0]));
        }
        else if (vimeo && vimeo.vimeo_oembed) {
            return (React__namespace.default.createElement("div", { className: css$X.videoContainer },
                React__namespace.default.createElement(LazyloadIframeVimeo, { vimeoOembed: vimeo.vimeo_oembed, width: 650, muted: true })));
        }
        else if (youtube) {
            return (React__namespace.default.createElement("div", { className: css$X.videoContainer },
                React__namespace.default.createElement(LazyloadIframeYoutube, { youtubeId: youtube, title: '', width: 650 })));
        }
        else if (hasImage && hasImageResizing) {
            return (validateBreakpointCollection(image) || (React__namespace.default.createElement(React__namespace.default.Fragment, null, image.map(function (imgResized, index) { return (React__namespace.default.createElement(ImgResized, __assign({}, imgResized, { key: imgResized._uid + String(index) }))); }))));
        }
        else if (hasImage) {
            return React__namespace.default.createElement(AdvanceImage, __assign({}, image[0].asset, { src: image[0].asset.image }));
        }
        return null;
    };
    var mediaRef = React.createRef();
    reactUse.useIsomorphicLayoutEffect(function () {
        mediaRef.current && setHeight(mediaRef.current.clientHeight);
    }, []);
    var media = getMedia();
    return media ? (React__namespace.default.createElement("div", { className: className, ref: mediaRef },
        titleAboveMedia && (React__namespace.default.createElement(Richtext, { body: titleAboveMedia, className: classNameHeadline })),
        media)) : null;
};

var AccessibilityRender = function (_a) {
    var elementsOrder = _a.elementsOrder, elements = _a.elements, _b = _a.tabletBreakpoint, tabletBreakpoint = _b === void 0 ? 'm1' : _b, _c = _a.desktopBreakpoint, desktopBreakpoint = _c === void 0 ? 'lg' : _c;
    var _d = React.useState([]), renderOrder = _d[0], setRenderOrder = _d[1];
    var isTablet = reactResponsive.useMediaQuery({
        minWidth: breakpoints[tabletBreakpoint],
        maxWidth: breakpoints[desktopBreakpoint]
    });
    var isDesktop = reactResponsive.useMediaQuery({
        minWidth: breakpoints[desktopBreakpoint]
    });
    var getRenderOrder = function () {
        if (isDesktop) {
            return elementsOrder.desktop;
        }
        else if (isTablet) {
            return elementsOrder.tablet;
        }
        else {
            return elementsOrder.mobile;
        }
    };
    reactUse.useDeepCompareEffect(function () {
        setRenderOrder(getRenderOrder());
    }, [elementsOrder, isDesktop, isTablet]);
    return renderOrder.map(function (elementName) { return (React__namespace.default.createElement(React__namespace.default.Fragment, { key: elementName }, elements[elementName])); });
};

var StandardModule = function (_a) {
    var _b, _c;
    var _d, _e, _f, _g;
    var title = _a.title, subtitle = _a.subtitle, body = _a.body, list = _a.list, cta = _a.cta, image = _a.image, videoContainer = _a.videoContainer, vimeo = _a.vimeo, youtube = _a.youtube, mediaPositionMobile = _a.mediaPositionMobile, mediaPositionDesktop = _a.mediaPositionDesktop, roundedBackground = _a.roundedBackground, roundedCorners = _a.roundedCorners, titleAboveMedia = _a.titleAboveMedia, mediaWidth = _a.mediaWidth, textAlign = _a.textAlign, _h = _a.layout, layout = _h === void 0 ? [] : _h, rest = __rest(_a, ["title", "subtitle", "body", "list", "cta", "image", "videoContainer", "vimeo", "youtube", "mediaPositionMobile", "mediaPositionDesktop", "roundedBackground", "roundedCorners", "titleAboveMedia", "mediaWidth", "textAlign", "layout"]);
    var roundedBackgroundColor = '';
    if (roundedBackground && layout[0]) {
        roundedBackgroundColor = layout[0].backgroundColor;
        layout[0].backgroundColor = '';
    }
    var _j = React.useState(480), mediaHeight = _j[0], setMediaHeight = _j[1];
    var isDesktop = reactResponsive.useMediaQuery({
        minWidth: breakpoints['m2']
    });
    var mediaProps = {
        vimeo: vimeo,
        youtube: youtube,
        videoContainer: videoContainer,
        titleAboveMedia: titleAboveMedia,
        classNameHeadline: classNames__default.default('default-headline', css$X.titleAboveMedia, textAlign),
        className: classNames__default.default(css$X.mediaContainer, css$X["mediaContainer-".concat(mediaPositionMobile)], css$X["mediaContainer-".concat(mediaPositionDesktop)], css$X[mediaWidth], (_b = {},
            _b[css$X.roundedCorners] = roundedCorners,
            _b[css$X['mediaContainer-media-center-mobile']] = mediaPositionMobile === 'media-center-mobile-reverse',
            _b[css$X['mediaContainer-media-center-desktop']] = mediaPositionDesktop === 'media-center-desktop-reverse',
            _b[css$X['mediaContainer-full-width-mobile']] = (_e = (_d = videoContainer === null || videoContainer === void 0 ? void 0 : videoContainer[0]) === null || _d === void 0 ? void 0 : _d.transcript) === null || _e === void 0 ? void 0 : _e[0],
            _b)),
        image: image,
        setHeight: setMediaHeight
    };
    var elementsOrder = { mobile: [], tablet: [], desktop: [] };
    switch (mediaPositionMobile) {
        case 'media-center-mobile-reverse':
            elementsOrder.mobile = elementsOrder.tablet = ['content', 'media'];
            break;
        default:
            elementsOrder.mobile = elementsOrder.tablet = ['media', 'content'];
            break;
    }
    switch (mediaPositionDesktop) {
        case 'media-center-desktop-reverse':
            elementsOrder.desktop = ['content', 'media'];
            break;
        case 'media-right-desktop':
            elementsOrder.desktop = ['content', 'media'];
            break;
        case 'media-left-desktop':
            elementsOrder.desktop = ['media', 'content'];
            break;
        case 'media-center-desktop':
            elementsOrder.desktop = ['media', 'content'];
            break;
    }
    var mediaElement = React__namespace.default.createElement(Media, __assign({}, mediaProps));
    var contentElement = (React__namespace.default.createElement("div", __assign({ className: classNames__default.default(css$X.contentContainer, css$X["contentContainer-".concat(mediaPositionMobile)], css$X["contentContainer-".concat(mediaPositionDesktop)], textAlign, css$X[mediaWidth]) }, (isDesktop && mediaPositionDesktop !== 'media-center-desktop'
        ? {
            style: {
                minHeight: mediaHeight - (((_g = (_f = videoContainer === null || videoContainer === void 0 ? void 0 : videoContainer[0]) === null || _f === void 0 ? void 0 : _f.transcript) === null || _g === void 0 ? void 0 : _g[0]) ? 100 : 0)
            }
        }
        : undefined)),
        title && (React__namespace.default.createElement(Richtext, { body: title, className: classNames__default.default('default-headline', css$X.title) })),
        subtitle && (React__namespace.default.createElement(Richtext, { body: subtitle, className: classNames__default.default('text-body-large', css$X.subtitle) })),
        body && React__namespace.default.createElement(Richtext, { body: body, className: css$X.body }),
        list[0] && React__namespace.default.createElement(List, __assign({}, list[0], { className: css$X.list })),
        cta[0] && React__namespace.default.createElement(StyledLink, __assign({}, cta[0]))));
    var standardModuleElements = {
        media: mediaElement,
        content: contentElement
    };
    return (React__namespace.default.createElement(ContainerLayout, __assign({}, layout[0], react.storyblokEditable(rest)),
        React__namespace.default.createElement("div", { className: classNames__default.default(css$X.standard, css$X["standard-".concat(mediaPositionMobile)], css$X["standard-".concat(mediaPositionDesktop)], (_c = {},
                _c[css$X['standard-media-center-mobile']] = mediaPositionMobile === 'media-center-mobile-reverse',
                _c[css$X['standard-media-center-desktop']] = mediaPositionDesktop === 'media-center-desktop-reverse',
                _c[roundedBackgroundColor] = roundedBackground,
                _c[css$X.rounded] = roundedBackground,
                _c)) },
            React__namespace.default.createElement(AccessibilityRender, { elementsOrder: elementsOrder, elements: standardModuleElements, desktopBreakpoint: "m2" }))));
};

var css$J = {"cardWrapper":"styles_cardWrapper__QRcqQ","cards-2":"styles_cards-2__htXzZ","miniCardWrapper":"styles_miniCardWrapper__vV07v","cards-4":"styles_cards-4__UISbT","cards-3":"styles_cards-3__WL-ol","cards-1":"styles_cards-1__GJlZM","largeCard":"styles_largeCard__4-gx2","largeCards-1":"styles_largeCards-1__xVN5t","largeCards-2":"styles_largeCards-2__mhiT-","card":"styles_card__9xBJ1","miniCard":"styles_miniCard__j-IKg","content":"styles_content__4ZtUo","iconArrow":"styles_iconArrow__Jcf6Q","headlineContainer":"styles_headlineContainer__9GWwa","imageContainer":"styles_imageContainer__oDIyD","fullWidth":"styles_fullWidth__LVlIC","magnetic":"styles_magnetic__QTXV-","title":"styles_title__Biyff","cardContent":"styles_cardContent__eLKJW","noMedia":"styles_noMedia__FZ4a1","textColor-white":"styles_textColor-white__yWbg7","textColor-dark":"styles_textColor-dark__zf1Qm","icon-headline-color":"styles_icon-headline-color__6NZLd","blue":"styles_blue__MJjly","cards-2-large-1":"styles_cards-2-large-1__TzALx","cards-2-large-2":"styles_cards-2-large-2__pitsf","mediaLeft":"styles_mediaLeft__t88Ln","image":"styles_image__14dsS","cards-1-large-1":"styles_cards-1-large-1__BH8-t","cards-3-large-1":"styles_cards-3-large-1__48g5p","imageBackground":"styles_imageBackground__Tv-iD","infoInsideCard":"styles_infoInsideCard__B2myd"};

var css$I = {"content":"styles_content__SoWQ5","infoInsideCard":"styles_infoInsideCard__OIuU7","miniCard":"styles_miniCard__LVVF4","title":"styles_title__MgmxE","text":"styles_text__RG4Nb","list":"styles_list__PezGT","link":"styles_link__TQFBq"};

var Info = function (_a) {
    var _b;
    var infoTitle = _a.infoTitle, link = _a.link, list = _a.list, miniCard = _a.miniCard, infoInsideCard = _a.infoInsideCard, text = _a.text, richtext = _a.richtext;
    return (React__namespace.default.createElement("div", { className: classNames__default.default(css$I.content, (_b = {},
            _b[css$I.miniCard] = miniCard,
            _b[css$I.infoInsideCard] = infoInsideCard,
            _b)) },
        infoTitle && (React__namespace.default.createElement("h2", { className: classNames__default.default(css$I.title, 'mini-headline') }, infoTitle)),
        text && (React__namespace.default.createElement("p", { className: classNames__default.default(css$I.text, 'default-text-block') }, replaceFootnoteRefInText(text))),
        richtext && React__namespace.default.createElement(Richtext, { body: richtext }),
        list[0] && (React__namespace.default.createElement("div", { className: css$I.list },
            React__namespace.default.createElement(List, __assign({}, list[0])))),
        link.length > 0 && React__namespace.default.createElement(StyledLink, __assign({ className: css$I.link }, link[0]))));
};

var StandardCard = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h;
    var _j, _k;
    var backgroundColor = _a.backgroundColor, backgroundImage = _a.backgroundImage, fullWidthImage = _a.fullWidthImage, image = _a.image, infoTitle = _a.infoTitle, largeCard = _a.largeCard, link = _a.link, list = _a.list, mediaPosition = _a.mediaPosition, miniCard = _a.miniCard, infoInsideCard = _a.infoInsideCard, numberOfCards = _a.numberOfCards, numberOfLargeCards = _a.numberOfLargeCards, text = _a.text, richtext = _a.richtext, textColor = _a.textColor, title = _a.title, url = _a.url, rest = __rest(_a, ["backgroundColor", "backgroundImage", "fullWidthImage", "image", "infoTitle", "largeCard", "link", "list", "mediaPosition", "miniCard", "infoInsideCard", "numberOfCards", "numberOfLargeCards", "text", "richtext", "textColor", "title", "url"]);
    var hasBackgroundImage = checkImage(backgroundImage);
    var hasImage = checkImage((_j = image[0]) === null || _j === void 0 ? void 0 : _j.asset);
    var hasImageResizing = !!((_k = image[0]) === null || _k === void 0 ? void 0 : _k.cropAlignment);
    var hasInfoContent = infoTitle.length > 0 ||
        text.length > 0 ||
        list.length > 0 ||
        link.length > 0;
    var hasInfoOutsideCard = hasInfoContent && !infoInsideCard;
    var hasInfoInsideCard = hasInfoContent && infoInsideCard;
    return (React__namespace.default.createElement("div", __assign({ className: classNames__default.default('focus-pp', css$J.cardWrapper, css$J["cards-".concat(numberOfCards)], css$J["largeCards-".concat(numberOfLargeCards)], (_b = {},
            _b[css$J.largeCard] = largeCard,
            _b[css$J.miniCardWrapper] = miniCard && numberOfCards !== 1,
            _b)) }, react.storyblokEditable(rest)),
        React__namespace.default.createElement("div", { className: classNames__default.default(css$J.card, [backgroundColor], css$J["cards-".concat(numberOfCards)], (_c = {},
                _c[css$J.miniCard] = miniCard && numberOfCards !== 1,
                _c[css$J.infoInsideCard] = infoInsideCard,
                _c[css$J.standardCard] = !largeCard,
                _c[css$J.largeCard] = largeCard && numberOfCards !== 4,
                _c[css$J.noMedia] = !hasImage && !hasBackgroundImage,
                _c)) },
            React__namespace.default.createElement("div", { className: classNames__default.default(css$J.cardContent, css$J["cards-".concat(numberOfCards, "-large-").concat(numberOfLargeCards)], (_d = {},
                    _d[css$J.largeCard] = largeCard && numberOfCards !== 4,
                    _d[css$J.noMedia] = !hasImage && !hasBackgroundImage,
                    _d[css$J["textColor-".concat(textColor)]] = hasBackgroundImage,
                    _d)) },
                React__namespace.default.createElement(ConditionalWrapper, { condition: hasBackgroundImage, wrapper: function (children) { return (React__namespace.default.createElement(ImgBackground, { src: (backgroundImage && backgroundImage.image) || '', base64: backgroundImage && backgroundImage.base64, quality: 90, loading: "lazy", className: css$J.imageBackground }, children)); } },
                    React__namespace.default.createElement(Link, { url: url },
                        React__namespace.default.createElement("div", { className: classNames__default.default(css$J.content, (_e = {},
                                _e[css$J.mediaLeft] = mediaPosition === 'left',
                                _e)) },
                            React__namespace.default.createElement("div", { className: classNames__default.default(css$J.headlineContainer, (_f = {},
                                    _f[css$J.whiteText] = hasBackgroundImage,
                                    _f)) },
                                React__namespace.default.createElement("h2", { className: classNames__default.default(css$J.title, 'title') }, title),
                                React__namespace.default.createElement(Svg, { className: classNames__default.default('icon-headline-color', css$J.iconArrow, (_g = {},
                                        _g[css$J.blue] = backgroundColor === 'white',
                                        _g)), name: 'ArrowRightOtto' })),
                            hasInfoInsideCard && (React__namespace.default.createElement(Info, { infoTitle: infoTitle, link: link, list: list, miniCard: miniCard, infoInsideCard: infoInsideCard, text: text, richtext: richtext })),
                            hasImage && (React__namespace.default.createElement("div", { className: classNames__default.default(css$J.imageContainer, (_h = {},
                                    _h[css$J.fullWidth] = fullWidthImage,
                                    _h[css$J.mediaLeft] = mediaPosition === 'left',
                                    _h)) }, hasImageResizing ? (validateBreakpointCollection(image) ||
                                image.map(function (imgResized, index) { return (React__namespace.default.createElement(ImgResized, __assign({ className: css$J.image }, imgResized, { key: imgResized._uid + String(index) }))); })) : (React__namespace.default.createElement(AdvanceImage, __assign({ className: css$J.image }, image[0].asset, { src: image[0].asset.image, key: image[0].asset.image })))))))))),
        React__namespace.default.createElement("div", null, hasInfoOutsideCard && (React__namespace.default.createElement(Info, { infoTitle: infoTitle, link: link, list: list, miniCard: miniCard, infoInsideCard: infoInsideCard, text: text, richtext: richtext })))));
};

var css$H = {"cardGroup":"styles_cardGroup__mS5x0","miniCards":"styles_miniCards__l6cCs","cards-3":"styles_cards-3__-IDyz"};

var StandardCardGroup = function (_a) {
    var _b;
    var _c = _a.cards, cards = _c === void 0 ? [] : _c, layout = _a.layout, miniCards = _a.miniCards, infoInsideCard = _a.infoInsideCard, rest = __rest(_a, ["cards", "layout", "miniCards", "infoInsideCard"]);
    var isAllowedLargeCardConfiguration = function (index) {
        if (index === 0 && cards.length === 3 && cards[2].largeCard) {
            return false;
        }
        if (index === 1 && cards.length === 3) {
            return false;
        }
        return true;
    };
    var getNumberOfLargeCards = function () {
        var largeCards = 0;
        cards.map(function (card, index) {
            return card.largeCard && isAllowedLargeCardConfiguration(index) && largeCards++;
        });
        return largeCards;
    };
    return (React__namespace.default.createElement(ContainerLayout, __assign({}, layout[0], react.storyblokEditable(rest)),
        React__namespace.default.createElement("div", { className: classNames__default.default(css$H.cardGroup, css$H["cards-".concat(cards.length)], (_b = {},
                _b[css$H.miniCards] = miniCards,
                _b)) }, cards.map(function (card, index) { return (React__namespace.default.createElement(StandardCard, __assign({}, card, { largeCard: card.largeCard && isAllowedLargeCardConfiguration(index), miniCard: miniCards, infoInsideCard: infoInsideCard, numberOfCards: cards.length, numberOfLargeCards: getNumberOfLargeCards(), key: card._uid }))); }))));
};

var css$G = {"variableTextDefaultColor":"#001c64","column":"styles_column__sIwX6","icon":"styles_icon__iRUnw","flag":"styles_flag__fZnP9","deprecated":"styles_deprecated__wbz5C","textContainer":"styles_textContainer__OTxQN","noIcon":"styles_noIcon__0sbEP","large":"styles_large__fXFTx","withHeading":"styles_withHeading__B7eOy","center":"styles_center__zANrR","withIllustration":"styles_withIllustration__Avuds","illustration":"styles_illustration__9FILe","withImage":"styles_withImage__GZm2l","nrColumns2":"styles_nrColumns2__NcnFT","nrColumns4":"styles_nrColumns4__NI2bs"};

var TextGridItem = function (_a) {
    var _b, _c;
    var heading = _a.heading, icon = _a.icon, ottoIcon = _a.ottoIcon, iconSize = _a.iconSize, flag = _a.flag, text = _a.text, illustration = _a.illustration, _d = _a.center, center = _d === void 0 ? false : _d, _e = _a.withImage, withImage = _e === void 0 ? false : _e, _f = _a.nrColumns, nrColumns = _f === void 0 ? 0 : _f;
    var ottoIcons = useOttoIcons().ottoIcons;
    var renderVisual = function () {
        if (illustration === null || illustration === void 0 ? void 0 : illustration.image) {
            return (React__namespace.default.createElement(Img, __assign({ className: css$G.illustration }, illustration, { src: illustration.image, key: illustration._uid })));
        }
        else if (flag) {
            return (React__namespace.default.createElement(Svg, { name: flag, className: classNames__default.default(css$G.icon, css$G.flag) }));
        }
        else if (isOttoIconBlock(ottoIcon) &&
            isOttoIconData(ottoIcons[String(ottoIcon[0].icon)])) {
            return (React__namespace.default.createElement("span", { className: css$G.icon },
                React__namespace.default.createElement(OttoIcon, __assign({ color: css$G.variableTextDefaultColor }, ottoIcon[0], { icon: ottoIcons[String(ottoIcon[0].icon)] }))));
        }
        return null;
    };
    return (React__namespace.default.createElement("div", { className: classNames__default.default(css$G.column, css$G["nrColumns".concat(nrColumns)], css$G[iconSize], (_b = {},
            _b[css$G.withHeading] = heading === null || heading === void 0 ? void 0 : heading.length,
            _b[css$G.center] = center,
            _b[css$G.withIllustration] = illustration === null || illustration === void 0 ? void 0 : illustration.image,
            _b[css$G.withImage] = withImage,
            _b)) },
        renderVisual(),
        React__namespace.default.createElement("div", { className: css$G.textContainer },
            heading && (React__namespace.default.createElement("h3", { className: classNames__default.default('headline-6', (_c = {}, _c[css$G.noIcon] = !icon, _c)) }, heading)),
            React__namespace.default.createElement(Richtext, { body: text, className: classNames__default.default(css$G.richtext) }))));
};

var css$F = {"container":"styles_container__KdnYc","gridWidth":"styles_gridWidth__XLl-V","topContainer":"styles_topContainer__cvVDv","heading":"styles_heading__DYK3E","topLink":"styles_topLink__BQauB","bottomLink":"styles_bottomLink__sc59D","center":"styles_center__ubSy8","withIllustrations":"styles_withIllustrations__Bwhwq","withImage":"styles_withImage__BtNVh","imageContainer":"styles_imageContainer__lVdjt","columns":"styles_columns__nG19k","image":"styles_image__isSgW","noTopPadding":"styles_noTopPadding__ctN5x"};

var TextGrid = function (_a) {
    var _b;
    var _c, _d;
    var heading = _a.heading, link = _a.link, image = _a.image, enableImage = _a.enableImage, _e = _a.textGridItems, textGridItems = _e === void 0 ? [] : _e, layout = _a.layout, iconSize = _a.iconSize, alignment = _a.alignment, backgroundColor = _a.backgroundColor, noTopPadding = _a.noTopPadding, rest = __rest(_a, ["heading", "link", "image", "enableImage", "textGridItems", "layout", "iconSize", "alignment", "backgroundColor", "noTopPadding"]);
    var gridProfile = (layout[0] || {}).gridProfile;
    var centerAlign = alignment === 'center';
    return (React__namespace.default.createElement(ContainerLayout, __assign({}, layout[0], react.storyblokEditable(rest)),
        React__namespace.default.createElement(ConditionalWrapper, { condition: enableImage, wrapper: function (children) {
                var _a;
                return (React__namespace.default.createElement("div", { className: css$F.withImage },
                    React__namespace.default.createElement("div", { className: classNames__default.default(css$F.imageContainer, [backgroundColor], (_a = {},
                            _a[css$F.withImage] = enableImage,
                            _a)) },
                        React__namespace.default.createElement(Img, __assign({ className: css$F.image }, image, { src: image === null || image === void 0 ? void 0 : image.image, key: image === null || image === void 0 ? void 0 : image._uid }))),
                    children));
            } },
            React__namespace.default.createElement("div", { className: classNames__default.default(css$F.container, [backgroundColor], (_b = {},
                    _b['px-grid-margin'] = gridProfile === 'full-width-no-margins',
                    _b[css$F.gridWidth] = gridProfile === 'full-width-with-margins',
                    _b[css$F.center] = centerAlign,
                    _b[css$F.withIllustrations] = (_d = (_c = textGridItems === null || textGridItems === void 0 ? void 0 : textGridItems[0]) === null || _c === void 0 ? void 0 : _c.illustration) === null || _d === void 0 ? void 0 : _d.image,
                    _b[css$F.noTopPadding] = noTopPadding,
                    _b)) },
                React__namespace.default.createElement("div", { className: css$F.topContainer },
                    heading && React__namespace.default.createElement(Richtext, { body: heading, className: css$F.heading }),
                    link[0] && React__namespace.default.createElement(StyledLink, __assign({}, link[0], { className: css$F.topLink }))),
                React__namespace.default.createElement("div", { className: css$F.columns }, textGridItems.length > 0 &&
                    textGridItems.map(function (_a) {
                        var _uid = _a._uid, item = __rest(_a, ["_uid"]);
                        return (React__namespace.default.createElement(TextGridItem, __assign({ key: _uid }, item, { center: centerAlign, withImage: enableImage, nrColumns: textGridItems.length, iconSize: iconSize })));
                    })),
                link[0] && React__namespace.default.createElement(StyledLink, __assign({}, link[0], { className: css$F.bottomLink }))))));
};

var css$E = {"cookieSettingWrapper":"styles_cookieSettingWrapper__xIdpD"};

var OnetrustCookieSettings = function (_a) {
    var settingsButton = _a.settingsButton, layout = _a.layout;
    return (React__namespace.default.createElement(ContainerLayout, __assign({}, layout[0]),
        React__namespace.default.createElement("div", { className: css$E.cookieSettingWrapper },
            React__namespace.default.createElement("button", { id: "ot-sdk-btn", className: "ot-sdk-show-settings" }, settingsButton[0] && settingsButton[0].text))));
};

var css$D = {"cookieListWrapper":"styles_cookieListWrapper__5U8PK"};

var OnetrustCookieList = function (_a) {
    var title = _a.title, layout = _a.layout;
    return (React__namespace.default.createElement(ContainerLayout, __assign({}, layout[0]),
        title && React__namespace.default.createElement("h2", null, title),
        React__namespace.default.createElement("div", { className: css$D.cookieListWrapper },
            React__namespace.default.createElement("div", { id: "ot-sdk-cookie-policy" }))));
};

var sharedComponents = {
    Accordion: Accordion,
    Image: Image$1,
    ImgResized: ImgResized,
    ImageSection: ImageSection,
    ImageStatic: ImageStatic,
    List: List,
    ListCircle: ListCircle,
    NavigationTree: NavigationTree,
    StatusBanner: StatusBanner,
    CalloutBlock: CalloutBlock,
    OnetrustCookieSettings: OnetrustCookieSettings,
    OnetrustCookieList: OnetrustCookieList,
    Richtext: Richtext,
    StandardCard: StandardCard,
    StandardCardGroup: StandardCardGroup,
    StandardModule: StandardModule,
    Table: Table,
    TableStandard: TableStandard,
    TextGrid: TextGrid,
    VideoContainer: VideoContainer
};
var sharedUtils = {
    ottoUtils: ottoUtils
};

var HeaderContext = React.createContext({
    isMobileNavOpen: false,
    /* eslint-disable @typescript-eslint/no-empty-function */
    toggleMobileNav: function () { },
    /* eslint-disable @typescript-eslint/no-empty-function */
    closeMobileNav: function () { }
});
var HeaderContextProvider = function (_a) {
    var children = _a.children;
    var _b = React.useState(false), isMobileNavOpen = _b[0], setIsOpen = _b[1];
    var toggleMobileNav = function () { return setIsOpen(!isMobileNavOpen); };
    var closeMobileNav = function () { return setIsOpen(false); };
    return (React__namespace.default.createElement(HeaderContext.Provider, { value: { isMobileNavOpen: isMobileNavOpen, toggleMobileNav: toggleMobileNav, closeMobileNav: closeMobileNav } }, children));
};

var ArticleContentLegacy = function (_a) {
    var body = _a.body, title = _a.title, rest = __rest(_a, ["body", "title"]);
    var updatedHtml = React.useMemo(function () {
        return body.content
            ? {
                __html: updateHtml(body.content, __assign(__assign(__assign(__assign({}, setLinkStyle('text-underline--hover')), setLinksRel), wrapTables('table-responsive')), setIframeAspectRatio))
            }
            : null;
    }, [body.content]);
    return (React__namespace.default.createElement("article", __assign({ "aria-label": title, className: classNames__default.default('desk-migration', 'rich-text', 'help-center-article') }, react.storyblokEditable(rest)), updatedHtml && React__namespace.default.createElement("div", { dangerouslySetInnerHTML: updatedHtml })));
};

var FeedbackButtons;
(function (FeedbackButtons) {
    FeedbackButtons[FeedbackButtons["POSITIVE"] = 0] = "POSITIVE";
    FeedbackButtons[FeedbackButtons["NEUTRAL"] = 1] = "NEUTRAL";
    FeedbackButtons[FeedbackButtons["NEGATIVE"] = 2] = "NEGATIVE";
})(FeedbackButtons || (FeedbackButtons = {}));
var IconNames;
(function (IconNames) {
    IconNames["POSITIVE"] = "Smile";
    IconNames["NEUTRAL"] = "Neutral";
    IconNames["NEGATIVE"] = "Sad";
})(IconNames || (IconNames = {}));
var TrackingFeedbackNames;
(function (TrackingFeedbackNames) {
    TrackingFeedbackNames["POSITIVE"] = "yes";
    TrackingFeedbackNames["NEUTRAL"] = "neutral";
    TrackingFeedbackNames["NEGATIVE"] = "no";
})(TrackingFeedbackNames || (TrackingFeedbackNames = {}));
var LikeParams;
(function (LikeParams) {
    LikeParams["POSITIVE"] = "1";
    LikeParams["NEUTRAL"] = "0";
    LikeParams["NEGATIVE"] = "-1";
})(LikeParams || (LikeParams = {}));

var css$C = {"container":"styles_container__6oVeL","feedbackArea":"styles_feedbackArea__iha1P","button":"styles_button__Inbzy","positive":"styles_positive__uoQzj","chosen":"styles_chosen__lu6Be","neutral":"styles_neutral__NoJ3G","negative":"styles_negative__NnG9C","icon":"styles_icon__Pz3NM","thankYou":"styles_thankYou__E549C"};

var FeedbackButton = function (_a) {
    var _b;
    var name = _a.name, label = _a.label, selection = _a.selection, handleClick = _a.handleClick;
    var buttonName = FeedbackButtons[name];
    var styleName = buttonName.toLowerCase();
    var iconName = IconNames[buttonName];
    var trackingName = TrackingFeedbackNames[buttonName];
    return (React__namespace.default.createElement("button", { id: "feedback-".concat(trackingName), name: buttonName, className: classNames__default.default(css$C.button, css$C[styleName], (_b = {},
            _b[css$C.chosen] = selection === buttonName,
            _b)), onClick: handleClick, disabled: !!selection, "aria-label": label !== null && label !== void 0 ? label : buttonName },
        React__namespace.default.createElement(Svg, { ariaHidden: true, name: iconName, className: css$C.icon })));
};

var css$B = {"surveyIframe":"styles_surveyIframe__TXxA3","heightPlus1":"styles_heightPlus1__izzob","heightPlus2":"styles_heightPlus2__Pz75L","heightPlus3":"styles_heightPlus3__7A-Ry","heightPlus4":"styles_heightPlus4__C0gSS","heightPlus5":"styles_heightPlus5__XMyCT","heightPlus6":"styles_heightPlus6__Gkxh3","heightPlus7":"styles_heightPlus7__T-ZZn"};

var SurveyIframe = function (_a) {
    var _b;
    var embedUrl = _a.embedUrl, feedback = _a.feedback, surveyDescription = _a.surveyDescription, surveyTriggers = _a.surveyTriggers, heightAdjustment = _a.heightAdjustment, articleId = _a.articleId, fullSlug = _a.fullSlug, children = _a.children;
    var ottoIcons = useOttoIcons().ottoIcons;
    var likeName = LikeParams[feedback];
    var isTriggered = surveyTriggers === null || surveyTriggers === void 0 ? void 0 : surveyTriggers.includes(feedback);
    if (!embedUrl || !isTriggered)
        return React__namespace.default.createElement(React__namespace.default.Fragment, null, children);
    return (React__namespace.default.createElement("div", { className: classNames__default.default(css$B.surveyIframe, heightAdjustment ? css$B["heightPlus".concat(heightAdjustment)] : '') },
        surveyDescription && (React__namespace.default.createElement(Html, { html: renderStoryblokRichText(((_b = surveyDescription === null || surveyDescription === void 0 ? void 0 : surveyDescription[0]) === null || _b === void 0 ? void 0 : _b.body) || { ottoIcons: ottoIcons }) })),
        React__namespace.default.createElement("iframe", { title: "Article Feedback Survey", src: embedUrl +
                likeName +
                "&page_title=".concat(articleId) +
                "&url=".concat(fullSlug) +
                "&gf_hide_progress&gf_navigation_bottom&gf_navigation_narrow&gf_footer_background_off&gf_hide_logo" })));
};

var ArticleFeedback = function (_a) {
    var _b;
    var title = _a.title, thankYouMessage = _a.thankYouMessage, feedbackButtons = _a.feedbackButtons, positiveButtonLabel = _a.positiveButtonLabel, neutralButtonLabel = _a.neutralButtonLabel, negativeButtonLabel = _a.negativeButtonLabel, surveyTriggers = _a.surveyTriggers, surveyDescription = _a.surveyDescription, embedUrl = _a.embedUrl, heightAdjustment = _a.heightAdjustment, articleId = _a.articleId, fullSlug = _a.fullSlug, _c = _a.path, path = _c === void 0 ? '' : _c, rest = __rest(_a, ["title", "thankYouMessage", "feedbackButtons", "positiveButtonLabel", "neutralButtonLabel", "negativeButtonLabel", "surveyTriggers", "surveyDescription", "embedUrl", "heightAdjustment", "articleId", "fullSlug", "path"]);
    var _d = React.useState(), feedback = _d[0], setFeedback = _d[1];
    var buttonLabels = (_b = {},
        _b[FeedbackButtons[FeedbackButtons.POSITIVE]] = positiveButtonLabel,
        _b[FeedbackButtons[FeedbackButtons.NEUTRAL]] = neutralButtonLabel,
        _b[FeedbackButtons[FeedbackButtons.NEGATIVE]] = negativeButtonLabel,
        _b);
    React.useEffect(function () {
        setFeedback(undefined);
    }, [path]);
    var handleClick = function (event) {
        event.preventDefault();
        setFeedback(event.currentTarget.name);
    };
    // button ids and css classes are used by GTM
    return (React__namespace.default.createElement("div", __assign({ className: "py-normal ".concat(css$C.container) }, react.storyblokEditable(rest)),
        React__namespace.default.createElement("div", { className: css$C.feedbackArea },
            React__namespace.default.createElement("h2", { className: 'headline-5' }, title),
            React__namespace.default.createElement("div", null, isNonEmptyArray(feedbackButtons) ? (feedbackButtons.map(function (feedbackButton) { return (React__namespace.default.createElement(FeedbackButton, { name: FeedbackButtons[feedbackButton], label: buttonLabels[feedbackButton], selection: feedback, handleClick: handleClick, key: feedbackButton })); })) : (React__namespace.default.createElement(React__namespace.default.Fragment, null,
                React__namespace.default.createElement(FeedbackButton, { name: FeedbackButtons.POSITIVE, label: buttonLabels[FeedbackButtons.POSITIVE], selection: feedback, handleClick: handleClick }),
                React__namespace.default.createElement(FeedbackButton, { name: FeedbackButtons.NEGATIVE, label: buttonLabels[FeedbackButtons.NEGATIVE], selection: feedback, handleClick: handleClick }))))),
        feedback && (React__namespace.default.createElement(SurveyIframe, { embedUrl: embedUrl, feedback: feedback, surveyDescription: surveyDescription, surveyTriggers: surveyTriggers, heightAdjustment: heightAdjustment, articleId: articleId, fullSlug: fullSlug },
            React__namespace.default.createElement("div", { className: css$C.thankYou }, thankYouMessage)))));
};

var css$A = {"badge":"styles_badge__EE4CT"};

var Badge = function (_a) {
    var _b = _a.color, color = _b === void 0 ? 'magnetic' : _b, text = _a.text;
    return (React__namespace.default.createElement("div", { className: classNames__default.default('colored-text', color, css$A.badge) }, text));
};

var BadgeGroup = function (_a) {
    var badges = _a.badges, rest = __rest(_a, ["badges"]);
    return (React__namespace.default.createElement("div", __assign({}, react.storyblokEditable(rest)), badges && badges.map(function (badge) { return React__namespace.default.createElement(Badge, __assign({ key: badge === null || badge === void 0 ? void 0 : badge._uid }, badge)); })));
};

var css$z = {"card":"styles_card__JUbAz","cardHeader":"styles_cardHeader__T6UR4","cardIcon":"styles_cardIcon__US-vE","cardTitle":"styles_cardTitle__TUi8O","iconArrow":"styles_iconArrow__aOR5v","pill":"styles_pill__l2Jtu","description":"styles_description__jHGND","pillMobile":"styles_pillMobile__bKW13","light-default":"styles_light-default__Uuivy","topTitle":"styles_topTitle__OoaIg"};

var SimplePill = function (_a) {
    var pillText = _a.pillText, className = _a.className;
    return (React__namespace.default.createElement("span", { className: className }, pillText));
};
var pillRemap = {
    info: 'blue',
    success: 'gold',
    error: 'black',
    warning: 'grey'
};
var Card = function (_a) {
    var title = _a.title, icon = _a.icon, url = _a.url, description = _a.description, pillText = _a.pillText, _b = _a.pillStyle, pillStyle = _b === void 0 ? 'info' : _b, _c = _a.cardStyle, cardStyle = _c === void 0 ? 'light-default' : _c, topTitle = _a.topTitle, rest = __rest(_a, ["title", "icon", "url", "description", "pillText", "pillStyle", "cardStyle", "topTitle"]);
    return (React__namespace.default.createElement("div", __assign({}, react.storyblokEditable(rest)),
        topTitle && (React__namespace.default.createElement("h2", { className: classNames__default.default('headline-3', css$z.topTitle) }, topTitle)),
        React__namespace.default.createElement(Link, { url: url, className: classNames__default.default(css$z.card, [css$z[cardStyle]]) },
            React__namespace.default.createElement("div", { className: css$z.cardHeader },
                icon && React__namespace.default.createElement(Svg, { className: css$z.cardIcon, name: icon }),
                React__namespace.default.createElement("h4", { className: classNames__default.default('title', css$z.cardTitle) }, title),
                pillText && (React__namespace.default.createElement(SimplePill, { className: classNames__default.default(css$z.pill, pillRemap[pillStyle]), pillText: pillText })),
                React__namespace.default.createElement(Svg, { name: 'ArrowRightOtto', className: classNames__default.default('color-action-inline', css$z.iconArrow) })),
            React__namespace.default.createElement("div", { className: css$z.description }, description),
            pillText && (React__namespace.default.createElement(SimplePill, { className: classNames__default.default(css$z.pillMobile, pillRemap[pillStyle]), pillText: pillText })))));
};

var css$y = {"yiq-black":"#fff","yiq-white":"#001c64","yiq-blue-400":"#fff","yiq-blue-500":"#fff","yiq-blue":"#fff","yiq-gold":"#001c64","yiq-neutral":"#001c64","yiq-grey":"#fff","yiq-purple-200":"#001c64","yiq-mint":"#fff","black":"#000","white":"#fff","primary-blue-400":"#0070e0","primary-blue-500":"#003087","primary-blue-600":"#001c64","gold-400":"#ffd140","neutral-100":"#faf8f5","grey-500":"#545d68","red-600":"#9b0021","green-600":"#005400","purple-600":"#24247f"};

var borderColors = {
    'border-grey': css$y['grey-500'],
    'border-blue': css$y['primary-blue-600'],
    'border-red': css$y['red-600'],
    'border-green': css$y['green-600'],
    'border-purple': css$y['purple-600']
};
var borderColorUtilityClasses = Object.keys(borderColors);

var css$x = {"cardWithImage":"styles_cardWithImage__t7-Bp","bordered":"styles_bordered__-G-1e","imgContainer":"styles_imgContainer__w2Iye","content":"styles_content__h82mT"};

var CardWithImage = function (_a) {
    var _b;
    var title = _a.title, url = _a.url, image = _a.image, borderColor = _a.borderColor, description = _a.description, rest = __rest(_a, ["title", "url", "image", "borderColor", "description"]);
    var resizedImg = image.image &&
        convertUrl(image.image, {
            width: 170,
            height: 170
        });
    var placeholderImg = 'http://img2.storyblok.com/170x170/f/68896/3074x1198/d04d0d0404/xlarge-1.jpg';
    var borderExists = "border-".concat(borderColor) in borderColorUtilityClasses;
    return (React__namespace.default.createElement(Link, __assign({ url: url, title: title, className: classNames__default.default(css$x.cardWithImage, (_b = {},
            _b[css$x.bordered] = borderExists,
            _b["border-".concat(borderColor)] = borderExists,
            _b)) }, react.storyblokEditable(rest)),
        React__namespace.default.createElement("div", { className: classNames__default.default(css$x.imgContainer), style: { backgroundImage: "url(\"".concat(resizedImg || placeholderImg, "\")") } }),
        React__namespace.default.createElement("div", { className: css$x.content },
            React__namespace.default.createElement("h3", { className: "headline-mini pb-2" }, title || 'UNTITLED'),
            React__namespace.default.createElement("p", null, description ||
                'Lorem ipsum eget eros et tortor fermentum iaculis. Nam non arcu eu turpis egestas porta. Duis ultricies bibendum id faucibus tellus nibh mec massa ucibus.'))));
};

var css$w = {"cardWithVideo":"styles_cardWithVideo__l1jHe","border":"styles_border__vTPxe","caption":"styles_caption__1QQmJ","header":"styles_header__kqSrY","duration":"styles_duration__3cF7v"};

var defaultMaxWidth = 650;
var CardWithVideo = function (_a) {
    var _b;
    var _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    var videoContainer = _a.videoContainer, vimeo = _a.vimeo, _p = _a.autoFill, autoFill = _p === void 0 ? false : _p, youtubeId = _a.youtubeId, manualTitle = _a.manualTitle, manualDescription = _a.manualDescription, manualDuration = _a.manualDuration, maxWidth = _a.maxWidth, _q = _a.border, border = _q === void 0 ? false : _q, rest = __rest(_a, ["videoContainer", "vimeo", "autoFill", "youtubeId", "manualTitle", "manualDescription", "manualDuration", "maxWidth", "border"]);
    var title = manualTitle, description = manualDescription, duration = manualDuration;
    var width = Number.isInteger(parseInt(maxWidth))
        ? parseInt(maxWidth)
        : defaultMaxWidth;
    if (autoFill) {
        var vimeoResponse = void 0;
        if (vimeo === null || vimeo === void 0 ? void 0 : vimeo.vimeo_oembed) {
            vimeoResponse = vimeo.vimeo_oembed.response;
        }
        if (((_e = (_d = (_c = videoContainer === null || videoContainer === void 0 ? void 0 : videoContainer[0]) === null || _c === void 0 ? void 0 : _c.source) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.component) === 'vimeo') {
            vimeoResponse = (_j = (_h = (_g = ((_f = videoContainer === null || videoContainer === void 0 ? void 0 : videoContainer[0]) === null || _f === void 0 ? void 0 : _f.source)[0]) === null || _g === void 0 ? void 0 : _g.settings) === null || _h === void 0 ? void 0 : _h.vimeo_oembed) === null || _j === void 0 ? void 0 : _j.response;
        }
        // set title, description, duration
        title = (vimeoResponse === null || vimeoResponse === void 0 ? void 0 : vimeoResponse.title) || '';
        description = (vimeoResponse === null || vimeoResponse === void 0 ? void 0 : vimeoResponse.description) || '';
        duration = "".concat(Math.round(Number(vimeoResponse === null || vimeoResponse === void 0 ? void 0 : vimeoResponse.duration) / 60));
    }
    var videoContainerProps = __assign(__assign({}, videoContainer === null || videoContainer === void 0 ? void 0 : videoContainer[0]), { playButtonLabel: ((_k = videoContainer === null || videoContainer === void 0 ? void 0 : videoContainer[0]) === null || _k === void 0 ? void 0 : _k.playButtonLabel) || '', source: ((_l = videoContainer === null || videoContainer === void 0 ? void 0 : videoContainer[0]) === null || _l === void 0 ? void 0 : _l.source) ||
            (((_m = vimeo === null || vimeo === void 0 ? void 0 : vimeo.vimeo_oembed) === null || _m === void 0 ? void 0 : _m.response)
                ? [{ settings: vimeo, component: 'vimeo' }]
                : youtubeId
                    ? [{ youtubeId: youtubeId, component: 'youtube' }]
                    : []), manualTitle: title || ((_o = videoContainer === null || videoContainer === void 0 ? void 0 : videoContainer[0]) === null || _o === void 0 ? void 0 : _o.manualTitle), maxWidth: width });
    return (React__namespace.default.createElement("div", __assign({ className: classNames__default.default(css$w.cardWithVideo, (_b = {},
            _b[css$w.border] = border,
            _b)), style: { maxWidth: width } }, react.storyblokEditable(rest)),
        React__namespace.default.createElement(VideoContainer, __assign({}, videoContainerProps)),
        React__namespace.default.createElement("div", { className: classNames__default.default(css$w.caption, 'last-element-nospace') },
            (!!title || !!duration) && (React__namespace.default.createElement("div", { className: css$w.header },
                title && (React__namespace.default.createElement("h2", { "data-testid": "title", className: "headline-7" }, title)),
                duration && (React__namespace.default.createElement("div", { className: classNames__default.default('text-body', css$w.duration) },
                    React__namespace.default.createElement(Svg, { name: 'Play' }),
                    "\u00A0",
                    duration,
                    " min")))),
            description && React__namespace.default.createElement("p", { "data-testid": "description" }, description))));
};

var css$v = {"cardGroup":"styles_cardGroup__iH2le","sectionTitle":"styles_sectionTitle__7emAV","cardContainer":"styles_cardContainer__9AhwJ","cardWrapper":"styles_cardWrapper__f6iBb"};

var Components$5 = buildComponentsObject({ Card: Card, CardWithImage: CardWithImage, CardWithVideo: CardWithVideo });
var CardGroup = function (_a) {
    var sectionTitle = _a.sectionTitle, _b = _a.cards, cards = _b === void 0 ? [] : _b, cardStyle = _a.cardStyle, layout = _a.layout, rest = __rest(_a, ["sectionTitle", "cards", "cardStyle", "layout"]);
    return (React__namespace.default.createElement(SectionLayout, __assign({}, layout[0], { className: css$v.cardGroup }, react.storyblokEditable(rest)),
        sectionTitle && (React__namespace.default.createElement("h2", { className: classNames__default.default('headline-3', 'section-text-align', css$v.sectionTitle) }, sectionTitle)),
        React__namespace.default.createElement("div", { className: css$v.cardContainer }, cards.map(function (card) { return (React__namespace.default.createElement("div", { className: css$v.cardWrapper, key: card._uid }, React__namespace.default.createElement(Components$5[card.component], __assign({ cardStyle: cardStyle }, card)))); }))));
};

var css$u = {"linkStyled":"styles_linkStyled__RguaZ","linkLarge":"styles_linkLarge__ReyIy","icon":"styles_icon__j8Zl7"};

var LinkStyled = function (_a) {
    var component = _a.component, props = __rest(_a, ["component"]);
    return (React__namespace.default.createElement(React__namespace.default.Fragment, null,
        component === 'link-styled' && (React__namespace.default.createElement(LinkStyledLegacy, __assign({}, props))),
        component === 'styled-link' && (React__namespace.default.createElement(StyledLink, __assign({}, props)))));
};
var LinkStyledLegacy = function (_a) {
    var _b, _c, _d;
    var url = _a.url, text = _a.text, color = _a.color, _e = _a.type, type = _e === void 0 ? 'solid' : _e, icon = _a.icon; 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _a._uid; var props = __rest(_a, ["url", "text", "color", "type", "icon", "_uid"]);
    var button = type === 'outlined' || type === 'solid' || type === 'btn-mobile';
    var large = type === 'large';
    var colorKey = color || 'action-inline';
    var _f = getColorClasses(colorKey), colorClass = _f.color, backgroundColorClass = _f.background;
    return (React__namespace.default.createElement(Link, __assign({ url: url, className: classNames__default.default(css$u.linkStyled, (_b = {
                btn: button,
                large: large
            },
            _b[css$u.linkLarge] = large,
            _b['btn-mobile'] = type === 'btn-mobile',
            _b), colorClass != null && backgroundColorClass != null
            ? (_c = {},
                _c[colorClass] = true,
                _c[getHoverColorClass(colorKey)] = true,
                _c[backgroundColorClass] = type !== 'outlined' && button,
                _c['box-shadow--hover'] = type !== 'outlined' && button,
                _c) : (_d = {},
            _d["btn-".concat(colorKey)] = type !== 'outlined' && button,
            _d["btn-outline-".concat(colorKey)] = type === 'outlined' && button,
            _d[css$u["linkLarge-".concat(colorKey)]] = large,
            _d)) }, props),
        React__namespace.default.createElement("span", null, text),
        icon && (React__namespace.default.createElement(Svg, { className: css$u.icon, name: (icon === 'ArrowRight' ? 'ArrowRightOtto' : icon) }))));
};

var placeholderLink = {
    url: { id: '', linktype: '', fieldtype: '', url: '', cached_url: '' },
    _uid: '',
    text: 'Enter CTA link...',
    component: 'link-styled'
};
var CtaLinkSection = function (_a) {
    var link = _a.link, layout = _a.layout, rest = __rest(_a, ["link", "layout"]);
    return (React__namespace.default.createElement(SectionLayout, __assign({}, layout[0], react.storyblokEditable(rest)),
        React__namespace.default.createElement("div", { className: "section-text-align" },
            React__namespace.default.createElement(LinkStyled, __assign({}, (link[0] ? link[0] : placeholderLink))))));
};

var HtmlContent = React.memo(function (_a) {
    var body = _a.body, rest = __rest(_a, ["body"]);
    return (React__namespace.default.createElement("div", __assign({ className: "html-content pt-3" }, react.storyblokEditable(rest)), body && React__namespace.default.createElement(Html, { html: body.content })));
});

var css$t = {"faq":"styles_faq__MvXRH","questionContainer":"styles_questionContainer__6SA6I","question":"styles_question__NjN8X","answer":"styles_answer__zgZ7g","open":"styles_open__-ro72","toggle":"styles_toggle__653dM","icon":"styles_icon__b5YbZ"};

var Components$4 = buildComponentsObject({ HtmlContent: HtmlContent, LinkStyled: LinkStyled });
var Faq = function (_a) {
    var 
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    _b = _a.onClick, 
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onClick = _b === void 0 ? function () { } : _b, _c = _a.index, index = _c === void 0 ? 0 : _c, question = _a.question, answer = _a.answer, _d = _a.isOpen, isOpen = _d === void 0 ? false : _d, _uid = _a._uid;
    var handleClick = React.useCallback(function () { return onClick(index); }, [onClick, index]);
    var titleId = "title".concat(_uid);
    var answerId = "answer".concat(_uid);
    /* eslint-disable jsx-a11y/click-events-have-key-events */
    return (React__namespace.default.createElement("div", { className: classNames__default.default(css$t.faq, isOpen ? css$t.open : null), "data-testid": "faq" },
        React__namespace.default.createElement(OtherTagButton, { tag: "div", className: classNames__default.default(css$t.questionContainer, 'focus-pp'), onPress: handleClick, "aria-labelledby": titleId, tabIndex: 0, "aria-expanded": isOpen, "aria-controls": answerId },
            React__namespace.default.createElement("span", { className: css$t.question, id: titleId }, question),
            React__namespace.default.createElement("span", null,
                React__namespace.default.createElement("div", { className: css$t.toggle, "data-testid": "faq-toggle" }, isOpen ? (React__namespace.default.createElement(Svg, { className: css$t.icon, name: "Minus", ariaHidden: true })) : (React__namespace.default.createElement(Svg, { className: css$t.icon, name: "Plus", ariaHidden: true }))))),
        React__namespace.default.createElement("div", { className: classNames__default.default(css$t.answer, 'last-element-nospace'), id: answerId, style: { display: isOpen ? 'block' : 'none' }, "aria-hidden": !isOpen, "aria-labelledby": titleId, role: 'region' }, answer &&
            answer.map(function (block) { return (React__namespace.default.createElement("div", { key: block._uid }, React__namespace.default.createElement(Components$4[block.component], __assign(__assign({}, block), { noFocus: !isOpen })))); }))));
};

var css$s = {"expandingFaq":"styles_expandingFaq__H3sL3","faqWrapper":"styles_faqWrapper__1EfR1","footnote":"styles_footnote__YuUGB"};

var transformFaqPropsToFaqItem = function (faqs) {
    return faqs.map(function (_a) {
        var _b, _c;
        var question = _a.question, answer = _a.answer;
        return ({
            title: question,
            body: {
                type: 'doc',
                content: [{ type: 'text', text: (_c = (_b = answer[0]) === null || _b === void 0 ? void 0 : _b.body) === null || _c === void 0 ? void 0 : _c.content }]
            }
        });
    });
};
var ExpandingFaq = function (_a) {
    var title = _a.title, footnote = _a.footnote, _b = _a.faqs, faqs = _b === void 0 ? [] : _b, autoCollapse = _a.autoCollapse, enableFaqStructuredData = _a.enableFaqStructuredData, layout = _a.layout, rest = __rest(_a, ["title", "footnote", "faqs", "autoCollapse", "enableFaqStructuredData", "layout"]);
    var _c = React.useState([]), currentItems = _c[0], setCurrentItems = _c[1];
    var handleFaqClick = React.useCallback(function (index) {
        if (!currentItems.includes(index)) {
            var preserveSelection = autoCollapse ? [] : currentItems;
            setCurrentItems(__spreadArray(__spreadArray([], preserveSelection, true), [index], false));
        }
        else {
            setCurrentItems(currentItems.filter(function (selected) { return selected !== index; }));
        }
    }, [currentItems, autoCollapse]);
    return (React__namespace.default.createElement(SectionLayout, __assign({}, layout[0], react.storyblokEditable(rest)),
        React__namespace.default.createElement("div", { className: css$s.expandingFaq },
            title && (React__namespace.default.createElement("h2", { className: classNames__default.default('headline-3', 'section-text-align') }, title)),
            React__namespace.default.createElement("div", { className: css$s.faqWrapper }, faqs.map(function (faq, index) { return (React__namespace.default.createElement(Faq, __assign({ key: faq._uid, index: index, onClick: handleFaqClick, isOpen: currentItems.includes(index) }, faq))); })),
            enableFaqStructuredData ? (React__namespace.default.createElement(FaqStructuredData, { items: transformFaqPropsToFaqItem(faqs) })) : (''),
            footnote && (React__namespace.default.createElement("div", { className: css$s.footnote }, footnote && React__namespace.default.createElement(Html, { html: footnote.content }))))));
};

var css$r = {"footerBottom":"styles_footerBottom__GHK2-","iconLogo":"styles_iconLogo__SXD6B","copyright":"styles_copyright__XA45S"};

var FooterBottom = function (_a) {
    var footerBottomText = _a.footerBottomText;
    return (React__namespace.default.createElement(Col, { xs: 4, className: css$r.footerBottom },
        React__namespace.default.createElement(Svg, { name: "LogoPayPalPrimaryPositive", className: css$r.iconLogo }),
        footerBottomText && (React__namespace.default.createElement("div", { className: css$r.copyright },
            React__namespace.default.createElement(Html, { html: footerBottomText.content })))));
};

var prependSlash = function (string) {
    return string.startsWith('/') || string.startsWith('http') ? string : "/".concat(string);
};

var css$q = {"dropdownContainer":"styles_dropdownContainer__TeJ5a","hide":"styles_hide__3kate","chevron":"styles_chevron__tVmXj","flagIcon":"styles_flagIcon__OdXvA","currentCountry":"styles_currentCountry__BbXO3","iconDown":"styles_iconDown__TGH0y","isOpen":"styles_isOpen__zivQy","countryListContainer":"styles_countryListContainer__YWhZu","countryItem":"styles_countryItem__WXUcH","iconFlag":"styles_iconFlag__rhuXS","webNextTheme":"styles_webNextTheme__CVmWX","noHover":"styles_noHover__n0iwQ","currentCountryText":"styles_currentCountryText__sSeKl"};

var sortAlphabeticallyByKey = function (arrayToSort, key) {
    return __spreadArray([], arrayToSort, true).sort(function (a, b) {
        if (a[key] < b[key]) {
            return -1;
        }
        if (a[key] > b[key]) {
            return 1;
        }
        return 0;
    });
};
var CountrySelectDropDown = function (_a) {
    var _b;
    var currentCountry = _a.currentCountry, countries = _a.countries, _c = _a.isWebNext, isWebNext = _c === void 0 ? false : _c, router = _a.router;
    var selectRef = React.useRef(null);
    var _d = React.useState(currentCountry), selectedCountry = _d[0], setSelectedCountry = _d[1];
    var allCountries = __spreadArray([], countries, true);
    var sortedCountries = sortAlphabeticallyByKey(allCountries, 'text');
    React.useEffect(function () {
        if (currentCountry._uid !== selectedCountry._uid) {
            setSelectedCountry(currentCountry);
        }
    }, [currentCountry._uid]);
    var handleSelect = function (e) {
        var _a;
        if (router) {
            router.push(sortedCountries[e.target.selectedIndex].url.url);
            (_a = selectRef === null || selectRef === void 0 ? void 0 : selectRef.current) === null || _a === void 0 ? void 0 : _a.blur(); // Blur the select element on select
        }
    };
    var ListItem = function (_a) {
        var url = _a.url, children = _a.children;
        return (React__namespace.default.createElement("li", null,
            React__namespace.default.createElement("a", { href: prependSlash(url) }, children)));
    };
    return (React__namespace.default.createElement("div", { className: classNames__default.default(css$q.dropdownContainer, (_b = {},
            _b[css$q.webNextTheme] = isWebNext,
            _b)) },
        React__namespace.default.createElement(Svg, { className: css$q.flagIcon, name: selectedCountry.icon, ariaHidden: true }),
        React__namespace.default.createElement(Svg, { className: css$q.chevron, name: "IconDownChevron", ariaHidden: true }),
        React__namespace.default.createElement("ul", { className: css$q.hide, "aria-hidden": true }, sortedCountries.map(function (_a) {
            var text = _a.text, url = _a.url, _uid = _a._uid;
            return (React__namespace.default.createElement(ListItem, { key: _uid, url: url.url }, text));
        })),
        React__namespace.default.createElement("select", { ref: selectRef, className: css$q.currentCountry, onChange: handleSelect, onBlur: function () {
                return;
            }, "aria-label": "Select country", "data-testid": "currentCountry", value: selectedCountry.text }, sortedCountries.map(function (_a) {
            var text = _a.text, _uid = _a._uid;
            return (React__namespace.default.createElement("option", { key: _uid, className: classNames__default.default(css$q.countryItem, 'focus-darken'), "data-testid": "countrySelectOption", value: text }, text));
        }))));
};

var css$p = {"countrySelect":"styles_countrySelect__uo3f1"};

var initialCurrentCountry = {
    url: {
        id: '',
        url: '/gb/help',
        linktype: 'url',
        fieldtype: 'multilink',
        cached_url: '#'
    },
    _uid: '',
    icon: 'FlagGb',
    text: 'United Kingdom'
};
var getUpdatedCountry = function (country, storyLinks) {
    var _a;
    if (country.url) {
        var countryCode = country.url.url.split('/')[1];
        country.url.url = (_a = storyLinks[countryCode]) !== null && _a !== void 0 ? _a : "/".concat(countryCode, "/help");
    }
    return country;
};
var filterCountries = function (lang, countries, storyLinks) {
    return countries.reduce(function (accumulator, current) {
        if (!current || !current.url) {
            return accumulator;
        }
        current.url.url.startsWith("/".concat(lang, "/"))
            ? (accumulator.currentCountry = current)
            : (accumulator.filteredCountries = __spreadArray(__spreadArray([], accumulator.filteredCountries, true), [
                getUpdatedCountry(current, storyLinks)
            ], false));
        return accumulator;
    }, {
        currentCountry: initialCurrentCountry,
        filteredCountries: []
    });
};
var CountrySelect = function (_a) {
    var _b;
    var countrySelectTitle = _a.countrySelectTitle, countries = _a.countries;
    var _c = React.useContext(SiteComponentContext), storyUuid = _c.storyUuid, internalLinks = _c.internalLinks, lang = _c.lang, useRouter = _c.hooks.useRouter;
    var storyLinks = (_b = internalLinks[storyUuid]) !== null && _b !== void 0 ? _b : {};
    var currentCountry = React.useMemo(function () { return filterCountries(lang, countries, storyLinks); }, [lang, countries, storyLinks]).currentCountry;
    var router = useRouter();
    return (React__namespace.default.createElement("div", { className: css$p.countrySelect },
        React__namespace.default.createElement(CountrySelectDropDown, { buttonLabel: countrySelectTitle, currentCountry: currentCountry, countries: countries, router: router })));
};

var css$o = {"footerSocialLinks":"styles_footerSocialLinks__ll6Re","socialLink":"styles_socialLink__LOsPf","iconSocial":"styles_iconSocial__dnuYm"};

var FooterSocialLinks = function (_a) {
    _a.socialLinksTitle; var socialLinks = _a.socialLinks;
    return (React__namespace.default.createElement("div", { className: css$o.footerSocialLinks },
        React__namespace.default.createElement("div", null, socialLinks.map(function (_a) {
            var url = _a.url, icon = _a.icon, text = _a.text, _uid = _a._uid;
            return (React__namespace.default.createElement(Link, { className: css$o.socialLink, key: _uid, url: url, "aria-labelledby": "title_".concat(_uid) },
                React__namespace.default.createElement(Svg, { ariaHidden: true, className: css$o.iconSocial, name: icon }),
                text && (React__namespace.default.createElement("span", { id: "title_".concat(_uid), className: "d-none" }, text))));
        }))));
};

var css$n = {"footerLinkGroup":"styles_footerLinkGroup__9HOfe","footerLink":"styles_footerLink__P2Gy4","iconLink":"styles_iconLink__SFgsA"};

var FooterLinkGroup = function (_a) {
    var title = _a.title, links = _a.links;
    return (React__namespace.default.createElement(Col, { xs: 4, md: 4, className: "lgColumn" },
        React__namespace.default.createElement("div", { className: css$n.footerLinkGroup },
            React__namespace.default.createElement("h4", { className: 'text-body-large' },
                React__namespace.default.createElement("strong", null, title)),
            React__namespace.default.createElement("ul", null, links.map(function (_a) {
                var url = _a.url, text = _a.text, icon = _a.icon, _uid = _a._uid;
                return (React__namespace.default.createElement("li", { key: _uid },
                    React__namespace.default.createElement(Link, { className: css$n.footerLink, url: url },
                        text,
                        icon && React__namespace.default.createElement(Svg, { className: css$n.iconLink, name: icon }))));
            })))));
};

var css$m = {"footer":"styles_footer__SYfjN","container":"styles_container__DqCrS","footerMain":"styles_footerMain__c4qxG"};

var Footer = function (_a) {
    var _b = _a.footerLinkGroups, footerLinkGroups = _b === void 0 ? [] : _b, countrySelectTitle = _a.countrySelectTitle, socialLinksTitle = _a.socialLinksTitle, _c = _a.countries, countries = _c === void 0 ? [] : _c, _d = _a.socialLinks, socialLinks = _d === void 0 ? [] : _d, footerBottomText = _a.footerBottomText, rest = __rest(_a, ["footerLinkGroups", "countrySelectTitle", "socialLinksTitle", "countries", "socialLinks", "footerBottomText"]);
    return (React__namespace.default.createElement("footer", __assign({ role: "contentinfo", className: classNames__default.default(css$m.footer, 'w-full', 'py-normal') }, react.storyblokEditable(rest)),
        React__namespace.default.createElement("div", { className: css$m.container },
            React__namespace.default.createElement(Row, { className: css$m.footerMain },
                footerLinkGroups &&
                    footerLinkGroups.map(function (_a) {
                        var _uid = _a._uid, rest = __rest(_a, ["_uid"]);
                        return (React__namespace.default.createElement(FooterLinkGroup, __assign({ key: _uid }, rest)));
                    }),
                footerLinkGroups.length === 2 && React__namespace.default.createElement(Col, { xs: 4, md: 4, lg: 3 }),
                React__namespace.default.createElement(Col, { xs: 4, md: 4, lg: 3 },
                    React__namespace.default.createElement(CountrySelect, { countrySelectTitle: countrySelectTitle, countries: countries }),
                    React__namespace.default.createElement(FooterSocialLinks, { socialLinksTitle: socialLinksTitle, socialLinks: socialLinks }))),
            React__namespace.default.createElement(Row, null,
                React__namespace.default.createElement(FooterBottom, { footerBottomText: footerBottomText })))));
};

var css$l = {"ctaGroup":"styles_ctaGroup__IVDY6"};

var css$k = {"tip":"styles_tip__VsRQv","icon-container":"styles_icon-container__x-EiJ","icon":"styles_icon__nUGim"};

var variants = {
    note: {
        icon: 'Checkmark',
        colorClasses: ['bg-highlight', 'border-action-primary', 'color-highlight'],
        iconColorClasses: ['bg-action-primary', 'color-action-primary']
    },
    warning: {
        icon: 'Cross',
        colorClasses: ['bg-warning', 'border-warning', 'color-warning'],
        iconColorClasses: ['salmon-dark']
    },
    advice: {
        icon: 'Star',
        colorClasses: ['bg-success', 'border-success', 'color-success'],
        iconColorClasses: ['mint']
    },
    settings: {
        icon: 'Sliders',
        colorClasses: ['bg-info', 'border-info', 'color-info'],
        iconColorClasses: ['magnetic']
    }
};
var Tip = function (_a) {
    var _b = _a.type, type = _b === void 0 ? 'note' : _b, body = _a.body, children = _a.children;
    var variant = variants[type];
    var html = body
        ? updateHtml(body.content, __assign({}, setLinkStyle('color-inherit text-underline')))
        : null;
    return (React__namespace.default.createElement("div", { className: classNames__default.default.apply(void 0, __spreadArray([[css$k.tip]], variant.colorClasses, false)) },
        React__namespace.default.createElement("div", { className: classNames__default.default.apply(void 0, __spreadArray([css$k['icon-container']], variant.iconColorClasses, false)) },
            React__namespace.default.createElement(Svg, { name: variant.icon, className: css$k.icon })),
        React__namespace.default.createElement("div", null,
            html && React__namespace.default.createElement(Html, { html: html }),
            children)));
};

var css$j = {"brandContainer":"styles_brandContainer__aInKS","logo":"styles_logo__so17z","title":"styles_title__j6gir"};

var defaultLink = {
    id: '123',
    url: 'https://www.izettle.com/gb/help',
    linktype: 'url',
    fieldtype: 'multilink',
    cached_url: 'https://www.izettle.com/gb/help'
};
var Brand = function (_a) {
    var _b = _a.logoLink, logoLink = _b === void 0 ? defaultLink : _b, _c = _a.logo, logo = _c === void 0 ? 'LogoPayPalPrimaryPositive' : _c, title = _a.title, ariaHidden = _a.ariaHidden, ariaLabel = _a.ariaLabel, tabIndex = _a.tabIndex;
    return (React__namespace.default.createElement("div", { className: css$j.brandContainer, "data-testid": "header-brand" },
        React__namespace.default.createElement(Link, __assign({ url: logoLink, tabIndex: tabIndex }, (title
            ? undefined
            : {
                'aria-label': ariaLabel
            }), { "aria-hidden": ariaHidden, className: 'focus-otto' }),
            React__namespace.default.createElement(Svg, { name: logo, className: css$j.logo, ariaLabel: ariaLabel }),
            title && React__namespace.default.createElement("span", { className: css$j.title }, title))));
};

var Components$3 = buildComponentsObject({ LinkStyled: LinkStyled, StyledLink: StyledLink });
var CtaGroup = function (_a) {
    var ctaItems = _a.ctaItems, className = _a.className;
    return (React__namespace.default.createElement("div", { className: classNames__default.default(className, [css$l.ctaGroup]) }, ctaItems &&
        ctaItems.map(function (cta) {
            return React__namespace.default.createElement(Components$3[cta.component], __assign({ key: cta._uid }, cta));
        })));
};

var css$i = {"expandingMenu":"styles_expandingMenu__1-fSI","title":"styles_title__nceTq","iconChevron":"styles_iconChevron__7vibk","focusOutline":"styles_focusOutline__1Gaeu","content":"styles_content__zDO6M","isOpen":"styles_isOpen__LX2co"};

var ExpandingMenu = function (_a) {
    var _b;
    var title = _a.title, children = _a.children, isOpen = _a.isOpen, setIsOpen = _a.setIsOpen, isVisible = _a.isVisible;
    var handleClick = function () { return setIsOpen(!isOpen); };
    return (React__namespace.default.createElement("div", { className: classNames__default.default(css$i.expandingMenu, (_b = {}, _b[css$i.isOpen] = isOpen, _b)) },
        React__namespace.default.createElement(OtherTagButton, { tag: "div", className: classNames__default.default(css$i.title, css$i.focusOutline), onPress: handleClick, "aria-expanded": isOpen, "aria-hidden": !isVisible, tabIndex: isVisible ? 0 : -1 },
            title,
            React__namespace.default.createElement(Svg, { className: css$i.iconChevron, name: 'IconDownChevronM' })),
        React__namespace.default.createElement("div", { className: css$i.content }, children)));
};

var css$h = {"mobileNav":"styles_mobileNav__1kyhl","navTop":"styles_navTop__c6hls","title":"styles_title__mfEYt","navBottom":"styles_navBottom__5INRF","mobileCtaGroup":"styles_mobileCtaGroup__xCpZp","ctaItem":"styles_ctaItem__fFalH","linkGroup":"styles_linkGroup__jy-km","isOpen":"styles_isOpen__r0JX-","mobileMenuLink":"styles_mobileMenuLink__3CHS3","clickArea":"styles_clickArea__E1DK1","linkText":"styles_linkText__Mu1MO"};

var MobileMenuLink = function (_a) {
    var url = _a.url, text = _a.text, icon = _a.icon, ottoIcon = _a.ottoIcon, ariaDescription = _a.ariaDescription, isVisible = _a.isVisible, _uid = _a._uid;
    var ottoIcons = useOttoIcons().ottoIcons;
    return (React__namespace.default.createElement(Link, { className: css$h.mobileMenuLink, url: url, "aria-describedby": ariaDescription && _uid, noFocus: !isVisible },
        React__namespace.default.createElement("div", { className: css$h.clickArea },
            React__namespace.default.createElement("span", { className: css$h.linkText }, text),
            isOttoIconBlock(ottoIcon) &&
                isOttoIconData(ottoIcons[String(ottoIcon[0].icon)]) ? (React__namespace.default.createElement(OttoIcon, __assign({}, ottoIcon[0], { icon: ottoIcons[String(ottoIcon[0].icon)] }))) : (icon && React__namespace.default.createElement(Svg, { className: css$h.iconLink, name: icon })),
            ariaDescription && (React__namespace.default.createElement("span", { id: _uid, className: 'd-none', "aria-hidden": true }, ariaDescription)))));
};
var MobileNav = function (_a) {
    var _b;
    var isOpen = _a.isOpen, ctaItems = _a.ctaItems, articleNavigation = _a.articleNavigation, headerNavigation = _a.headerNavigation, initialActiveStory = _a.initialActiveStory;
    var withoutMegaMenu = headerNavigation.filter(function (item) { return item.component !== 'mega-menu'; });
    var _c = React.useState(false), isExpandingMenuOpen = _c[0], setExpandingMenuOpen = _c[1];
    // According to the designs Article Megamenu should not be available in desktop view in article pages,
    // but article expanding tree should be visible in all layouts in mobile.
    // Therefore in this case need to filter out the megamenu from `headerNavigation` and render the rest.
    React.useEffect(function () {
        var body = document.body;
        isOpen ? body.classList.add('isOpen') : body.classList.remove('isOpen');
    }, [isOpen]);
    var toggledCtaItems = React.useMemo(function () {
        return ctaItems.map(function (item) {
            return (__assign(__assign({}, item), { noFocus: !isOpen }));
        });
    }, [ctaItems, isOpen]);
    return (React__namespace.default.createElement("nav", { "aria-label": "header mobile", "aria-hidden": !isOpen, className: classNames__default.default(css$h.mobileNav, 'w-full', (_b = {}, _b[css$h.isOpen] = isOpen, _b)) },
        React__namespace.default.createElement("div", { className: css$h.navTop },
            articleNavigation && (React__namespace.default.createElement(ExpandingMenu, { title: articleNavigation.mobileMenuTitle, isOpen: isExpandingMenuOpen, setIsOpen: setExpandingMenuOpen, isVisible: isOpen },
                React__namespace.default.createElement(NavigationTree, { menu: articleNavigation.menu, isMobile: true, initialOpen: !!initialActiveStory, isMobileExpanded: isOpen, isExpandingMenuOpen: isExpandingMenuOpen, closeOthers: true, initialActiveStory: initialActiveStory }))),
            withoutMegaMenu &&
                withoutMegaMenu.map(function (menuItem) { return (React__namespace.default.createElement(MobileMenuLink, __assign({ key: menuItem._uid }, menuItem, { isVisible: isOpen }))); })),
        React__namespace.default.createElement("div", { className: css$h.navBottom }, toggledCtaItems && React__namespace.default.createElement(CtaGroup, { ctaItems: toggledCtaItems }))));
};

var useClickOutside = function (ref, cb) {
    React.useEffect(function () {
        var listener = function (event) {
            if (!ref.current || ref.current.contains(event.target)) {
                return;
            }
            cb(event);
        };
        document.addEventListener('mousedown', listener);
        document.addEventListener('touchstart', listener);
        return function () {
            document.removeEventListener('mousedown', listener);
            document.removeEventListener('touchstart', listener);
        };
    }, [ref, cb]);
};

var css$g = {"megaMenu":"styles_megaMenu__sXlxH","title":"styles_title__OUsXj","menuItem":"styles_menuItem__Aob39","dropdown":"styles_dropdown__Xvj4R","isOpen":"styles_isOpen__I8kFM"};

var MegaMenu = function (_a) {
    var _b;
    var articleNavigation = _a.articleNavigation, initialActiveStory = _a.initialActiveStory, _c = _a.menuTitle, menuTitle = _c === void 0 ? 'Enter Title...' : _c, _d = _a.ottoIcon, ottoIcon = _d === void 0 ? 'IconSimpleArrowDownMedium' : _d;
    var ottoIcons = useOttoIcons().ottoIcons;
    var _e = React.useState(false), isOpen = _e[0], setIsOpen = _e[1];
    var ref = React.useRef(null);
    var handleClick = function () { return setIsOpen(!isOpen); };
    var pressProps = interactions.usePress({
        onPress: handleClick
    }).pressProps;
    var handleClickOutside = function (e) {
        if (e.target !== ref.current) {
            setIsOpen(false);
        }
    };
    useClickOutside(ref, handleClickOutside);
    /* eslint-disable jsx-a11y/click-events-have-key-events */
    return (React__namespace.default.createElement("div", { "data-testid": "mega-menu", className: classNames__default.default(css$g.megaMenu, (_b = {}, _b[css$g.isOpen] = isOpen, _b)), ref: ref },
        React__namespace.default.createElement("button", __assign({}, pressProps, { className: css$g.menuItem, "aria-expanded": isOpen }),
            menuTitle,
            React__namespace.default.createElement(OttoIcon, { icon: ottoIcons[ottoIcon], nonStandardSizeOverride: exports.OttoIconSizes.Small })),
        React__namespace.default.createElement("div", { className: css$g.dropdown },
            React__namespace.default.createElement("div", { className: classNames__default.default('title', css$g.title), "aria-hidden": true }, menuTitle),
            articleNavigation && (React__namespace.default.createElement(NavigationTree, { menu: articleNavigation.menu, closeOthers: true, initialActiveStory: initialActiveStory, initialOpen: isOpen, isMegaMenuOpen: isOpen, title: menuTitle, toggle: handleClick })))));
};

var css$f = {"desktopNav":"styles_desktopNav__qCESB","headerLink":"styles_headerLink__1ClXz"};

var HeaderLink = function (_a) {
    var url = _a.url, text = _a.text; _a.icon; _a.ottoIcon; var ariaDescription = _a.ariaDescription, _uid = _a._uid;
    useOttoIcons().ottoIcons;
    return (React__namespace.default.createElement(Link, { className: css$f.headerLink, url: url, "aria-describedby": ariaDescription && _uid },
        text,
        ariaDescription && (React__namespace.default.createElement("span", { id: _uid, className: 'd-none', "aria-hidden": true }, ariaDescription))));
};
var DesktopNav = function (_a) {
    var headerNavigation = _a.headerNavigation, articleNavigation = _a.articleNavigation, initialActiveStory = _a.initialActiveStory;
    return (React__namespace.default.createElement("div", { className: css$f.desktopNav }, headerNavigation.map(function (navItem) {
        switch (navItem.component) {
            case 'link':
                return React__namespace.default.createElement(HeaderLink, __assign({ key: navItem._uid }, navItem));
            case 'mega-menu':
                return (React__namespace.default.createElement(MegaMenu, __assign({ key: navItem._uid, articleNavigation: articleNavigation, initialActiveStory: initialActiveStory }, navItem)));
        }
    })));
};

var SearchContext = React.createContext({
    isOpen: false,
    /* eslint-disable @typescript-eslint/no-empty-function */
    toggle: function () { },
    /* eslint-disable @typescript-eslint/no-empty-function */
    close: function () { },
    /* eslint-disable @typescript-eslint/no-empty-function */
    setQuery: function () { },
    /* eslint-disable @typescript-eslint/no-empty-function */
    query: ''
});
var SearchContextProvider = function (_a) {
    var children = _a.children;
    var _b = React.useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var _c = React.useState(''), query = _c[0], setQuery = _c[1];
    var toggle = function () { return setIsOpen(!isOpen); };
    var close = function () { return setIsOpen(false); };
    return (React__namespace.default.createElement(SearchContext.Provider, { value: { isOpen: isOpen, toggle: toggle, close: close, query: query, setQuery: setQuery } }, children));
};

var css$e = {"hamburgerButton":"styles_hamburgerButton__n4Z5d"};

var Hamburger = function (_a) {
    var onClick = _a.onClick, open = _a.open, menuLabel = _a.menuLabel, menuCloseLabel = _a.menuCloseLabel;
    var ottoIcons = useOttoIcons().ottoIcons;
    var _b = React.useContext(SearchContext), toggleSearch = _b.toggle, isSearchOpen = _b.isOpen;
    var handleClick = function (event) {
        if (isSearchOpen)
            toggleSearch();
        onClick &&
            onClick(event);
    };
    return (React__namespace.default.createElement(Button, { tabIndex: 0, onPress: handleClick, className: classNames__default.default(css$e.hamburgerButton, 'focus-otto-icon') },
        React__namespace.default.createElement(OttoIcon, { icon: ottoIcons[open ? 'IconCrossMedium' : 'IconMenuMedium'], label: open ? menuLabel : menuCloseLabel })));
};

var css$d = {"btnSearch":"styles_btnSearch__99i4S"};

var SearchButton = function (_a) {
    var searchLabel = _a.searchLabel;
    var toggleSearch = React.useContext(SearchContext).toggle;
    var _b = React.useContext(HeaderContext), isMobileNavOpen = _b.isMobileNavOpen, toggleMobileNav = _b.toggleMobileNav;
    var ottoIcons = useOttoIcons().ottoIcons;
    var handleClick = function () {
        if (isMobileNavOpen)
            toggleMobileNav();
        toggleSearch();
    };
    return (React__namespace.default.createElement(OtherTagButton, { tag: "div", "aria-label": searchLabel, className: classNames__default.default(css$d.btnSearch, 'focus-otto-icon'), onPress: handleClick, tabIndex: 0 }, isOttoIconData(ottoIcons['IconSearchMedium']) ? (React__namespace.default.createElement(OttoIcon, { icon: ottoIcons['IconSearchMedium'] })) : (React__namespace.default.createElement(Svg, { className: css$d.iconSearch, name: 'Search' }))));
};

var css$c = {"hiddenDesktop":"styles_hiddenDesktop__2M2EL","hiddenMobile":"styles_hiddenMobile__fH4-c","header":"styles_header__B8BTD","unsetShadow":"styles_unsetShadow__Gl2Qj","container":"styles_container__nthPf","mobileOnly":"styles_mobileOnly__E63KE","btnContainer":"styles_btnContainer__q7YGn","iconSearch":"styles_iconSearch__oxolS","mediumUp":"styles_mediumUp__sOqe9","navigation":"styles_navigation__t8yqy"};

var Header = function (_a) {
    var logo = _a.logo, logoLink = _a.logoLink, title = _a.title, ctaItems = _a.ctaItems, headerNavigation = _a.headerNavigation, articleNavigation = _a.articleNavigation, _b = _a.initialActiveStory, initialActiveStory = _b === void 0 ? '' : _b, hideSearchDesktop = _a.hideSearchDesktop, _c = _a.searchLabel, searchLabel = _c === void 0 ? 'open article search' : _c, _d = _a.menuLabel, menuLabel = _d === void 0 ? 'open navigation menu' : _d, _e = _a.menuCloseLabel, menuCloseLabel = _e === void 0 ? 'close navigation menu' : _e, rest = __rest(_a, ["logo", "logoLink", "title", "ctaItems", "headerNavigation", "articleNavigation", "initialActiveStory", "hideSearchDesktop", "searchLabel", "menuLabel", "menuCloseLabel"]);
    var _f = React.useContext(HeaderContext), isMobileNavOpen = _f.isMobileNavOpen, toggleMobileNav = _f.toggleMobileNav;
    var headingRef = React.useRef(null);
    reactUse.useIsomorphicLayoutEffect(function () {
        var observer;
        if (typeof window.ResizeObserver === 'function') {
            observer = new ResizeObserver(function (_a) {
                var elem = _a[0];
                var height = elem === null || elem === void 0 ? void 0 : elem.contentRect.height;
                if (height) {
                    document.documentElement.style.setProperty('--header-height', "".concat(height, "px"));
                }
            });
            if (headingRef.current) {
                observer.observe(headingRef.current);
            }
        }
        return function () {
            if (observer) {
                observer.disconnect();
            }
        };
    }, [headingRef.current]);
    return (React__namespace.default.createElement(React__namespace.default.Fragment, null,
        React__namespace.default.createElement("header", __assign({ ref: headingRef, className: classNames__default.default(css$c.header, 'w-full', isMobileNavOpen ? css$c.unsetShadow : '') }, react.storyblokEditable(rest)),
            React__namespace.default.createElement("div", { className: css$c.container },
                React__namespace.default.createElement("div", { className: css$c.mobileOnly },
                    React__namespace.default.createElement(Brand, { logo: logo, logoLink: logoLink, title: title }),
                    React__namespace.default.createElement("div", { className: css$c.btnContainer },
                        React__namespace.default.createElement(SearchButton, { searchLabel: searchLabel }),
                        React__namespace.default.createElement(Hamburger, { open: isMobileNavOpen, onClick: toggleMobileNav, menuLabel: menuLabel, menuCloseLabel: menuCloseLabel }))),
                React__namespace.default.createElement("div", { className: css$c.mediumUp },
                    React__namespace.default.createElement(Brand, { logo: logo, logoLink: logoLink, title: title }),
                    React__namespace.default.createElement("nav", { "aria-label": "header desktop", className: css$c.navigation },
                        !hideSearchDesktop && React__namespace.default.createElement(SearchButton, { searchLabel: searchLabel }),
                        headerNavigation && (React__namespace.default.createElement(DesktopNav, { headerNavigation: headerNavigation, articleNavigation: articleNavigation, initialActiveStory: initialActiveStory })),
                        ctaItems && React__namespace.default.createElement(CtaGroup, { ctaItems: ctaItems }))))),
        React__namespace.default.createElement(MobileNav, { isOpen: isMobileNavOpen, ctaItems: ctaItems, articleNavigation: articleNavigation, headerNavigation: headerNavigation, initialActiveStory: initialActiveStory })));
};

var css$b = {"headingNavigation":"styles_headingNavigation__ZXyjk"};

var HeadingNavigationItem = function (_a) {
    var id = _a.id, text = _a.text, isActive = _a.isActive;
    return (React__namespace.default.createElement("li", { className: classNames__default.default({ active: isActive }) },
        React__namespace.default.createElement("a", { "aria-current": isActive, href: "#".concat(id) }, text)));
};
var HeadingNavigation = function (_a) {
    var title = _a.title;
    var id = 'heading-navigation';
    var headings = React.useContext(HeadingsContext).headings;
    return headings.length > 0 ? (React__namespace.default.createElement("div", { role: "navigation", "aria-label": "heading", id: id, className: classNames__default.default(id, css$b.headingNavigation) },
        title && React__namespace.default.createElement("h2", { className: "headline-7" }, title),
        React__namespace.default.createElement("ul", null, headings.map(function (heading) { return (React__namespace.default.createElement(HeadingNavigationItem, { key: heading.id, text: heading.text, id: heading.id, isActive: heading.isActive })); })))) : null;
};

var css$a = {"heroImage":"styles_heroImage__ZyA-k"};

var placeholderImageSrc = '//a.storyblok.com/f/68896/1920x1280/71670cf36c/placeholder-image.jpg';
var placeholderAsset = {
    _uid: 'fed501a4-43e6-4bae-a839-4211ae17d5c3',
    type: 'fluid',
    image: '',
    src: '',
    base64: '',
    plugin: 'iz-advanced-image',
    alt_tag: 'contact us',
    caption: '',
    quality: 100,
    maxWidth: '',
    fillColor: ''
};
var HeroImage = function (_a) {
    var asset = _a.asset, rest = __rest(_a, ["asset"]);
    return (React__namespace.default.createElement("div", __assign({ className: css$a.heroImage }, react.storyblokEditable(rest)), !asset || asset.image === '' ? (React__namespace.default.createElement(Img, __assign({}, placeholderAsset, { src: placeholderImageSrc }))) : (React__namespace.default.createElement(Img, __assign({}, asset, { src: asset.image })))));
};

var css$9 = {"jumbo":"styles_jumbo__qDITb","jumbo-media-right":"styles_jumbo-media-right__GX8UX","mediaContainer":"styles_mediaContainer__Yawpa","mediaContainer-media-right":"styles_mediaContainer-media-right__1rLtY"};

var Jumbo = function (_a) {
    var _b, _c;
    var title = _a.title, body = _a.body, image = _a.image, vimeo = _a.vimeo, youtube = _a.youtube, cta = _a.cta, layout = _a.layout, variant = _a.variant, titleLevel = _a.titleLevel, rest = __rest(_a, ["title", "body", "image", "vimeo", "youtube", "cta", "layout", "variant", "titleLevel"]);
    var mediaRight = 'media-right';
    var Media = function () {
        if (vimeo && vimeo.vimeo_oembed) {
            return (React__namespace.default.createElement(LazyloadIframeVimeo, { vimeoOembed: vimeo.vimeo_oembed, title: title, width: 650 }));
        }
        else if (youtube) {
            return (React__namespace.default.createElement(LazyloadIframeYoutube, { youtubeId: youtube, title: title, width: 650 }));
        }
        else if (image && image.image) {
            return React__namespace.default.createElement(AdvanceImage, { src: image.image });
        }
    };
    return (React__namespace.default.createElement(SectionLayout, __assign({}, layout[0], react.storyblokEditable(rest)),
        React__namespace.default.createElement("div", { className: classNames__default.default(css$9.jumbo, (_b = {},
                _b[css$9["jumbo-".concat(mediaRight)]] = variant === mediaRight,
                _b)) },
            React__namespace.default.createElement("div", { className: classNames__default.default(css$9.mediaContainer, (_c = {},
                    _c[css$9["mediaContainer-".concat(mediaRight)]] = variant === mediaRight,
                    _c)) }, Media()),
            React__namespace.default.createElement("div", { className: "section-text-align" },
                titleLevel === 'H1' ? (React__namespace.default.createElement("h1", { className: "headline-small" }, title)) : (React__namespace.default.createElement("h2", { className: "headline-small" }, title)),
                body && React__namespace.default.createElement(Html, { html: body.content }),
                cta.length > 0 && React__namespace.default.createElement(LinkStyled, __assign({}, cta[0]))))));
};

var css$8 = {"title":"styles_title__i9nBe","largeLinkCollection":"styles_largeLinkCollection__2bO6l"};

var LargeLinkCollection = function (_a) {
    var title = _a.title, layout = _a.layout, collection = _a.collection, rest = __rest(_a, ["title", "layout", "collection"]);
    return (React__namespace.default.createElement(SectionLayout, __assign({}, layout[0], react.storyblokEditable(rest), { gridProfile: "" }),
        title && (React__namespace.default.createElement("h2", { className: classNames__default.default(css$8.title, 'headline-3', 'section-text-align') }, title)),
        React__namespace.default.createElement("div", { className: classNames__default.default(css$8.largeLinkCollection) }, collection.map(function (_a) {
            var _uid = _a._uid; _a.className; var rest = __rest(_a, ["_uid", "className"]);
            return (React__namespace.default.createElement(LinkStyled, __assign({ type: "large", key: _uid, _uid: _uid }, rest, { icon: "ArrowRightOtto", className: "text-body" })));
        }))));
};

var css$7 = {"pillGroup":"styles_pillGroup__iTPo6"};

var css$6 = {"pill":"styles_pill__3Rewr"};

var Pill = function (_a) {
    var url = _a.url, text = _a.text, props = __rest(_a, ["url", "text"]);
    return (React__namespace.default.createElement(Link, __assign({ className: classNames__default.default('colored-text', 'color-action-inline', 'bg-default', css$6.pill) }, props, { url: url }), text !== '' ? text : 'UNTITLED'));
};

var PillGroup = function (_a) {
    var pills = _a.pills, layout = _a.layout, trackingId = _a.trackingId;
    return (React__namespace.default.createElement(SectionLayout, __assign({}, layout[0]),
        React__namespace.default.createElement("div", { className: css$7.pillGroup }, pills.map(function (pillProps) { return (React__namespace.default.createElement(Pill, __assign({ key: pillProps._uid }, pillProps, { trackingId: trackingId }))); }))));
};

var Promo = function (_a) {
    var title = _a.title, cta = _a.cta, layout = _a.layout, content = _a.content, rest = __rest(_a, ["title", "cta", "layout", "content"]);
    var ottoIcons = useOttoIcons().ottoIcons;
    var html = content ? renderStoryblokRichText(content, { ottoIcons: ottoIcons }) : null;
    return (React__namespace.default.createElement(SectionLayout, __assign({}, layout[0], react.storyblokEditable(rest)),
        React__namespace.default.createElement("div", { className: "section-text-align" },
            React__namespace.default.createElement("h2", { className: "headline-4" }, title),
            html && React__namespace.default.createElement(Html, { html: html }),
            cta.length > 0 && (React__namespace.default.createElement("div", { className: "pt-normal" },
                React__namespace.default.createElement(LinkStyled, __assign({}, cta[0])))))));
};

var css$5 = {"searchInput":"styles_searchInput__4Vgvy","title":"styles_title__DYV6Y","iconLink":"styles_iconLink__IjRs1"};

var SearchHero = function (_a) {
    var title = _a.title, placeholder = _a.placeholder, layout = _a.layout, rest = __rest(_a, ["title", "placeholder", "layout"]);
    var toggle = React.useContext(SearchContext).toggle;
    return (React__namespace.default.createElement(SectionLayout, __assign({}, layout[0], react.storyblokEditable(rest)),
        React__namespace.default.createElement("h1", { className: classNames__default.default('headline-1 section-text-align mb-5', css$5.title) }, title),
        React__namespace.default.createElement("button", { className: classNames__default.default('w-narrow', css$5.searchInput), onClick: toggle },
            placeholder,
            React__namespace.default.createElement(Svg, { className: css$5.iconLink, name: 'Search' }))));
};

var HelpCenterComponents$1 = buildComponentsObject(__assign(__assign({}, sharedComponents), { ArticleFeedback: ArticleFeedback, Footer: Footer, HeadingNavigation: HeadingNavigation, HeroImage: HeroImage, LargeLinkCollection: LargeLinkCollection, ListCircle: ListCircle, NavigationTree: NavigationTree, PillGroup: PillGroup, Promo: Promo, SearchHero: SearchHero }));
var Global = function (_a) {
    var _b = _a.global, global = _b === void 0 ? [] : _b;
    if (global.length === 0) {
        return React__namespace.default.createElement("div", null);
    }
    return global.map(function (content) {
        return React__namespace.default.createElement(HelpCenterComponents$1[content.component], __assign({ key: content._uid }, content));
    });
};

var GlobalReference = function (_a) {
    var reference = _a.reference;
    if (typeof reference === 'string') {
        if (reference !== '') {
            return React__namespace.default.createElement("div", null, "You need to save to load in the reference");
        }
        return React__namespace.default.createElement("div", null);
    }
    return React__namespace.default.createElement(Global, __assign({}, reference.content));
};

var Components$2 = buildComponentsObject({
    CalloutBlock: CalloutBlock,
    CardWithVideo: CardWithVideo,
    GlobalReference: GlobalReference,
    ImageStatic: ImageStatic,
    LinkStyled: LinkStyled,
    ListCircle: ListCircle,
    TableStandard: TableStandard,
    Tip: Tip
});

var RichtextContent = React.memo(function (_a) {
    var body = _a.body, rest = __rest(_a, ["body"]);
    var ottoIcons = useOttoIcons().ottoIcons;
    var content = renderStoryblokRichText(body, { Components: Components$2, ottoIcons: ottoIcons });
    var html = content
        ? updateHtml(content, __assign(__assign({}, setLinkStyle('color-action-inline text-underline--hover text-underline--focus')), wrapTables('table-responsive')))
        : null;
    return html ? (React__namespace.default.createElement("div", __assign({ className: "rich-text help-center-article" }, react.storyblokEditable(rest)), content && React__namespace.default.createElement(Html, { html: html }))) : (React__namespace.default.createElement("div", __assign({}, react.storyblokEditable(rest))));
});

var pushToDataLayer = function (query, url, event) {
    if (typeof window !== 'undefined') {
        var data = {
            event: event,
            query: query,
            url: url
        };
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(data);
    }
};

var css$4 = {"searchResultItem":"styles_searchResultItem__khAjE","category":"styles_category__K83Fy"};

var SearchResultItemComponent = function (_a) {
    var _b;
    var hit = _a.hit, query = _a.query;
    var highlightContent = hit.highlight.content ? hit.highlight.content[0] : '';
    var setQuery = React.useContext(SearchContext).setQuery;
    var data = {};
    (_b = hit._source.keywords) === null || _b === void 0 ? void 0 : _b.split('$$').forEach(function (str) {
        try {
            data = JSON.parse(str);
        }
        catch (_a) { } // eslint-disable-line no-empty
    });
    var url = {
        id: 'xxxx',
        url: '',
        _uid: '',
        linktype: 'story',
        fieldtype: 'multilink',
        cached_url: "".concat(hit._source.url.replace(/https:\/\/www.[i]?zettle.com/, ''))
    };
    var handleClick = function () {
        setQuery('');
        pushToDataLayer(query, hit._source.url, 'hc.searchClick');
    };
    return (React__namespace.default.createElement("div", { key: hit._id, className: css$4.searchResultItem },
        data.category && (React__namespace.default.createElement("p", { className: css$4.category, "aria-hidden": true }, data.category)),
        React__namespace.default.createElement("span", null,
            React__namespace.default.createElement(Link, { url: url, rel: "noopener noreferrer", "aria-describedby": 'highlight' + hit._id, onClick: handleClick, onKeyUp: function (e) { return e.key === 'Enter' && handleClick(); }, className: classNames__default.default('color-action-inline', 'text-underline--hover', 'text-underline--focus') }, hit._source.h1 || hit._source.title)),
        React__namespace.default.createElement("p", { className: "highlight", id: 'highlight' + hit._id, "aria-hidden": true },
            React__namespace.default.createElement(Html, { html: highlightContent })),
        React__namespace.default.createElement("hr", { "aria-hidden": true })));
};
var SearchResultItem = React.memo(SearchResultItemComponent);

var loadMoreLimit = 10;
var minQueryLength = 3;

var css$3 = {"searchResultContainer":"styles_searchResultContainer__tVG6z","noResults":"styles_noResults__yZLoh","searchResultLoadMore":"styles_searchResultLoadMore__v1ae1","gotoLatest":"styles_gotoLatest__KBNXu","resultCount":"styles_resultCount__E4h6H"};

var SearchResultComponent = function (_a) {
    var searchResults = _a.searchResults, loadMore = _a.loadMore, hideResults = _a.hideResults, noResultText = _a.noResultText, resultCountSuffix = _a.resultCountSuffix;
    var hits = searchResults.hits, total = searchResults.total;
    var hasMoreHits = total > hits.length;
    var handleLoadMore = function () { return loadMore(hits.length); };
    if (searchResults.query.length < minQueryLength || hideResults) {
        return null;
    }
    if (hits.length === 0) {
        return React__namespace.default.createElement("div", { className: css$3.noResults }, noResultText);
    }
    var ariaLive = hits.length ? 'polite' : 'off';
    return (React__namespace.default.createElement(React__namespace.default.Fragment, null,
        resultCountSuffix && (React__namespace.default.createElement("div", { className: css$3.resultCount },
            React__namespace.default.createElement("span", { "aria-live": ariaLive }, "".concat(total, " ").concat(resultCountSuffix, " ")),
            React__namespace.default.createElement("i", null, "\"".concat(searchResults.query, "\"")))),
        React__namespace.default.createElement("div", { className: css$3.searchResultContainer },
            hits.map(function (hit, index) { return (React__namespace.default.createElement(React__namespace.default.Fragment, null,
                React__namespace.default.createElement(SearchResultItem, { key: hit._id, hit: hit, query: searchResults.query }),
                (index + 1) % loadMoreLimit === 0 && (React__namespace.default.createElement("div", { id: "result-section-".concat((index + 1) / loadMoreLimit), key: "result-section".concat(hit._id) })))); }),
            hasMoreHits && (React__namespace.default.createElement("div", { className: css$3.searchResultLoadMore },
                React__namespace.default.createElement(Button, { className: classNames__default.default('color-action-inline', 'text-underline--hover', 'text-underline--focus', 'bg-transparent'), "aria-controls": "result-section-".concat(hits.length / loadMoreLimit), onPress: handleLoadMore }, "Load more"),
                React__namespace.default.createElement(Button, { className: classNames__default.default('color-action-inline', 'bg-transparent', 'text-underline--hover', 'text-underline--focus', css$3.gotoLatest), tabIndex: 0, onPress: function () {
                        var lastResults = document.getElementById("result-section-".concat(hits.length / loadMoreLimit - 1));
                        lastResults === null || lastResults === void 0 ? void 0 : lastResults.setAttribute('tabindex', '0');
                        lastResults === null || lastResults === void 0 ? void 0 : lastResults.focus();
                    } }, "Go to latest loaded results"))))));
};
var SearchResult = React.memo(SearchResultComponent);

var css$2 = {"searchInputContainer":"styles_searchInputContainer__adlhh","searchInput":"styles_searchInput__0Rq1j","minusMargin":"styles_minusMargin__0U-xK"};

var Components$1 = buildComponentsObject({ PillGroup: PillGroup });
var SearchComponent = function (_a, forwardedRef) {
    var searchService = _a.searchService, texts = _a.texts, body = _a.body, _b = _a.isOverlaying, isOverlaying = _b === void 0 ? false : _b;
    var containerRef = React.useRef(null);
    var _c = React.useState(0), offset = _c[0], setOffset = _c[1];
    var _d = React.useState(null), error = _d[0], setError = _d[1];
    var _e = React.useState(false), hideResults = _e[0], setHideResults = _e[1];
    var _f = React.useState(searchService.getInitialState), searchResults = _f[0], setSearchResults = _f[1];
    var _g = React.useContext(SearchContext), setQuery = _g.setQuery, query = _g.query;
    var handleSearch = function (e) {
        setQuery(e.target.value);
        setOffset(0);
        setHideResults(false);
    };
    var handleLoadMore = function (offset) { return setOffset(offset); };
    var handleResponse = function (response) {
        if (searchService.isError(response)) {
            return setError(response);
        }
        if (offset === 0) {
            setSearchResults(__assign(__assign({}, response), { query: query }));
        }
        else {
            setSearchResults(__assign(__assign({}, response), { hits: searchResults.hits.concat(response.hits), query: query }));
        }
        setError(null);
    };
    var handleKeydown = function (e) {
        if (e.key === 'Escape') {
            setHideResults(true);
        }
    };
    React.useEffect(function () {
        var subscription = searchService.getResults().subscribe(handleResponse);
        searchService.search({ query: query, offset: offset });
        return function () { return subscription.unsubscribe(); };
    }, [query, offset]);
    useClickOutside(containerRef || {}, function () { return !isOverlaying && setHideResults(true); });
    return (React__namespace.default.createElement("div", { ref: isOverlaying ? forwardedRef : containerRef, className: css$2.searchInputContainer },
        React__namespace.default.createElement("div", { className: css$2.searchInput },
            React__namespace.default.createElement("input", { type: "text", onChange: handleSearch, onKeyDown: handleKeydown, placeholder: texts.placeholderText }),
            React__namespace.default.createElement(Svg, { name: "Search", ariaHidden: true })),
        error ? (React__namespace.default.createElement("div", null, texts.errorText)) : (React__namespace.default.createElement(React__namespace.default.Fragment, null,
            React__namespace.default.createElement(SearchResult, { searchResults: searchResults, loadMore: handleLoadMore, hideResults: hideResults, noResultText: texts.noResultsText, resultCountSuffix: texts.resultCountSuffix }),
            body && searchResults.hits.length === 0 && (React__namespace.default.createElement("div", { className: css$2.minusMargin }, body.map(function (block) {
                return React__namespace.default.createElement(Components$1[block.component], __assign({ key: block._uid }, block));
            })))))));
};
var Search = React.memo(React.forwardRef(SearchComponent));

var queryIsMoreThanOneWord = function (query) {
    return query.trim().indexOf(' ') != -1;
};
var createQueryFactory = function (_a) {
    var locale = _a.locale;
    return function (_a) {
        var query = _a.query, _b = _a.limit, limit = _b === void 0 ? loadMoreLimit : _b, _c = _a.offset, offset = _c === void 0 ? 0 : _c;
        var type = queryIsMoreThanOneWord(query)
            ? 'cross_fields'
            : 'phrase_prefix';
        return {
            query: {
                bool: {
                    must: {
                        multi_match: {
                            query: "".concat(query, "*"),
                            fields: [
                                'title^4',
                                'h1^3',
                                'h2^2',
                                'h3^1',
                                'content',
                                'description',
                                'keywords'
                            ],
                            type: type
                        }
                    },
                    filter: {
                        prefix: {
                            url: "https://www.zettle.com/".concat(locale, "/help/articles/")
                        }
                    }
                }
            },
            size: limit,
            from: offset,
            highlight: {
                pre_tags: ['<mark>'],
                post_tags: ['</mark>'],
                fields: { '*': {} },
                require_field_match: false
            }
        };
    };
};
var createSearchService = function (_a) {
    var url = _a.url, locale = _a.locale;
    var query$ = new rxjs.Subject();
    var createQuery = createQueryFactory({ locale: locale });
    var searchStoryblok = function (searchOptions) {
        return ajax.ajax({
            url: url,
            method: 'POST',
            crossDomain: true,
            headers: {
                'Content-Type': 'application/json'
            },
            body: createQuery(searchOptions)
        }).pipe(operators.map(function (ajaxResponse) { return ajaxResponse.response.hits; }), operators.catchError(function (ajaxError) {
            return rxjs.of(ajaxError.response);
        }));
    };
    return {
        search: function (searchOptions) { return query$.next(searchOptions); },
        getResults: function () {
            return query$.pipe(operators.filter(function (_a) {
                var query = _a.query;
                return query.length >= minQueryLength;
            }), operators.debounceTime(250), operators.distinctUntilChanged(isEqual__default.default), operators.switchMap(searchStoryblok));
        },
        getInitialState: function () { return ({ total: 0, max_score: 0, hits: [], query: '' }); },
        isError: function (obj) { return !!obj.error; }
    };
};

var css$1 = {"searchContainer":"styles_searchContainer__Qcma-","overlay":"styles_overlay__QF0rB","modal":"styles_modal__XvcSV","closeContainer":"styles_closeContainer__gJvrQ","close":"styles_close__40N7w","closeText":"styles_closeText__Uzcl0"};

var SearchOverlay = function (_a) {
    var rootNode = _a.rootNode, _b = _a.content, body = _b.body, language = _b.language, noResultsText = _b.noResultsText, placeholderText = _b.placeholderText, errorText = _b.errorText, resultCountSuffix = _b.resultCountSuffix, closeText = _b.closeText;
    var searchService = createSearchService({
        url: 'https://sapi.searchblok.com/v1/9d73b8c5d3/_search',
        locale: language
    });
    var searchRef = React.useRef(null);
    var _c = React__namespace.default.useContext(SearchContext), closeSearch = _c.close, isOpen = _c.isOpen;
    var setFocus = function () {
        var _a, _b, _c, _d;
        (_d = (_b = (_a = searchRef.current) === null || _a === void 0 ? void 0 : _a.getElementsByTagName('input')) === null || _b === void 0 ? void 0 : (_c = _b[0]).focus) === null || _d === void 0 ? void 0 : _d.call(_c);
    };
    var _d = React.useContext(SearchContext), setQuery = _d.setQuery, query = _d.query;
    var handleBeforeUnload = function () {
        if (searchRef.current) {
            pushToDataLayer(query, 'on page leave', 'hc.searchLeave');
        }
    };
    React.useEffect(function () {
        Modal__default.default.setAppElement(rootNode);
        window.addEventListener('beforeunload', handleBeforeUnload);
        return function () {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);
    var onClose = function () {
        setQuery('');
        pushToDataLayer(query, 'on close', 'hc.searchLeave');
        closeSearch();
    };
    /*eslint-disable jsx-a11y/click-events-have-key-events */
    return (React__namespace.default.createElement(Modal__default.default, { isOpen: isOpen, onRequestClose: onClose, onAfterOpen: setFocus, className: css$1.modal, overlayClassName: css$1.overlay },
        React__namespace.default.createElement("div", { className: css$1.closeContainer },
            React__namespace.default.createElement(OtherTagButton, { tag: "div", className: css$1.close, onPress: onClose, tabIndex: 0 },
                React__namespace.default.createElement("span", { className: css$1.closeText }, closeText),
                React__namespace.default.createElement(Svg, { name: 'Cross' }))),
        React__namespace.default.createElement("div", { className: classNames__default.default(css$1.searchContainer, 'w-narrow') },
            React__namespace.default.createElement(Search, { ref: searchRef, isOverlaying: true, searchService: searchService, texts: {
                    noResultsText: noResultsText,
                    placeholderText: placeholderText,
                    errorText: errorText,
                    resultCountSuffix: resultCountSuffix
                }, body: body }))));
};

var getCss = function (izAdvancedImage, className) {
    var imgProps = getBasicImageProps(izAdvancedImage.image);
    var mediaQueries = imageScales
        .slice(0)
        .reverse()
        .filter(function (breakpoint) { return breakpoint <= imgProps.dimensions.width; })
        .map(function (breakpoint) {
        return "@media (max-width: ".concat(breakpoint, "px) {\n      .").concat(className, " {\n        background-image: url(\"").concat(convertUrl(izAdvancedImage.image, {
            width: breakpoint,
            height: 0
        }), "\");\n      }\n    }");
    })
        .join('\n');
    return ".".concat(className, " {\n      background-image: url(\"").concat(izAdvancedImage.image, "\");\n    }\n    ").concat(mediaQueries);
};

var css = {"sectionContainer":"styles_sectionContainer__04lo9"};

var Components = buildComponentsObject({
    SearchHero: SearchHero,
    GlobalReference: GlobalReference,
    PillGroup: PillGroup,
    CardGroup: CardGroup
});
var SectionContainer = function (_a) {
    var sections = _a.sections, backgroundImage = _a.backgroundImage, rest = __rest(_a, ["sections", "backgroundImage"]);
    var className = slugify(backgroundImage.image || '');
    return (React__namespace.default.createElement("div", __assign({ className: classNames__default.default(css.sectionContainer, className), style: { backgroundColor: backgroundImage.fillColor || undefined } }, react.storyblokEditable(rest)),
        className && (React__namespace.default.createElement("style", { dangerouslySetInnerHTML: {
                __html: getCss(backgroundImage, className)
            } })),
        sections &&
            sections.map(function (section) {
                return React__namespace.default.createElement(Components[section.component], __assign({ key: section._uid }, section));
            })));
};

var DEFAULT_CONFIGURATION_V2 = {
    companyId: process.env.NEXT_PUBLIC_UJET_COMPANY_ID || '',
    host: 'https://izettle.api.ujet.co',
    logo: 'https://cdn.izettle.com/ujet-icons/ujet-zettle-logo-blue.png',
    right: '20px',
    bottom: '20px',
    launcher: {
        right: '20px',
        bottom: '20px',
        cssText: 'img#chat, .close img#chat, .open img#minimize {transform: scale(0.66667);}',
        chatIcon: 'https://cdn.izettle.com/ujet-icons/ujet-chat-start-blue-500.svg',
        style: {
            '--background-color': 'white',
            '--count-color': '#e55430' // salmon-60
        }
    },
    style: {
        '--primary-color': '#273664',
        '--primary-font': 'PayPalOpen, sans-serif'
    }
};
// locale code: 1) es-ES 2) es-MX
// language code: 1) es 2) es-MX
var localeToLanguage = function (isoLocale) {
    // return these language codes as is
    var exceptions = ['es-MX', 'pt-BR'];
    if (exceptions.includes(isoLocale)) {
        return isoLocale;
    }
    var matches = isoLocale.match(/^([a-z]{2}){1}(-[a-z]{2})?$/i);
    // e.g. return da for da-DK
    if (matches) {
        return matches[1];
    }
    return 'en';
};
var UJET_URL = 'https://websdk.ujetqa.co/v2/loader.js';
var UJET_AUTH_URL = process.env.NEXT_PUBLIC_UJET_AUTH_URL || '';
var initializeUjet = function (_a) {
    var locale = _a.locale, callbackOnSuccess = _a.callbackOnSuccess;
    var headerScript = document.createElement('script');
    headerScript.src = UJET_URL;
    headerScript.async = true;
    headerScript.onload = function () { return __awaiter(void 0, void 0, void 0, function () {
        var ujetInstance, launcher, loader_1;
        return __generator(this, function (_a) {
            try {
                ujetInstance = (window.ujetInstance = new UJET(__assign(__assign({}, DEFAULT_CONFIGURATION_V2), { authenticate: function getAuthToken() {
                        return fetch(UJET_AUTH_URL, {
                            headers: { 'Content-Type': 'application/json' },
                            method: 'POST'
                        })
                            .then(function (resp) { return resp.json(); })
                            .catch(function (error) { return console.log('UJET Auth error:', error); });
                    }, lang: localeToLanguage(locale) })));
                callbackOnSuccess(ujetInstance);
                launcher = document.getElementById('ujet-launcher');
                loader_1 = document.createElement('img');
                loader_1.alt = 'loading';
                loader_1.src =
                    'https://cdn.izettle.com/ujet-icons/ujet-loading-icon-blue-500.svg';
                loader_1.style.opacity = '0';
                loader_1.style.position = 'absolute';
                loader_1.style.pointerEvents = 'none';
                loader_1.style.top = '0';
                loader_1.style.padding = '25%';
                launcher === null || launcher === void 0 ? void 0 : launcher.appendChild(loader_1);
                ujetInstance.registerHook('loading', function () { return (loader_1.style.opacity = '1'); });
                ujetInstance.registerHook('open', function () { return (loader_1.style.opacity = '0'); });
                ujetInstance.registerHook('close', function () { return (loader_1.style.opacity = '0'); });
            }
            catch (err) {
                console.log(err);
            }
            return [2 /*return*/];
        });
    }); };
    var iconStyleOverride = document.createElement('style');
    iconStyleOverride.innerHTML = "\n    #ujet-launcher {\n      z-index: 100 !important;\n    }\n  ";
    document.querySelector('head').appendChild(iconStyleOverride);
    document.querySelector('head').appendChild(headerScript);
};

var Ujet = function (_a) {
    var autoExpand = _a.autoExpand, directAccessPoint = _a.directAccessPoint, locale = _a.locale;
    var _b = React.useState(), instance = _b[0], setInstance = _b[1];
    var options = directAccessPoint ? { menuKey: directAccessPoint } : undefined;
    React.useEffect(function () {
        var oldInstance = window.ujetInstance;
        if (!oldInstance) {
            initializeUjet({
                locale: locale,
                callbackOnSuccess: setInstance
            });
        }
        else {
            setInstance(oldInstance);
        }
    }, [locale]);
    React.useEffect(function () {
        if (instance && autoExpand) {
            if (instance.ready)
                instance.open();
            else
                instance.start(options);
        }
        return function () {
            var _a;
            window.ujetInstance = undefined;
            (_a = instance === null || instance === void 0 ? void 0 : instance.destroy) === null || _a === void 0 ? void 0 : _a.call(instance);
        };
    }, [instance, autoExpand, directAccessPoint]);
    return null;
};

var processH2s = function (rootElement, selector, callback) {
    var headingIdMap = new Map();
    if (rootElement.current == null) {
        return headingIdMap;
    }
    var articleH2s = Array.from(rootElement.current.querySelectorAll(selector));
    for (var _i = 0, articleH2s_1 = articleH2s; _i < articleH2s_1.length; _i++) {
        var h2 = articleH2s_1[_i];
        var existingId = h2.id, textContent = h2.textContent;
        var text = textContent === null || textContent === void 0 ? void 0 : textContent.trim().replace(/#$/, '').replace(/[\u00A0\u202F]/g, '\x20');
        if (!text) {
            continue;
        }
        var id = existingId ? existingId : slugify(text);
        var count = 0;
        while (headingIdMap.has(id)) {
            id = "".concat(id).concat(++count);
        }
        headingIdMap.set(id, { text: text, element: h2 });
        try {
            callback(id, h2);
        }
        catch (e) {
            console.error(e);
        }
    }
    return headingIdMap;
};
var setIdAndAddAnchorLinkToH2 = function (addHeadingKnob) { return function (id, h2) {
    var existingId = h2.id;
    if (existingId !== id) {
        h2.setAttribute('id', id);
    }
    if (addHeadingKnob && h2.lastElementChild == null) {
        var anchorKnob = document.createElement('a');
        anchorKnob.setAttribute('aria-hidden', 'true');
        anchorKnob.classList.add('anchor-knob');
        anchorKnob.href = "#".concat(id);
        h2.appendChild(anchorKnob);
    }
}; };
var trackActiveHeading = function (headings, setActiveHeading) {
    var keys = Array.from(headings.keys());
    if (typeof IntersectionObserver === 'function') {
        var observer_1 = new IntersectionObserver(function (entries) {
            var firstVisibleHeadingId = entries
                .filter(function (entry) { return entry.isIntersecting; })
                .map(function (entry) { return entry.target.id; })
                .sort(function (a, b) { return keys.indexOf(a) - keys.indexOf(b); })[0];
            if (firstVisibleHeadingId && keys.indexOf(firstVisibleHeadingId) >= 0) {
                setActiveHeading(firstVisibleHeadingId);
            }
        }, {
            rootMargin: '0px 0px -50% 0px',
            threshold: 1
        });
        Array.from(headings.values()).forEach(function (_a) {
            var element = _a.element;
            return observer_1.observe(element);
        });
        return observer_1;
    }
    else {
        return null;
    }
};
var getActiveIdFromUrl = function () { var _a, _b; return decodeURIComponent((_b = (_a = window.location.hash) === null || _a === void 0 ? void 0 : _a.replace(/^#/, '')) !== null && _b !== void 0 ? _b : ''); };
var useHeadingNavigation = function (_a) {
    var rootElement = _a.rootElement, selector = _a.selector, _b = _a.addHeadingKnob, addHeadingKnob = _b === void 0 ? true : _b;
    var useRouter = React.useContext(SiteComponentContext).hooks.useRouter;
    var route = useRouter();
    var setHeadings = React.useContext(HeadingsContext).setHeadings;
    var populateHeadings = React.useCallback(function () {
        var headingIdMap = processH2s(rootElement, selector, setIdAndAddAnchorLinkToH2(addHeadingKnob));
        setHeadings(Array.from(headingIdMap.entries()).map(function (_a) {
            var id = _a[0], _b = _a[1], text = _b.text, element = _b.element;
            return ({
                id: id,
                text: text,
                element: element.tagName,
                isActive: false
            });
        }));
        return headingIdMap;
    }, [rootElement, selector, addHeadingKnob]);
    var setActiveHeading = React.useCallback(function (activeId) {
        setHeadings(function (headings) {
            return headings.map(function (_a) {
                var id = _a.id, rest = __rest(_a, ["id"]);
                return (__assign(__assign({}, rest), { id: id, isActive: id === activeId }));
            });
        });
    }, [setHeadings]);
    reactUse.useIsomorphicLayoutEffect(function () {
        var headingIdMap = populateHeadings();
        var intersectionObserver = trackActiveHeading(headingIdMap, setActiveHeading);
        return function () {
            if (intersectionObserver) {
                intersectionObserver.disconnect();
            }
        };
    }, [route.asPath, populateHeadings, setActiveHeading]);
    React.useEffect(function () {
        // this effect is because react's child component update order is unpredicatble and the effect above might not always run at the correct time
        var mutationObserver;
        var intersectionObserver;
        if (rootElement.current) {
            mutationObserver = new MutationObserver(function () {
                var headingIdMap = populateHeadings();
                intersectionObserver = trackActiveHeading(headingIdMap, setActiveHeading);
            });
            mutationObserver.observe(rootElement.current, {
                childList: true,
                subtree: true
            });
        }
        return function () {
            if (mutationObserver) {
                mutationObserver.disconnect();
            }
            if (intersectionObserver) {
                intersectionObserver.disconnect();
            }
        };
    }, [rootElement.current, populateHeadings, trackActiveHeading]);
    React.useEffect(function () {
        // this effect is only for the first time the user navigate to the heading section directly from a url with a hash
        var activeIdFromUrl = getActiveIdFromUrl();
        if (activeIdFromUrl) {
            var h2 = document.getElementById(activeIdFromUrl);
            if (h2) {
                h2.scrollIntoView({ behavior: 'auto' });
            }
        }
    }, []);
};

var HelpCenterComponents = buildComponentsObject(__assign(__assign({}, sharedComponents), { ArticleContentLegacy: ArticleContentLegacy, ArticleFeedback: ArticleFeedback, BadgeGroup: BadgeGroup, CardGroup: CardGroup, CardWithVideo: CardWithVideo, CtaLinkSection: CtaLinkSection, ExpandingFaq: ExpandingFaq, Footer: Footer, Header: Header, HeadingNavigation: HeadingNavigation, HeroImage: HeroImage, HtmlContent: HtmlContent, Jumbo: Jumbo, LargeLinkCollection: LargeLinkCollection, PillGroup: PillGroup, Promo: Promo, RichtextContent: RichtextContent, Search: Search, SearchOverlay: SearchOverlay, SectionContainer: SectionContainer, SearchHero: SearchHero, StyledLink: StyledLink, Tip: Tip, Ujet: Ujet, GlobalReference: GlobalReference }));

exports.Accordion = Accordion;
exports.ActiveStoryContext = ActiveStoryContext;
exports.ActiveStoryContextProvider = ActiveStoryContextProvider;
exports.ArticleContentLegacy = ArticleContentLegacy;
exports.ArticleFeedback = ArticleFeedback;
exports.BadgeGroup = BadgeGroup;
exports.CalloutBlock = CalloutBlock;
exports.CardGroup = CardGroup;
exports.CardWithVideo = CardWithVideo;
exports.Col = Col;
exports.ContainerLayout = ContainerLayout;
exports.CtaLinkSection = CtaLinkSection;
exports.ExpandingFaq = ExpandingFaq;
exports.Footer = Footer;
exports.Global = Global;
exports.GlobalReference = GlobalReference;
exports.Header = Header;
exports.HeaderContext = HeaderContext;
exports.HeaderContextProvider = HeaderContextProvider;
exports.HeadingNavigation = HeadingNavigation;
exports.HeadingsContext = HeadingsContext;
exports.HeadingsContextProvider = HeadingsContextProvider;
exports.HelpCenterComponents = HelpCenterComponents;
exports.HeroImage = HeroImage;
exports.HtmlContent = HtmlContent;
exports.Image = Image$1;
exports.ImageSection = ImageSection;
exports.ImageStatic = ImageStatic;
exports.ImgResized = ImgResized;
exports.Jumbo = Jumbo;
exports.LargeLinkCollection = LargeLinkCollection;
exports.List = List;
exports.ListCircle = ListCircle;
exports.NavigationTree = NavigationTree;
exports.OttoIconProvider = OttoIconProvider;
exports.PillGroup = PillGroup;
exports.Promo = Promo;
exports.Provider = Provider;
exports.Richtext = Richtext;
exports.RichtextContent = RichtextContent;
exports.Row = Row;
exports.Search = Search;
exports.SearchContext = SearchContext;
exports.SearchContextProvider = SearchContextProvider;
exports.SearchHero = SearchHero;
exports.SearchOverlay = SearchOverlay;
exports.SectionContainer = SectionContainer;
exports.SectionLayout = SectionLayout;
exports.SectionLayoutLegacy = SectionLayoutLegacy;
exports.SiteComponentContext = SiteComponentContext;
exports.StandardCard = StandardCard;
exports.StandardCardGroup = StandardCardGroup;
exports.StandardModule = StandardModule;
exports.StatusBanner = StatusBanner;
exports.StyledLink = StyledLink;
exports.Svg = Svg;
exports.Table = Table;
exports.TableStandard = TableStandard;
exports.TextGrid = TextGrid;
exports.Tip = Tip;
exports.Ujet = Ujet;
exports.collectIcons = collectIcons;
exports.isOttoIconBlock = isOttoIconBlock;
exports.isOttoIconData = isOttoIconData;
exports.isOttoIconName = isOttoIconName;
exports.loadOttoIcons = loadOttoIcons;
exports.ottoUtils = ottoUtils;
exports.sharedComponents = sharedComponents;
exports.sharedUtils = sharedUtils;
exports.transformAccordionItemPropsToFaqItem = transformAccordionItemPropsToFaqItem;
exports.transformFaqPropsToFaqItem = transformFaqPropsToFaqItem;
exports.typeNames = typeNames;
exports.types = types;
exports.useHeadingNavigation = useHeadingNavigation;
exports.useOttoIcons = useOttoIcons;
